"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7097],{

/***/ 6051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowRight = function SvgArrowRight(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        viewBox: "0 0 8 14"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "m.313 12.045 5.113-5.112L.313 1.821A1.065 1.065 0 1 1 1.82.312L7.687 6.18a1.064 1.064 0 0 1 0 1.508L1.82 13.554a1.065 1.065 0 1 1-1.507-1.508"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight);


/***/ }),

/***/ 96654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowRight2 = function SvgArrowRight2(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        viewBox: "0 0 8 14"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "m.313 12.045 5.113-5.112L.313 1.821A1.065 1.065 0 1 1 1.82.312L7.687 6.18a1.064 1.064 0 0 1 0 1.508L1.82 13.554a1.065 1.065 0 1 1-1.507-1.508"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight2);


/***/ }),

/***/ 48109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useContactSalesTypeform; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_generic_config_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3156);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77784);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_typeform_typeform_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15728);
/* harmony import */ var _constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13979);
/* harmony import */ var client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53989);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65023);







function useContactSalesTypeform(param) {
    var abTests = param.abTests, fallbackLink = param.fallbackLink;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isShowingTypeform = ref[0], setIsShowingTypeform = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(contexts_generic_config_context__WEBPACK_IMPORTED_MODULE_1__/* .GenericConfigContext */ .Z), forcePricing = ref1.forcePricing, useNewTypeformUSVariant = ref1.useNewTypeformUSVariant, cookies = ref1.cookies, forceCurrency = ref1.forceCurrency, cloudfrontViewerCountry = ref1.cloudfrontViewerCountry, isV13PricingVersion = ref1.isV13PricingVersion, testTypeformContactSales = ref1.testTypeformContactSales, forceTypeformContactSalesExperience = ref1.forceTypeformContactSalesExperience, contactSalesTestMode = ref1.contactSalesTestMode;
    var onCallback = function() {
        setIsShowingTypeform(false);
    };
    var displayTypeform = function() {
        var getNewVariantForTest = useNewTypeformUSVariant || (0,services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__.shouldUseNewTypeformVariant)(abTests, true);
        var pricingData = {
            forcePricing: forcePricing,
            cookies: cookies,
            abTests: abTests,
            forceCurrency: forceCurrency,
            countryCode: cloudfrontViewerCountry,
            isV13PricingVersion: isV13PricingVersion
        };
        if ((0,services_typeform_typeform_service__WEBPACK_IMPORTED_MODULE_3__/* .shouldGetTypeformExperience */ .ap)({
            abTests: abTests,
            cloudfrontViewerCountry: cloudfrontViewerCountry,
            testTypeformContactSales: testTypeformContactSales,
            forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
            sendBigBrainEvent: true
        })) {
            try {
                setIsShowingTypeform(true);
                (0,_constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__/* .openContactSalesTypeform */ ._X)({
                    country: cloudfrontViewerCountry,
                    deviceType: _constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__/* .TYPEFORM_DESKTOP_DEVICE_TYPE */ .PM,
                    getNewVariantForTest: getNewVariantForTest,
                    isTest: contactSalesTestMode,
                    pricingData: pricingData,
                    onCloseCallback: onCallback,
                    onSubmitCallback: onCallback,
                    onReadyCallback: onCallback
                });
            } catch (e) {
                var bbEventParams = {
                    name: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_6__.TYPEFORM_UNHANDLED_EXCEPTION
                };
                (0,client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_5__/* .handleClientException */ .N)({
                    e: e,
                    bbEventParams: bbEventParams
                });
                window.location = fallbackLink;
            }
        }
    };
    return {
        isShowingTypeform: isShowingTypeform,
        displayTypeform: displayTypeform
    };
}


/***/ }),

/***/ 833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ badge_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/badge/badge-component.scss.js


var StyledBadgeComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e18e91rw0"
})("padding:1px 8px 2px 7px;border-radius:2px;background-color:", colors/* default.brand-yellow */.Z["brand-yellow"], ";font-size:0.6875rem;color:", colors/* default.black */.Z.black, ";&.has-stroke{padding-top:0px;padding-bottom:1px;}");

;// CONCATENATED MODULE: ./components/core/badge/badge-component.js










var BadgeComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BadgeComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BadgeComponent);
    function BadgeComponent() {
        (0,_class_call_check/* default */.Z)(this, BadgeComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BadgeComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, translate = _props.translate, badgeText = _props.badgeText, badgeColorName = _props.badgeColorName, badgeTextColorName = _props.badgeTextColorName, badgeStrokeColorName = _props.badgeStrokeColorName;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgeComponent, {
                    className: classnames_default()("core-badge-component", {
                        "has-stroke": badgeStrokeColorName
                    }),
                    style: {
                        backgroundColor: colors/* default */.Z[badgeColorName],
                        color: colors/* default */.Z[badgeTextColorName],
                        border: badgeStrokeColorName ? "1px solid ".concat(colors/* default */.Z[badgeStrokeColorName]) : "unset"
                    },
                    children: badgeText || translate("header.menuItem.popular")
                });
            }
        }
    ]);
    return BadgeComponent;
}(react.PureComponent);
/* harmony default export */ var badge_component = ((0,generic_config_context/* withGenericConfig */.P)(BadgeComponent));


/***/ }),

/***/ 77097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ base_header_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.scss.js


var StyledBaseHeaderComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ey2cu0a0"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_MIN_WIDTH */.K0, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/basic-header-component.js + 1 modules
var basic_header_component = __webpack_require__(72491);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-link-item/secondary-link-item-component.scss.js



var borderBottomSize = "1px";
var transparentBorderBottom = "".concat(borderBottomSize, " solid transparent");
var borderBottom = "".concat(borderBottomSize, " solid ").concat(colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME]);
var StyledSecondaryLinkItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1w21yvw0"
})("cursor:pointer;display:flex;align-items:center;padding-top:", borderBottomSize, ";padding-left:16px;padding-right:16px;text-decoration:none;color:", colors/* default.asphalt */.Z.asphalt, ";transition:color 200ms ease;font-weight:300;font-size:0.875rem;line-height:24px;border-bottom:", transparentBorderBottom, ";&.selected{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";border-bottom:", borderBottom, ";}&:hover{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-link-item/secondary-link-item-component.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var SecondaryLinkItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SecondaryLinkItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SecondaryLinkItemComponent);
    function SecondaryLinkItemComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SecondaryLinkItemComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var url = _this.props.url;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", bigbrain_event_types.SECONDARY_HEADER_LINK_CLICKED, {
                kind: url,
                info1: isKeyboardEvent ? "keyboard" : "mouse"
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SecondaryLinkItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, url = _props.url, isSelected = _props.isSelected, translate = _props.translate;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryLinkItemComponent, {
                    href: url,
                    className: classnames_default()("secondary-link-item-component", {
                        selected: isSelected
                    }),
                    onClick: this.onClick,
                    children: translate(title)
                });
            }
        }
    ]);
    return SecondaryLinkItemComponent;
}(react.PureComponent);
/* harmony default export */ var secondary_link_item_component = ((0,generic_config_context/* withGenericConfig */.P)(SecondaryLinkItemComponent));

// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/constants.js
var base_header_constants = __webpack_require__(48802);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-header-desktop/secondary-header-desktop-component.scss.js





var transparentBorder = "1px solid transparent";
var border = "1px solid ".concat(colors/* default.riverstone */.Z.riverstone);
var HEADER_CONTENT_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var UNIFIED_HEADER_LOGO_TRANSITION = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FIRST_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FIRST_TRANSITION_DURATION, "ms ease, transform ").concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FIRST_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FIRST_TRANSITION_DURATION, "ms ease");
var UNIFIED_HEADER_LINKS_TRANSITION = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease, transform ").concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease");
var UNIFIED_HEADER_TRANSITION = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease");
var SECONDARY_HEADER_HEIGHT_WITH_BORDER = "".concat(constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT + 1, "px");
var SECONDARY_HEADER_HEIGHT = "".concat(constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px");
var StyledSecondaryHeaderDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", {
    target: "e1vliikj0"
})("display:flex;justify-content:center;width:100%;border-top:", border, ";border-bottom:", transparentBorder, ";transition:", UNIFIED_HEADER_TRANSITION, ";height:", SECONDARY_HEADER_HEIGHT_WITH_BORDER, ";background-color:", colors/* default.white */.Z.white, ";.secondary-header-desktop-content{height:100%;max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;padding-left:", HEADER_CONTENT_HORIZONTAL_PADDING, ";padding-right:", HEADER_CONTENT_HORIZONTAL_PADDING, ";display:flex;.logo-wrapper{padding-right:16px;transition:", UNIFIED_HEADER_LOGO_TRANSITION, ";.secondary-header-logo-image{height:", SECONDARY_HEADER_HEIGHT, ";}}.links-wrapper{height:100%;display:flex;align-items:center;transition:", UNIFIED_HEADER_LINKS_TRANSITION, ";.secondary-link-item-wrapper{height:100%;display:flex;}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-header-desktop/secondary-header-desktop-component.js






function secondary_header_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}









var SecondaryHeaderDesktopComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SecondaryHeaderDesktopComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SecondaryHeaderDesktopComponent);
    function SecondaryHeaderDesktopComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SecondaryHeaderDesktopComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        secondary_header_desktop_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLogo", function() {
            var _props = _this.props, pageClusterConfig = _props.pageClusterConfig, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
            var logo = (0,cluster_config_service/* getMiniSiteLogo */.o8)(pageClusterConfig, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                className: "secondary-header-logo-image",
                src: logo === null || logo === void 0 ? void 0 : logo.src,
                alt: logo === null || logo === void 0 ? void 0 : logo.alt,
                href: logo === null || logo === void 0 ? void 0 : logo.url
            });
        });
        secondary_header_desktop_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLinks", function() {
            var _props = _this.props, pageClusterConfig = _props.pageClusterConfig, router = _props.router, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
            var links = (0,cluster_config_service/* getMiniSiteLinks */.J9)(pageClusterConfig, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
            return links.map(function(link, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "secondary-link-item-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_link_item_component, {
                        url: link === null || link === void 0 ? void 0 : link.url,
                        title: link === null || link === void 0 ? void 0 : link.text,
                        isSelected: (0,url.isSameUrlWithoutQueryParams)(link === null || link === void 0 ? void 0 : link.url, router === null || router === void 0 ? void 0 : router.asPath)
                    })
                }, index);
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SecondaryHeaderDesktopComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryHeaderDesktopComponent, {
                    "aria-label": "Secondary",
                    className: "secondary-header-desktop-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "secondary-header-desktop-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "logo-wrapper",
                                children: this.renderLogo()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "links-wrapper",
                                children: this.renderLinks()
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return SecondaryHeaderDesktopComponent;
}(react.PureComponent);
/* harmony default export */ var secondary_header_desktop_component = ((0,router.withRouter)((0,generic_config_context/* withGenericConfig */.P)(SecondaryHeaderDesktopComponent)));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-service.js + 56 modules
var base_header_service = __webpack_require__(33054);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/base-header-desktop-component.scss.js







var BASIC_HEADER_HEIGHT = "".concat(constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT, "px");
var base_header_desktop_component_scss_SECONDARY_HEADER_HEIGHT = "".concat(constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px");
var base_header_desktop_component_scss_UNIFIED_HEADER_TRANSITION = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease, transform ").concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease");
var UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION */.Z.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION, "ms ease, transform ").concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION */.Z.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION, "ms ease");
var SUBMENU_TRANSITION = "opacity 50ms ease";
var StyledBaseHeaderDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", {
    target: "e10outa10"
})("width:100%;.header-create-account-button-wrapper{padding-left:8px;.regular-button{height:40px;.button-component{display:flex;height:100%;align-items:center;font-size:0.8125rem;}}}.header-prominant-contact-sales-button-wrapper{padding-left:8px;.regular-button{height:40px;a{text-decoration:none;}.button-component{display:flex;height:100%;align-items:center;font-size:0.8125rem;}}}.header-button-wrapper{display:flex;align-items:center;padding-left:16px;.signup-button{height:40px;}}.signup-popup-wrapper{position:fixed;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";top:", constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT + 12, "px;left:calc(\n      (100vw - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2 + ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px -\n        ", constants/* default.SIGNUP_POPUP_SCREEN_WIDTH */.Z.SIGNUP_POPUP_SCREEN_WIDTH, "px - ", constants/* default.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN */.Z.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN, "px\n    );@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){left:calc(100vw - ", constants/* default.SIGNUP_POPUP_SCREEN_WIDTH */.Z.SIGNUP_POPUP_SCREEN_WIDTH, "px - ", constants/* default.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN */.Z.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN, "px);}}&.scroll-started{.secondary-header-wrapper{.secondary-header-desktop-component{border-bottom:1px solid ", colors/* default.riverstone */.Z.riverstone, ";}}}.products-switcher-wrapper{position:fixed;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";top:", constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT + 12, ' + "px";left:calc(\n      (100vw - ', vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2 + ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px -\n        ", constants/* default.PRODUCTS_SWITCHER_SCREEN_WIDTH */.Z.PRODUCTS_SWITCHER_SCREEN_WIDTH, "px - ", constants/* default.PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN */.Z.PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN, "px\n    );@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){left:calc(\n        100vw - ", constants/* default.PRODUCTS_SWITCHER_SCREEN_WIDTH */.Z.PRODUCTS_SWITCHER_SCREEN_WIDTH, "px - ", constants/* default.PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN */.Z.PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN, "px\n      );}}&.scrolled-threshold{.with-secondary-logo{.basic-header-content-wrapper{.basic-header-content{.main-logo-wrapper{opacity:0;visibility:hidden;pointer-events:none;position:absolute;}.secondary-logo-wrapper{opacity:1;visibility:visible;position:static;display:flex;pointer-events:auto;}}}}.base-header-desktop-content{.left-side-header-links{.absolute-main-links{opacity:0;visibility:hidden;pointer-events:none;transform:translateY(-8px);transition:", UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR, ";}.absolute-unified-links{opacity:1;visibility:visible;pointer-events:auto;transform:none;transition:", base_header_desktop_component_scss_UNIFIED_HEADER_TRANSITION, ";}}}.secondary-header-wrapper{pointer-events:none;.secondary-header-desktop-component{opacity:0;visibility:hidden;.logo-wrapper{opacity:0;visibility:hidden;transform:translateY(-5px);}.links-wrapper{opacity:0;visibility:hidden;transform:translateY(-5px);}}}}.base-header-desktop-content{flex-grow:1;display:flex;align-items:center;justify-content:flex-end;height:", BASIC_HEADER_HEIGHT, ";.left-side-header-links,.right-side-header-links{height:100%;display:flex;.link-item-with-menu-component-wrapper,.link-item-component-wrapper{display:flex;align-items:center;&.header-language-picker{justify-content:center;align-items:center;.language-picker-component{.selected-language{border-radius:8px;padding:0 16px;&:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}}.earth-icon{margin:0 6px;width:18px;height:18px;}.arrow-down-icon{height:7px;}.language-picker-dialog-component-wrapper{top:52px;}}}}}.left-side-header-links{flex-grow:1;flex-shrink:0;.absolute-unified-links,.absolute-main-links{position:absolute;display:flex;height:100%;}.absolute-main-links{opacity:1;visibility:visible;transition:", base_header_desktop_component_scss_UNIFIED_HEADER_TRANSITION, ";.submenu-enter{opacity:0.01;}.submenu-enter.submenu-enter-active{opacity:1;transition:", SUBMENU_TRANSITION, ";}.submenu-leave{opacity:1;}.submenu-leave.submenu-leave-active{opacity:0.01;transition:", SUBMENU_TRANSITION, ";}}.absolute-unified-links{opacity:0;visibility:hidden;pointer-events:none;transform:translateY(8px);transition:", UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR, ";}}.right-side-header-links{flex-shrink:0;}.header-button-wrapper{flex-shrink:0;}}.header-menu-component-wrapper{position:fixed;top:", BASIC_HEADER_HEIGHT, ";z-index:", z_index/* TOP_BAR */.sE, ";left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.1);backdrop-filter:blur(4px);// currently not supported in Firefox\n    pointer-events:none;width:100%;overflow:auto;.menu-component-wrapper{pointer-events:all;}}.secondary-header-wrapper{height:", base_header_desktop_component_scss_SECONDARY_HEADER_HEIGHT, ";position:fixed;width:100%;z-index:", z_index/* TOP_BAR */.sE - 1, ";}.header-menu-component-wrapper.enhanced-products{.structured-header-menu-left-panel-items{.inner-menu-item{.inner-menu-item-subitems{max-height:246px;gap:8px;.inner-menu-item-subitem{padding:8px 0;.inner-menu-item-subitem-wrapper{display:flex;width:100%;.inner-menu-item-subitem-title-icon-and-arrow{display:flex;.inner-menu-item-subitem-title-icon{width:48px;height:48px;margin:0 10px;}width:100%;align-items:center;.inner-menu-item-subitem-title-and-subtitle{display:flex;flex-direction:column;width:100%;.inner-menu-item-subitem-title{line-height:24px;}.inner-menu-item-subitem-subtitle{line-height:24px;color:", colors/* default.asphalt */.Z.asphalt, ";font-size:0.8125rem;}}}}}}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){.structured-header-menu-left-panel-items{.inner-menu-item{.inner-menu-item-subitems{.inner-menu-item-subitem{.inner-menu-item-subitem-wrapper{.inner-menu-item-subitem-title-icon-and-arrow{.inner-menu-item-subitem-title-icon{width:32px;height:32px;margin:0 6px;}.inner-menu-item-subitem-title-and-subtitle{.inner-menu-item-subitem-title{line-height:20px;}.inner-menu-item-subitem-subtitle{line-height:20px;font-size:12px;}}.inner-menu-item-subitem-title-arrow{margin-right:8px;}}}}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/products-switcher/products-switcher.scss.js






var SEPARATOR_LINE_COLOR = "#d9d9d9";
var StyledProductsSwitcher = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jpkpsg0"
})("height:", constants/* default.PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT */.Z.PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT, "px;width:", constants/* default.PRODUCTS_SWITCHER_SCREEN_WIDTH */.Z.PRODUCTS_SWITCHER_SCREEN_WIDTH, "px;border-radius:8px;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";box-shadow:0px 4px 50px 0px rgba(0,0,0,0.2);padding:24px;&.is-existing{height:", constants/* default.PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT */.Z.PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT, "px;}.main-products-title-wrapper{margin-bottom:16px;.main-product-title{font-size:0.875rem;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";font-weight:400;}}.main-products-wrapper{display:flex;flex-direction:column;}.separator-line{margin:16px 0 24px 0;height:1px;background-color:", SEPARATOR_LINE_COLOR, ";}.additional-products-title{font-size:0.875rem;font-weight:400;color:", colors/* default.asphalt */.Z.asphalt, ";margin-bottom:16px;}.additional-products-wrapper{display:flex;flex-direction:row;.product{.icon-wrapper{.picture-component{display:flex;height:20px;width:20px;}}}}.product{display:flex;gap:8px;align-items:center;font-size:0.875rem;font-weight:400;color:", colors/* default.asphalt */.Z.asphalt, ";padding:8px;border-radius:8px;text-decoration:none;.icon-wrapper{.picture-component{display:flex;height:32px;width:32px;}}.beta-tag{font-size:0.6875rem;font-weight:300;color:", colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_BACKGROUND_PINK], ";border-radius:2px;padding:1px 5px;line-height:normal;border-radius:32px;}:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}}");

// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/products-switcher/consts.js

var MAIN_PRODUCTS = [
    {
        name: "Work Management",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/WM.png",
        miniSiteLink: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
        productStoreLink: "monday.com/account_products/direct_install/core"
    },
    {
        name: "CRM",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/CRM.png",
        miniSiteLink: links/* CRM_MINI_SITE_LINK */.mgz,
        productStoreLink: "monday.com/account_products/direct_install/crm"
    },
    {
        name: "Dev",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/DEV.png",
        miniSiteLink: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
        productStoreLink: "monday.com/account_products/direct_install/software"
    },
    {
        name: "Service",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/Services.png",
        miniSiteLink: links/* SERVICE_MINI_SITE_LINK */.Kon,
        productStoreLink: "monday.com/account_products/direct_install/service",
        hasBetaTag: true
    }
];
var ADDITIONAL_PRODUCTS = [
    {
        name: "WorkForms",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/forms.png",
        miniSiteLink: links/* WORKFORMS_HOMEPAGE_LINK */.o2N
    },
    {
        name: "WorkCanvas",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/canvas.png",
        miniSiteLink: links/* CANVAS_HOMEPAGE_LINK */.gOl
    }
];

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./services/monday-platform/existing-accounts-service.js
var existing_accounts_service = __webpack_require__(14124);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/products-switcher/products-switcher.js
function products_switcher_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_switcher_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var ProductsSwitcher = function(props) {
    var translate = props.translate, setShowproductsSwithcer = props.setShowproductsSwithcer, showproductsSwithcer = props.showproductsSwithcer, persistantCookies = props.persistantCookies, simulateSwitcherForExistingUsers = props.simulateSwitcherForExistingUsers;
    var EXISTING_USER = "existing_user";
    var NEW_USER = "new_user";
    var isExistingUserTest = simulateSwitcherForExistingUsers || (0,existing_accounts_service/* isExistingUserSwithcerInHeaderTest */.dF)(persistantCookies, false);
    var lastAccountSlug = (0,cookies_service/* getCookie */.ej)(cookies.LAST_ACCOUNT_SLUG);
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var onPopUpClose = function() {
            if (showproductsSwithcer) {
                setShowproductsSwithcer(false);
            }
        };
        var checkIfClickedOutside = function(e) {
            if (ref.current && !ref.current.contains(e.target)) {
                onPopUpClose();
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return function() {
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, [
        showproductsSwithcer,
        setShowproductsSwithcer
    ]);
    var renderProduct = function(product, openInDifferentTab) {
        var linkProps = {
            href: isExistingUserTest ? "https://".concat(lastAccountSlug, ".").concat(product === null || product === void 0 ? void 0 : product.productStoreLink) : product === null || product === void 0 ? void 0 : product.miniSiteLink,
            className: "product",
            onClick: function() {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SWITCHER_PRODUCT_CLICKED, {
                    kind: product === null || product === void 0 ? void 0 : product.name,
                    info1: isExistingUserTest ? EXISTING_USER : NEW_USER
                });
            },
            onMouseEnter: function() {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SWITCHER_PRODUCT_HOVERED, {
                    kind: product === null || product === void 0 ? void 0 : product.name,
                    info1: isExistingUserTest ? EXISTING_USER : NEW_USER
                });
            }
        };
        if (openInDifferentTab) {
            linkProps.target = "_blank";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", _object_spread_props(_object_spread({}, linkProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "icon-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: product === null || product === void 0 ? void 0 : product.iconLink,
                        alt: product === null || product === void 0 ? void 0 : product.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-name",
                    children: product === null || product === void 0 ? void 0 : product.name
                }),
                (product === null || product === void 0 ? void 0 : product.hasBetaTag) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "beta-tag",
                    children: translate("header.tabs.solutions.byProduct.dev.beta")
                })
            ]
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductsSwitcher, {
        className: classnames_default()("products-switcher", {
            "is-existing": isExistingUserTest
        }),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-products-title-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-product-title",
                    children: translate("header.productsSwitcher.exploreFeaturedProducts")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-products-wrapper",
                children: MAIN_PRODUCTS.map(function(product, index) {
                    return renderProduct(product, false, index);
                })
            }),
            !isExistingUserTest && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bottom-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "separator-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "additional-products-title-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "additional-products-title",
                            children: [
                                translate("header.productsSwitcher.moreProducts"),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "additional-products-wrapper",
                        children: ADDITIONAL_PRODUCTS.map(function(product, index) {
                            return renderProduct(product, true, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var products_switcher = ((0,generic_config_context/* withGenericConfig */.P)(ProductsSwitcher));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/link-item/link-item-component.js + 1 modules
var link_item_component = __webpack_require__(88838);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/link-item-with-menu/link-item-with-menu-component.scss.js



var StyledLinkItemWithMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bm0d790"
})("cursor:pointer;display:flex;align-items:center;padding:8px 10px;color:", colors/* default.text-gray */.Z["text-gray"], ";transition:color 200ms ease;border-radius:8px;&:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}&.is-open,&:hover{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";.link-item-with-menu-icon{path{fill:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";stroke:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}}&.is-open{.link-item-with-menu-icon{transform:rotate(180deg);}}.link-item-with-menu-title{font-size:0.875rem;margin-right:4px;}.link-item-with-menu-icon{height:7px;width:10px;transition:transform 200ms ease;path{fill:", colors/* default.mud */.Z.mud, ";stroke:", colors/* default.mud */.Z.mud, ";}}");

// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/link-item-with-menu/link-item-with-menu-component.js





function link_item_with_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var LIST_ITEM_WITH_MENU_CLASS_NAME = "link-item-with-menu-component";
var HOVER_OPEN_MENU_WAIT_MILISECONDS = 500;
var LinkItemWithMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LinkItemWithMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LinkItemWithMenuComponent);
    function LinkItemWithMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, LinkItemWithMenuComponent);
        var _this;
        _this = _super.call(this, props);
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMouseLeave", function(event) {
            var _props = _this.props, isOpen = _props.isOpen, closeMenu = _props.closeMenu;
            _this.clearHoverOpenMenuTimeoutIfNeeded();
            if (isOpen) {
                var _event_target;
                closeMenu(event);
                event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.blur();
            }
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMouseEnter", function(event) {
            var openMenu = _this.props.openMenu;
            _this._hoverTimeout = setTimeout(openMenu, _this.getHoverWaitTime());
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getHoverWaitTime", function() {
            var shouldDelayMenuOpenOnHover = _this.props.shouldDelayMenuOpenOnHover;
            return shouldDelayMenuOpenOnHover ? HOVER_OPEN_MENU_WAIT_MILISECONDS : 0;
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "clearHoverOpenMenuTimeoutIfNeeded", function() {
            if (_this._hoverTimeout) {
                clearTimeout(_this._hoverTimeout);
                _this._hoverTimeout = null;
            }
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClickAction", function(event) {
            var _props = _this.props, openMenu = _props.openMenu, isOpen = _props.isOpen, closeMenu = _props.closeMenu;
            if (isOpen) {
                closeMenu();
            } else {
                openMenu();
            }
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "blurItem", function(e) {
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".".concat(LIST_ITEM_WITH_MENU_CLASS_NAME))) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            _this.blurItem(e);
            _this.onClickAction(e);
        });
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onClickAction);
        _this._hoverTimeout = null;
        return _this;
    }
    (0,_create_class/* default */.Z)(LinkItemWithMenuComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, isOpen = _props.isOpen, translate = _props.translate, className = _props.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLinkItemWithMenuComponent, {
                    className: classnames_default()(LIST_ITEM_WITH_MENU_CLASS_NAME, className, {
                        "is-open": isOpen
                    }),
                    onKeyDown: this.onKeyDown,
                    onClick: this.onClick,
                    role: "link",
                    tabIndex: 0,
                    "aria-haspopup": "true",
                    "aria-expanded": isOpen,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "link-item-with-menu-title",
                            children: translate(title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {
                            className: "link-item-with-menu-icon"
                        })
                    ]
                });
            }
        }
    ]);
    return LinkItemWithMenuComponent;
}(react.PureComponent);
LinkItemWithMenuComponent.defaultProps = {
    shouldDelayMenuOpenOnHover: false
};
/* harmony default export */ var link_item_with_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(LinkItemWithMenuComponent));

// EXTERNAL MODULE: ./components/core/language-picker/language-picker-component.js + 6 modules
var language_picker_component = __webpack_require__(39160);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-service.js
var language_picker_service = __webpack_require__(42803);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/base-header-menu/base-header-menu-component.scss.js


var StyledBaseHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edqq9jd0"
})("width:100%;background-color:rgba(255,255,255,1);box-shadow:0px 18px 30px rgba(0,0,0,0.03);padding:16px 0px;.header-menu-items-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;display:flex;flex-wrap:wrap;margin:auto;padding:0px 32px;.header-menu-item-component-wrapper{height:156px;width:20%;}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){.header-menu-items-wrapper{.header-menu-item-component-wrapper{width:25%;}}}");

// EXTERNAL MODULE: ./components/core/badge/badge-component.js + 1 modules
var badge_component = __webpack_require__(833);
// EXTERNAL MODULE: ./static/svg/arrow-right2.svg
var arrow_right2 = __webpack_require__(96654);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/base-header-menu/header-menu-item/header-menu-item-component.scss.js


var StyledHeaderMenuItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "exmkqvt0"
})("display:flex;height:100%;width:100%;cursor:pointer;padding:0px 10px;align-items:center;transition:background-color 200ms ease;text-decoration:none;color:", colors/* default.black */.Z.black, ";&:hover{background-color:", colors/* default.highlight-blue */.Z["highlight-blue"], ";}.header-menu-item-content{display:flex;.menu-item-title-icon{flex-shrink:0;font-size:0.875rem;margin-right:16px;path{stroke:", colors/* default.iris */.Z.iris, ";}}.menu-item-text-wrapper{display:flex;flex-direction:column;.menu-item-title-wrapper{display:flex;.menu-item-title{font-weight:400;}.new-badge-component-wrapper{margin-left:8px;}}.menu-item-description{margin-top:8px;font-size:0.8125rem;line-height:20px;color:", colors/* default.asphalt */.Z.asphalt, ";}.menu-item-footer{display:flex;align-items:center;margin-top:16px;color:", colors/* default.iris */.Z.iris, ";font-size:0.6875rem;position:absolute;top:130px;svg{fill:currentColor;height:10px;margin-left:8px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/base-header-menu/header-menu-item/header-menu-item-component.js






function header_menu_item_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var HeaderMenuItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HeaderMenuItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HeaderMenuItemComponent);
    function HeaderMenuItemComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, HeaderMenuItemComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        header_menu_item_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var url = _this.props.url;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
                kind: url,
                info1: isKeyboardEvent ? "keyboard" : "mouse"
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(HeaderMenuItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, Icon = _props.icon, title = _props.title, description = _props.description, url = _props.url, isPopular = _props.isPopular, translate = _props.translate, footer = _props.footer;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderMenuItemComponent, {
                    className: "header-menu-item-component",
                    href: url,
                    onClick: this.onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-menu-item-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                className: "menu-item-title-icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "menu-item-text-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "menu-item-title-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "menu-item-title",
                                                children: translate(title)
                                            }),
                                            isPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "new-badge-component-wrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_component/* default */.Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "menu-item-description",
                                        children: translate(description)
                                    }),
                                    footer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "menu-item-footer",
                                        children: [
                                            translate(footer),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right2/* default */.Z, {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return HeaderMenuItemComponent;
}(react.PureComponent);
/* harmony default export */ var header_menu_item_component = ((0,generic_config_context/* withGenericConfig */.P)(HeaderMenuItemComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/base-header-menu/base-header-menu-component.js




function base_header_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_header_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_header_menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var BaseHeaderMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseHeaderMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseHeaderMenuComponent);
    function BaseHeaderMenuComponent() {
        (0,_class_call_check/* default */.Z)(this, BaseHeaderMenuComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BaseHeaderMenuComponent, [
        {
            key: "renderHeaderMenuItems",
            value: function renderHeaderMenuItems() {
                var menuItems = this.props.menuItems;
                return menuItems.map(function(menuItem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header-menu-item-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_item_component, base_header_menu_component_object_spread({}, menuItem))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseHeaderMenuComponent, {
                    className: "base-header-menu-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header-menu-items-wrapper",
                        children: this.renderHeaderMenuItems()
                    })
                });
            }
        }
    ]);
    return BaseHeaderMenuComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./static/svg/header/header_subtitle_line.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgHeaderSubtitleLine = function SvgHeaderSubtitleLine(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 6,
        height: 1,
        fill: "none",
        viewBox: "0 0 6 1"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#676879",
        strokeLinecap: "round",
        d: "M.25.75h5.5"
    })));
};
/* harmony default export */ var header_subtitle_line = (SvgHeaderSubtitleLine);

// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/header-menu-section-component.scss.js



var StyledHeaderMenuSectionComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rl3vti0"
})("height:100%;.header-menu-section-title{color:", colors/* default.asphalt */.Z.asphalt, ';font-weight:300;font-size:0.8125rem;display:flex;align-items:center;position:relative;&.with-underline{font-size:1rem;&:after{content:"";background:', colors/* default.mud */.Z.mud, ";opacity:0.1;top:24px;display:block;position:absolute;height:1px;width:calc(100% - 20px);margin-left:-8px;}}&.with-image-and-CTA{flex-direction:column;align-items:flex-start;gap:8px;margin-left:-16px;padding:12px 16px;border-bottom:1px solid ", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";&:hover{border-radius:4px;border-color:transparent;background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";cursor:pointer;}.secondary-button{font-size:0.8125rem;}}.header-menu-section-title-line{margin-right:8px;stroke:", colors/* default.asphalt */.Z.asphalt, ";}.header-menu-section-title-image-and-cta{display:flex;width:100%;justify-content:space-between;align-items:center;.header-menu-section-title-image{height:26px;display:flex;}.secondary-button{margin-right:18px;}}}.header-menu-section-items-wrapper{margin:20px 0;display:grid;grid-auto-flow:column;grid-template-rows:repeat(var(--max-number-of-items-in-column),auto);}.header-menu-see-more-wrapper{margin-bottom:16px;display:flex;.secondary-button{.secondary-button-text{font-size:0.8125rem;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
;// CONCATENATED MODULE: ./static/svg/bullet_checked_green.svg
var _circle, bullet_checked_green_path;
function bullet_checked_green_extends() {
    bullet_checked_green_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return bullet_checked_green_extends.apply(this, arguments);
}

var SvgBulletCheckedGreen = function SvgBulletCheckedGreen(props) {
    return /*#__PURE__*/ react.createElement("svg", bullet_checked_green_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 10,
        cy: 10,
        r: 10,
        fill: "#CAF4E2",
        className: "circle"
    })), bullet_checked_green_path || (bullet_checked_green_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#037F4C",
        d: "M6.272 9.834a.756.756 0 0 0-1.054 0 .72.72 0 0 0 0 1.032l2.98 2.92a.756.756 0 0 0 1.053 0l5.96-5.84a.72.72 0 0 0 0-1.032.756.756 0 0 0-1.054 0l-5.433 5.324z",
        className: "mark"
    })));
};
/* harmony default export */ var bullet_checked_green = (SvgBulletCheckedGreen);

;// CONCATENATED MODULE: ./static/svg/bullet_plus_green_2.svg
var _g, _defs;
function bullet_plus_green_2_extends() {
    bullet_plus_green_2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return bullet_plus_green_2_extends.apply(this, arguments);
}

var SvgBulletPlusGreen2 = function SvgBulletPlusGreen2(props) {
    return /*#__PURE__*/ react.createElement("svg", bullet_plus_green_2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_562_26773)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#CAF4E2",
        d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10",
        className: "circle"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#037F4C",
        d: "M14.319 9.396q.681 0 .681.593v.044q0 .285-.154.44-.153.13-.527.131h-3.715v3.715q0 .374-.153.527-.133.154-.418.154h-.044q-.594 0-.593-.681v-3.715H5.68q-.374 0-.527-.131Q5 10.318 5 10.033v-.044q0-.594.681-.593h3.715V5.68q0-.681.593-.681h.044q.285 0 .418.154.153.153.153.527v3.715z",
        className: "mark"
    }))), _defs || (_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_562_26773"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var bullet_plus_green_2 = (SvgBulletPlusGreen2);

// EXTERNAL MODULE: ./constants/localized-links.js
var localized_links = __webpack_require__(31182);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/consts.js


var _obj;
var MENU_ID_TO_EVENT_KIND_MAP = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, base_header_service/* SOLUTIONS_MENU_ID */.e1, "Products"), (0,src_define_property/* default */.Z)(_obj, base_header_service/* TEAMS_MENU_ID */.$Q, "Teams"), (0,src_define_property/* default */.Z)(_obj, base_header_service/* PLATFORM_MENU_ID */.wP, "Platform"), (0,src_define_property/* default */.Z)(_obj, base_header_service/* CUSTOMERS_MENU_ID */.xN, "Success stories"), (0,src_define_property/* default */.Z)(_obj, base_header_service/* RESOURCES_MENU_ID */.Gu, "Resources"), _obj);

// EXTERNAL MODULE: ./segments/desktop/constants.js
var desktop_constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/constants.js
var SECTION_ITEM_HEIGHT = 98;
var SECTION_ITEM_WIDTH = 286; // includes 16 pixel padding (8 on each side)
var SECTION_ITEM_HORIZONTAL_MARGIN = 18;
var SECTION_ITEM_SMALL_HORIZONTAL_MARGIN = 8;
var SEPERATOR_RIGHT_MARGIN = 32;
var SEPERATOR_LEFT_MARGIN = 4;
var SEPERATOR_RIGHT_MARGIN_SMALL = 16;
var SEPERATOR_LEFT_MARGIN_SMALL = 4;
var SECTION_MARGIN_BETWEEN_COLUMNS = 8;
var SECTION_SMALL_MARGIN_BETWEEN_COLUMNS = 0;
var SECTION_ITEM_BOTTOM_MARGIN = 38;

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section-item/header-menu-section-item-component.scss.js






var SECTION_ITEM_HEIGHT_PX = "".concat(SECTION_ITEM_HEIGHT, "px");
var SECTION_ITEM_WIDTH_PX = "".concat(SECTION_ITEM_WIDTH, "px");
var SECTION_ITEM_HORIZONTAL_MARGIN_PX = "".concat(SECTION_ITEM_HORIZONTAL_MARGIN, "px");
var SECTION_ITEM_SMALL_HORIZONTAL_MARGIN_PX = "".concat(SECTION_ITEM_SMALL_HORIZONTAL_MARGIN, "px");
var StyledHeaderMenuSectionItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e13mtidn0"
})("width:", SECTION_ITEM_WIDTH_PX, ";height:", SECTION_ITEM_HEIGHT_PX, ";margin-right:", SECTION_ITEM_HORIZONTAL_MARGIN_PX, ";padding:16px 8px;background-color:var(--header-menu-section-item-background-color);&:hover{background-color:var(--header-menu-section-item-hover-background-color);}&.outline{border-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}border-radius:4px;border-width:2px;border-style:solid;&:not(.outline){border-color:transparent;}&.secondary-product{width:340px;.menu-item-title{opacity:0.85;}}&.feature{width:280px;margin-bottom:14px;margin-right:14px;padding:16px 12px;.menu-item-title-icon{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";border:1px solid transparent;border-radius:2px;margin-right:12px;}&:hover{.menu-item-title-icon{border:", "1px solid ".concat(colors/* default */.Z[color_consts.LIGHT_WORK_OS_IRIS_COLOR_NAME]), ";}}}&.resource{width:274px;margin-bottom:14px;margin-right:28px;}&.story{height:unset;width:356px;padding:0;border:none;&:hover{", (0,desktop_constants.getComponentShadowFilter)(), "      // remove hover effect in safari because of this bug:https://monday.monday.com/boards/757661511/pulses/2181485781\n            @media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none){filter:unset;}}}&:not(:last-child){margin-bottom:20px;}img{width:100%;height:147px;background:", colors/* default.silver */.Z.silver, ";border-top-left-radius:4px;border-top-right-radius:4px;}.menu-item-text-wrapper{padding:8px 20px 16px;.menu-item-description{font-size:0.8125rem;line-height:19px;color:", colors/* default.mud */.Z.mud, ";}}}.menu-item-text-and-tags-wrapper{display:flex;align-items:center;}&.by-team{.header-menu-section-item-component{.header-menu-item-content{.menu-item-title-icon{margin-top:-4px;margin-right:8px;}}}}&.secondary-product{width:156px;height:54px;margin-bottom:12px;.header-menu-section-item-component .header-menu-item-content .menu-item-text-wrapper .menu-item-description{-webkit-line-clamp:3;}}.header-menu-section-item-component{display:flex;height:100%;width:100%;cursor:pointer;align-items:center;transition:background-color 200ms ease;text-decoration:none;color:", colors/* default.black */.Z.black, ";&:not([href]){cursor:default;}.header-menu-item-content{display:flex;&.has-image-instead-title{flex-direction:column;}.menu-item-title-icon{flex-shrink:0;font-size:0.875rem;margin-right:16px;&:not(.fill){path,rect,circle{stroke:var(--icon-color);}}}.menu-item-text-wrapper{display:flex;flex-direction:column;.menu-item-title-wrapper{display:flex;.menu-item-title{font-size:0.875rem;font-weight:400;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;line-height:20px;}.new-badge-component-wrapper{margin-left:8px;display:flex;align-items:center;}}.menu-item-description{margin-top:8px;font-size:0.8125rem;line-height:20px;color:", colors/* default.asphalt */.Z.asphalt, ";overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;/* number of lines to show */\n          -webkit-box-orient:vertical;}.menu-item-description-button{margin-top:16px;.secondary-button{font-size:0.8125rem;}}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){margin-right:", SECTION_ITEM_SMALL_HORIZONTAL_MARGIN_PX, ";}}@media (max-width:", vp_sizes/* MD_DESKTOP_WIDTH */.JF, "){&.story{width:280px;img{height:115px;}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_MID_WIDTH */.ko, "){&.story{width:240px;img{height:99px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section-item/header-menu-section-item-component.js




















var HeaderMenuSectionItemComponent = function(props) {
    var Icon = props.icon, iconType = props.iconType, iconColor = props.iconColor, imageSrc = props.imageSrc, topic = props.topic, title = props.title, subtitle = props.subtitle, SubtitleIcon = props.subtitleIcon, description = props.description, url = props.url, isPopular = props.isPopular, translate = props.translate, badgeText = props.badgeText, badgeColorName = props.badgeColorName, badgeTextColorName = props.badgeTextColorName, badgeStrokeColorName = props.badgeStrokeColorName, openInNewTab = props.openInNewTab, button = props.button, menuId = props.menuId, sectionId = props.sectionId, iconStrokeColor = props.iconStrokeColor, tags = props.tags, buttonText = props.buttonText, outline = props.outline, itemType = props.itemType, backgroundColor = props.backgroundColor, hoverBackgroundColor = props.hoverBackgroundColor, subtitleAboveItem = props.subtitleAboveItem, localeId = props.localeId, imageFloatingCaption = props.imageFloatingCaption;
    var localizedUrl = (0,react.useMemo)(function() {
        return (0,localized_links/* getLocalizedLink */.Lz)(url, localeId);
    }, [
        url,
        localeId
    ]);
    var onClick = (0,react.useCallback)(function(e) {
        var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
            click_text: translate(title),
            parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
            kind: localizedUrl,
            info1: isKeyboardEvent ? "keyboard" : "mouse",
            info2: menuId,
            info3: sectionId
        });
    }, [
        localizedUrl,
        menuId,
        sectionId,
        title,
        translate
    ]);
    var onTagMouseEnter = function(tag, index) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_PRODUCT_TAG_HOVERED, {
            kind: translate(title),
            info1: translate(tag),
            info2: index
        });
    };
    var renderMenuItemText = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "menu-item-text-wrapper",
            children: [
                topic && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "menu-item-topic-wrapper",
                    children: translate(topic)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "menu-item-title-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "menu-item-title",
                            children: translate(title)
                        }),
                        isPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "new-badge-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_component/* default */.Z, {
                                badgeText: translate(badgeText),
                                badgeColorName: badgeColorName,
                                badgeTextColorName: badgeTextColorName,
                                badgeStrokeColorName: badgeStrokeColorName
                            })
                        })
                    ]
                }),
                subtitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "menu-item-subtitle-wrapper",
                    children: [
                        SubtitleIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleIcon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "menu-item-title",
                            children: translate(subtitle)
                        })
                    ]
                }),
                description && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "menu-item-description",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        text: translate(description)
                    })
                }),
                button && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "menu-item-description-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, {
                        buttonText: translate(buttonText || "header.menuItem.button.readMore"),
                        url: localizedUrl,
                        isOpenLinkInNewTab: openInNewTab
                    })
                })
            ]
        });
    };
    var renderTag = function(param) {
        var tag = param.tag, index = param.index;
        var tagsType = (tags === null || tags === void 0 ? void 0 : tags.tagsType) || base_header_service/* TAG_TYPES.DEFAULT */.qq.DEFAULT;
        var renderBulletTag = function() {
            var _tags_list;
            var BulletIcon = index === (tags === null || tags === void 0 ? void 0 : (_tags_list = tags.list) === null || _tags_list === void 0 ? void 0 : _tags_list.length) - 1 ? bullet_plus_green_2 : bullet_checked_green;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletIcon, {
                        className: "tag-bullet"
                    }),
                    translate(tag)
                ]
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tag",
            onMouseEnter: function() {
                return onTagMouseEnter(tag, index);
            },
            children: tagsType === base_header_service/* TAG_TYPES.BULLET */.qq.BULLET ? renderBulletTag() : translate(tag)
        }, index);
    };
    var renderTags = function(param) {
        var className = param.className;
        return tags && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("tags-wrapper", className),
            style: {
                "--header-product-tag-background-color": tags.backgroundColor,
                "--header-product-tag-color": tags.color
            },
            children: [
                tags.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tags-title",
                    children: "".concat(translate(tags.title), ":")
                }),
                tags.list.map(function(tag, index) {
                    return renderTag({
                        tag: tag,
                        index: index
                    });
                })
            ]
        });
    };
    var getStyle = function() {
        var backgroundColorValue = backgroundColor || colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        var hoverBackgroundColorValue = hoverBackgroundColor || colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME];
        return {
            "--header-menu-section-item-background-color": backgroundColorValue,
            "--header-menu-section-item-hover-background-color": hoverBackgroundColorValue
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            subtitleAboveItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: translate(subtitleAboveItem)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderMenuSectionItemComponent, {
                className: classnames_default()("header-menu-section-item-component-wrapper", itemType, {
                    outline: outline
                }),
                style: getStyle(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "header-menu-section-item-component",
                    href: localizedUrl,
                    onClick: onClick,
                    target: openInNewTab ? "_blank" : "_self",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-menu-item-content-and-tags-wrapper",
                        style: {
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("header-menu-item-content", {
                                    "has-image-instead-title": !!imageSrc,
                                    "no-description": !description
                                }),
                                children: [
                                    Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        className: classnames_default()("menu-item-title-icon", iconType),
                                        style: {
                                            "--icon-color": colors/* default */.Z[iconColor || color_consts.WORK_OS_IRIS_COLOR_NAME],
                                            "--icon-stroke-color": iconStrokeColor
                                        }
                                    }),
                                    imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "menu-item-image-and-caption-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                src: imageSrc
                                            }),
                                            imageFloatingCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "menu-item-image-floating-caption",
                                                children: translate(imageFloatingCaption)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "menu-item-text-and-tags-wrapper",
                                        children: [
                                            renderMenuItemText(),
                                            renderTags({
                                                className: "tags-next-to-logo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            renderTags({
                                className: "tags-at-the-bottom"
                            })
                        ]
                    })
                })
            }, title)
        ]
    });
};
/* harmony default export */ var header_menu_section_item_component = ((0,generic_config_context/* withGenericConfig */.P)(HeaderMenuSectionItemComponent));
HeaderMenuSectionItemComponent.defaultProps = {
    iconType: base_header_service/* ICON_TYPES.outline */.Yp.outline
};

// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/components/tags.scss.js




var BACKGROUND_COLOR_OPACITY = 0.08;
var StyledTags = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e65ul410"
})("display:flex;align-content:center;.tags-title-wrapper{margin-right:8px;align-self:center;}.tags-wrapper{display:flex;gap:4px;.tag{border-radius:4px;padding:4px 8px;color:", function(param) {
    var color = param.color;
    return colors/* default */.Z[color];
}, ";background-color:", function(param) {
    var color = param.color;
    return (0,general/* hexToRgba */.a7)(colors/* default */.Z[color || color_consts.BRAND_BLACK_TEXT_COLOR], BACKGROUND_COLOR_OPACITY);
}, ";}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/components/tags.js


var Tags = function(param) {
    var tags = param.tags, translate = param.translate;
    var _tags_labels;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTags, {
        color: tags === null || tags === void 0 ? void 0 : tags.color,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tags-title-wrapper",
                children: translate("header.tabs.products.tags.bestFor")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tags-wrapper",
                children: tags === null || tags === void 0 ? void 0 : (_tags_labels = tags.labels) === null || _tags_labels === void 0 ? void 0 : _tags_labels.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tag",
                        children: translate(tag)
                    }, tag);
                })
            })
        ]
    });
};
/* harmony default export */ var components_tags = (Tags);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/header-menu-section-component.js
function header_menu_section_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function header_menu_section_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            header_menu_section_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function header_menu_section_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function header_menu_section_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        header_menu_section_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



















var MAX_NUMBER_OF_ITEMS_IN_COLUMN_DEFAULT = 3;
var HeaderMenuSectionComponent = function(props) {
    var menuSectionItems = props.menuSectionItems, maxNumberOfItemsInColumn = props.maxNumberOfItemsInColumn, title = props.title, subtitle = props.subtitle, seeMoreItem = props.seeMoreItem, translate = props.translate, classname = props.classname, titleLine = props.titleLine, titleImage = props.titleImage, titleCTA = props.titleCTA, tags = props.tags, titleUrl = props.titleUrl, menuId = props.menuId, id = props.id, withTitleUnderline = props.withTitleUnderline;
    var onButtonClicked = (0,react.useCallback)(function(event, url, eventInfo) {
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
            click_text: translate(titleCTA === null || titleCTA === void 0 ? void 0 : titleCTA.title),
            parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
            kind: url,
            info1: eventInfo,
            info2: menuId,
            info3: id
        });
        event === null || event === void 0 ? void 0 : event.stopPropagation();
    }, [
        id,
        menuId,
        titleCTA === null || titleCTA === void 0 ? void 0 : titleCTA.title,
        translate
    ]);
    var getStyle = function(menuSectionItem) {
        var backgroundColor = menuSectionItem.backgroundColor, hoverBackgroundColor = menuSectionItem.hoverBackgroundColor;
        var backgroundColorValue = backgroundColor || colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        var hoverBackgroundColorValue = hoverBackgroundColor || colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME];
        return {
            "--header-menu-section-item-background-color": backgroundColorValue,
            "--header-menu-section-item-hover-background-color": hoverBackgroundColorValue
        };
    };
    var renderHeaderMenuItems = (0,react.useCallback)(function() {
        return menuSectionItems.map(function(menuSectionItem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_item_component, header_menu_section_component_object_spread_props(header_menu_section_component_object_spread({}, menuSectionItem), {
                menuId: menuId,
                sectionId: id
            }));
        });
    }, [
        menuSectionItems
    ]);
    var renderBtnFromConfig = (0,react.useCallback)(function(btnConfig) {
        if (!btnConfig) return null;
        var btnText = btnConfig.title, _buttonType = btnConfig.buttonType, buttonType = _buttonType === void 0 ? button_consts/* SECONDARY_BUTTON_TYPE */.jE : _buttonType, eventInfo = btnConfig.eventInfo, config = _object_without_properties(btnConfig, [
            "title",
            "buttonType",
            "eventInfo"
        ]);
        var buttonConfig = header_menu_section_component_object_spread({
            buttonText: translate(btnText),
            buttonType: buttonType,
            onClick: function(event) {
                return onButtonClicked(event, config === null || config === void 0 ? void 0 : config.url, eventInfo);
            }
        }, config);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, header_menu_section_component_object_spread({}, buttonConfig));
    }, [
        onButtonClicked,
        translate
    ]);
    var onTitleClick = function(e) {
        var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
        if (titleUrl) {
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
                click_text: id,
                parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
            });
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
                kind: titleUrl,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: menuId,
                info3: id
            });
            window.location.href = titleUrl;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderMenuSectionComponent, {
        className: "header-menu-section-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("header-menu-section-title", {
                    "with-underline": withTitleUnderline,
                    "with-image-and-CTA": titleImage && titleCTA
                }),
                onClick: onTitleClick,
                children: [
                    (titleImage || titleCTA) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-menu-section-title-image-and-cta",
                        children: [
                            titleImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: titleUrl,
                                tabIndex: "-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                    src: titleImage,
                                    className: "header-menu-section-title-image"
                                })
                            }),
                            renderBtnFromConfig(titleCTA)
                        ]
                    }),
                    tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tags, {
                        tags: tags,
                        translate: translate
                    }),
                    titleLine && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_subtitle_line, {
                        className: "header-menu-section-title-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        className: "header-menu-section-title-text",
                        text: translate(title)
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-menu-section-subtitle",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                    text: translate(subtitle)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("header-menu-section-items-wrapper", classname),
                style: {
                    "--max-number-of-items-in-column": maxNumberOfItemsInColumn
                },
                children: renderHeaderMenuItems()
            }),
            seeMoreItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-menu-see-more-wrapper",
                children: renderBtnFromConfig(seeMoreItem)
            })
        ]
    });
};
/* harmony default export */ var header_menu_section_component = ((0,generic_config_context/* withGenericConfig */.P)(HeaderMenuSectionComponent));
HeaderMenuSectionComponent.defaultProps = {
    maxNumberOfItemsInColumn: MAX_NUMBER_OF_ITEMS_IN_COLUMN_DEFAULT
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/sections-header-menu-component.scss.js






var SEPERATOR_RIGHT_MARGIN_PX = "".concat(SEPERATOR_RIGHT_MARGIN, "px");
var SEPERATOR_RIGHT_MARGIN_SMALL_PX = "".concat(SEPERATOR_RIGHT_MARGIN_SMALL, "px");
var SEPERATOR_LEFT_MARGIN_PX = "".concat(SEPERATOR_LEFT_MARGIN, "px");
var SEPERATOR_LEFT_MARGIN_SMALL_PX = "".concat(SEPERATOR_LEFT_MARGIN_SMALL, "px");
var StyledSectionsHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqe2t5w0"
})("width:100%;background-color:rgba(255,255,255,1);padding:0;box-shadow:none;.header-menu-sections-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;height:100%;display:flex;margin:auto;padding:0px 32px;.sections-separator{border-right:1px solid;border-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";margin:32px ", SEPERATOR_RIGHT_MARGIN_PX, " 36px ", SEPERATOR_LEFT_MARGIN_PX, ";&.products{margin-right:80px;}&.mondayProducts{margin-right:64px;}}.header-menu-section-component-wrapper{padding:48px 0 0px;background-color:var(--section-background-color);min-height:400px;&.has-background-color{flex:1;padding-left:54px;padding-top:48px;padding-bottom:32px;}&.products:first-of-type{.header-menu-section-title{font-size:1.238rem;margin-bottom:16px;margin-right:80px;color:unset;font-weight:500;}.header-menu-section-subtitle{font-size:0.8125rem;line-height:20px;margin-right:50px;color:", colors/* default.asphalt */.Z.asphalt, ";}}&.products{width:312px;}&.mondayProducts{.menu-item-title{opacity:0.85;}padding-top:30px;.header-menu-section-items-wrapper.mondayProducts{margin-top:0;}}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){.header-menu-sections-wrapper{.sections-separator{margin-right:", SEPERATOR_RIGHT_MARGIN_SMALL_PX, ";margin-left:", SEPERATOR_LEFT_MARGIN_SMALL_PX, ";}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/sections-header-menu-component.js
function sections_header_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sections_header_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sections_header_menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sections_header_menu_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sections_header_menu_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sections_header_menu_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var SectionsHeaderMenuComponent = function(props) {
    var menuItems = props.menuItems, menuId = props.menuId;
    var renderHeaderMenuSections = (0,react.useCallback)(function() {
        return menuItems.map(function(menuSection, index) {
            var backgroundColor = menuSection.backgroundColor, classname = menuSection.classname, noSeparator = menuSection.noSeparator, title = menuSection.title, hasFirstSeparator = menuSection.hasFirstSeparator;
            var isLastItem = menuItems.length - 1 === index;
            var hasBackgroundColor = !!backgroundColor;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    hasFirstSeparator && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("sections-separator", classname)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("header-menu-section-component-wrapper", classname, {
                            "has-background-color": hasBackgroundColor
                        }),
                        style: {
                            "--section-background-color": colors/* default */.Z[backgroundColor] || "transparent"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_component, sections_header_menu_component_object_spread_props(sections_header_menu_component_object_spread({}, menuSection), {
                            menuId: menuId
                        }))
                    }, title),
                    !isLastItem && !noSeparator && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("sections-separator", classname)
                    })
                ]
            });
        });
    }, [
        menuItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionsHeaderMenuComponent, {
        className: "sections-header-menu-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "header-menu-sections-wrapper",
            children: renderHeaderMenuSections()
        })
    });
};
/* harmony default export */ var sections_header_menu_component = (SectionsHeaderMenuComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-component.scss.js





var structured_header_menu_component_scss_SEPERATOR_RIGHT_MARGIN_PX = "".concat(SEPERATOR_RIGHT_MARGIN, "px");
var structured_header_menu_component_scss_SEPERATOR_LEFT_MARGIN_PX = "".concat(SEPERATOR_LEFT_MARGIN, "px");
var StyledStructuredHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1pegubm0"
})("width:100%;background-color:", colors/* default.white */.Z.white, ";display:flex;justify-content:center;&.with-left-panel{.structured-header-menu-content{padding-left:64px;}}.header-menu-section-item-component-wrapper{margin-left:-8px;}&.solutions,&.teams{.header-menu-section-items-wrapper{margin-top:16px;}}&.solutions,&.teams,&.platform{min-height:592px;}&.solutions,&.teams,&.customers,&.resources{.structured-header-menu\n    .structured-header-menu-top-part\n    .structured-header-menu-content\n    .header-menu-sections-wrapper{.header-menu-section-item-component-wrapper{margin-bottom:10px;}}}&.customers{.structured-header-menu\n    .structured-header-menu-top-part\n    .structured-header-menu-content\n    .header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:90px;&:nth-child(2){margin-right:30px;}}}}&.resources{.structured-header-menu\n    .structured-header-menu-top-part\n    .structured-header-menu-content\n    .header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:0px;&:nth-child(3){margin-right:30px;}.header-menu-section-title{margin-right:32px;}.header-menu-section-item-component-wrapper{margin-right:60px;}}}}.structured-header-menu{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;height:auto;display:flex;flex-direction:column;padding:0px 32px;.structured-header-menu-top-part{display:flex;height:100%;.structured-header-menu-content{width:100%;display:flex;.header-menu-sections-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;height:100%;display:flex;margin:auto;.sections-separator{border-right:1px solid;border-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";margin:0 ", structured_header_menu_component_scss_SEPERATOR_RIGHT_MARGIN_PX, " 0 ", structured_header_menu_component_scss_SEPERATOR_LEFT_MARGIN_PX, ";&.products{margin-right:80px;}&.mondayProducts{margin-right:64px;}}.header-menu-section-component-wrapper{padding:48px 0 0px;background-color:var(--section-background-color);min-height:400px;margin-right:32px;&.has-background-color{flex:1;padding-left:54px;padding-top:48px;padding-bottom:32px;}.header-menu-section-title{.header-menu-section-title-text{margin-bottom:10px;}&.with-underline .header-menu-section-title-text{margin-bottom:6px;}}.header-menu-section-item-component-wrapper{&.inner-menu-bottom-item{height:unset;}&.story{width:280px;&:hover{filter:drop-shadow(0px 8px 24px rgba(29,140,242,0.08));}img{height:115px;}}&.feature{width:286px;margin-right:18px;margin-bottom:10px;.menu-item-title-icon{background-color:transparent;}&:hover{.menu-item-title-icon{border-color:", colors/* default */.Z[color_consts.TRANSPARENT_COLOR_NAME], ";}}}&.integration,&.addOn{height:68px;width:208px;.header-menu-section-item-component{.header-menu-item-content{.menu-item-title-icon{margin-right:8px;}&.has-image-instead-title{flex-direction:row;gap:8px;.picture-component{display:flex;width:40px;height:40px;border:1px solid ", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";border-radius:4px;}}}svg{border:1px solid var(--icon-stroke-color);border-radius:4px;}}}}.header-menu-section-item-component{.header-menu-item-content{.menu-item-image-and-caption-wrapper{position:relative;.menu-item-image-floating-caption{position:absolute;bottom:12px;left:8px;padding:4px;background-color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";font-size:12px;border-radius:4px;color:white;margin-right:8px;}}}}}}}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){&.solutions,&.teams,&.platform{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-left-panel{min-width:304px;}.structured-header-menu-content{padding-left:40px;.header-menu-sections-wrapper{.header-menu-section-component-wrapper{&.features{margin-right:8px;}}}}}}}&.solutions,&.teams{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:8px;}}}}}}&.customers,&.resources{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:10px;.header-menu-section-component{.header-menu-section-items-wrapper{.header-menu-section-item-component-wrapper{margin-right:32px;margin-bottom:10px;}}}}}}}}}&.customers{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:20px;&:nth-child(2){margin-right:52x;}.header-menu-section-component{.header-menu-section-items-wrapper{.header-menu-section-item-component-wrapper{margin-right:20px;}}}}}}}}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){&.platform{.structured-header-menu{.structured-header-menu-top-part{.header-menu-section-item-component-wrapper{&.inner-menu-bottom-item{height:120px;.menu-item-description{-webkit-line-clamp:3;}}}}}}&.solutions,&.teams,&.platform{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{padding-left:38px;}.structured-header-menu-left-panel{min-width:250px;.structured-header-menu-left-panel-items{.inner-menu-item{.inner-menu-item-title{font-size:0.875rem;}.inner-menu-item-subitems{.inner-menu-item-subitem{font-size:0.875rem;.inner-menu-item-subitem-title-and-icon{gap:8px;}}}}}.header-menu-section-item-component-wrapper{&.inner-menu-bottom-item{width:216px;}}}}}}&.customers,&.resources{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:16px;.header-menu-section-component{.header-menu-section-items-wrapper{.header-menu-section-item-component-wrapper{width:274px;margin-right:0px;}}}}}}}}}&.customers{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{&:first-child{margin-right:20px;}&:nth-child(2){margin-right:22px;}.header-menu-section-component{.header-menu-section-items-wrapper{.header-menu-section-item-component-wrapper{margin-right:16px;}}}}}}}}}&.resources{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:26px;&:nth-child(3){margin-right:38px;}}}}}}}.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{&.has-background-color:last-child{padding-left:32px;}}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-content/structured-header-menu-content.scss.js


var StyledStructuredHeaderMenuContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erklsrt0"
})("display:flex;flex-direction:column;.structured-header-menu-content-title{font-size:1rem;color:", colors/* default.asphalt */.Z.asphalt, ';padding-top:48px;&:after{content:"";background:#323338;opacity:0.1;top:6px;display:block;position:relative;height:1px;margin-left:-8px;width:calc(100% - 40px);}}.header-menu-section-component-wrapper{.header-menu-sections-wrapper{display:flex;.header-menu-section-title{font-size:1rem;font-weight:300;}}&.integrations,&.addOns{.header-menu-section-items-wrapper{margin:8px 0 32px;}.header-menu-section-title{font-size:0.8125rem;font-weight:400;*{font-weight:400;}}}}');

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-content/structured-header-menu-content.js
function structured_header_menu_content_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function structured_header_menu_content_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            structured_header_menu_content_define_property(target, key, source[key]);
        });
    }
    return target;
}
function structured_header_menu_content_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function structured_header_menu_content_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        structured_header_menu_content_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var StructuredHeaderMenuContentComponent = function(props) {
    var menuId = props.menuId, id = props.id, _content = props.content, content = _content === void 0 ? {} : _content, translate = props.translate;
    var contentTitle = content.title, _menuSections = content.menuSections, menuSections = _menuSections === void 0 ? [] : _menuSections;
    var getStyle = function() {
        var backgroundColor = backgroundColor ? colors/* default */.Z[backgroundColor] : "transparent";
        return {
            "--section-background-color": backgroundColor
        };
    };
    var renderHeaderMenuSections = (0,react.useCallback)(function() {
        return menuSections.map(function(menuSection, index) {
            var backgroundColor = menuSection.backgroundColor, classname = menuSection.classname, noSeparator = menuSection.noSeparator, title = menuSection.title;
            var isLastItem = menuSections.length - 1 === index;
            var hasBackgroundColor = !!backgroundColor;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("header-menu-section-component-wrapper", classname, {
                            "has-background-color": hasBackgroundColor
                        }),
                        style: getStyle(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_component, structured_header_menu_content_object_spread_props(structured_header_menu_content_object_spread({}, menuSection), {
                            menuId: menuId
                        }))
                    }, title),
                    !isLastItem && !noSeparator && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("sections-separator", classname)
                    })
                ]
            });
        });
    }, [
        menuSections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStructuredHeaderMenuContentComponent, {
        className: "structured-header-menu-content",
        children: [
            contentTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "structured-header-menu-content-title",
                children: translate(contentTitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-menu-sections-wrapper",
                children: renderHeaderMenuSections()
            })
        ]
    });
};
/* harmony default export */ var structured_header_menu_content = ((0,generic_config_context/* withGenericConfig */.P)(StructuredHeaderMenuContentComponent));

;// CONCATENATED MODULE: ./static/svg/header/expand_arrow_1.svg
var expand_arrow_1_path;
function expand_arrow_1_extends() {
    expand_arrow_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return expand_arrow_1_extends.apply(this, arguments);
}

var SvgExpandArrow1 = function SvgExpandArrow1(props) {
    return /*#__PURE__*/ react.createElement("svg", expand_arrow_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 11,
        height: 8,
        fill: "none",
        viewBox: "0 0 14 11"
    }, props), expand_arrow_1_path || (expand_arrow_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#323338",
        d: "M0 .342h14L7.368 10.658z"
    })));
};
/* harmony default export */ var expand_arrow_1 = (SvgExpandArrow1);

// EXTERNAL MODULE: ./static/svg/arrow-right.svg
var arrow_right = __webpack_require__(6051);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./client/services/hooks/use-previous.js

function usePrevious(value) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        ref.current = value; // assign the value of ref to the argument
    }, [
        value
    ]); // this code will run when the value of 'value' changes
    return ref.current; // in the end, return the current ref value.
}
/* harmony default export */ var use_previous = (usePrevious);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-left-panel/structured-header-menu-left-panel.scss.js



var COLLAPSE_TRANSITION_DURATION_IN_MIL_SEC = 150;
var ARROW_TRANSITION = "".concat(COLLAPSE_TRANSITION_DURATION_IN_MIL_SEC, "ms transform ease-in-out");
var PANEL_TRANSITION = "".concat(COLLAPSE_TRANSITION_DURATION_IN_MIL_SEC, "ms max-height ease-in-out,").concat(COLLAPSE_TRANSITION_DURATION_IN_MIL_SEC, "ms margin ease-in-out");
var StyledStructuredHeaderMenuLeftPanelComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "enjqqrt0"
})("min-width:320px;padding:24px 24px 24px 0;box-shadow:32px 0 40px -32px rgba(29,140,242,0.16);display:flex;flex-direction:column;justify-content:space-between;.structured-header-menu-left-panel-items{display:flex;flex-direction:column;.inner-menu-item{display:flex;flex-direction:column;border-top:", "1px solid ".concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01]), ";// for keyboard focus outline visibility\n      margin:1px;&:last-child{border-bottom:1px solid ", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";}&.collapsed{.inner-menu-item-subitems{max-height:170px;margin:0 0 16px;}}.inner-menu-item-title{padding:16px 0;font-size:1rem;font-weight:400;display:flex;gap:8px;align-items:center;justify-content:space-between;.expand-arrow{transform:rotate(-90deg);transition:", ARROW_TRANSITION, ";display:flex;margin-right:14px;&.down-direction{transform:rotate(0deg);}}}.inner-menu-item-subitems{display:flex;flex-direction:column;margin:0px;max-height:0px;overflow:hidden;transition:", PANEL_TRANSITION, ";.inner-menu-item-subitem{display:flex;justify-content:space-between;font-size:1rem;line-height:40px;padding-left:8px;border-top-right-radius:8px;border-bottom-right-radius:8px;// for keyboard focus outline visibility\n          margin:1px;&.selected{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}.inner-menu-item-subitem-title-and-icon{align-items:center;display:flex;.inner-menu-item-subitem-title-icon{height:22px;width:22px;margin-right:16px;}.beta-tag{font-size:0.6875rem;font-weight:400;color:", colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_BACKGROUND_PINK], ";border-radius:2px;padding:1px 5px;line-height:normal;border-radius:32px;margin-left:4px;}}.inner-menu-item-subitem-title-arrow{margin-right:16px;.arrow-icon{path{fill:", colors/* default.asphalt */.Z.asphalt, ";}height:8px;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-left-panel/structured-header-menu-left-panel.js
function structured_header_menu_left_panel_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function structured_header_menu_left_panel_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            structured_header_menu_left_panel_define_property(target, key, source[key]);
        });
    }
    return target;
}













var SUB_ITEM_HOVER_DEBOUNCE_RATE = 1000; // 1sec
var SUB_ITEM_CHANGED_BY = {
    DEFAULT: "default",
    USER: "user"
};
var subItemHoverAction = function(param) {
    var menuItem = param.menuItem, subMenuItem = param.subMenuItem, changedBy = param.changedBy;
    (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_LEFT_PANEL_SUBITEM_CONTENT_VIEWED, {
        kind: subMenuItem.id,
        info1: menuItem.id,
        info3: changedBy
    });
};
var debounceOnHover = debounce_default()(function(param) {
    var menuItem = param.menuItem, subMenuItem = param.subMenuItem, changedBy = param.changedBy;
    return subItemHoverAction({
        menuItem: menuItem,
        subMenuItem: subMenuItem,
        changedBy: changedBy
    });
}, SUB_ITEM_HOVER_DEBOUNCE_RATE);
var StructuredHeaderMenuLeftPanelComponent = function(props) {
    var menu = props.menu, menuId = props.menuId, innerMenuIndex = props.innerMenuIndex, onItemClick = props.onItemClick, innerMenuSubIndex = props.innerMenuSubIndex, setInnerMenuIndex = props.setInnerMenuIndex, setInnerMenuSubIndex = props.setInnerMenuSubIndex, translate = props.translate, hasSubItems = props.hasSubItems, itemsCollapsedState = props.itemsCollapsedState, enhancedProducts = props.enhancedProducts;
    var bottomItem = menu.bottomItem;
    var prevInnerMenuSubIndex = use_previous(innerMenuSubIndex);
    var onLeftPanelItemClick = function(param) {
        var itemIndex = param.itemIndex;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_LEFT_PANEL_ITEM_CLICKED, {
            kind: menu.items[itemIndex].id,
            info2: menuId,
            info3: itemsCollapsedState[itemIndex]
        });
        onItemClick(itemIndex);
    };
    var onSubItemClick = function(param) {
        var itemIndex = param.itemIndex, subItemIndex = param.subItemIndex;
        setInnerMenuSubIndex(subItemIndex);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_LEFT_PANEL_SUBITEM_CLICKED, {
            kind: menu.items[itemIndex].subItems[subItemIndex].id,
            info2: menuId
        });
    };
    (0,react.useEffect)(function() {
        if (hasSubItems(innerMenuIndex)) {
            var changedBy = prevInnerMenuSubIndex === undefined ? SUB_ITEM_CHANGED_BY.DEFAULT : SUB_ITEM_CHANGED_BY.USER;
            debounceOnHover({
                menuItem: menu.items[innerMenuIndex],
                subMenuItem: menu.items[innerMenuIndex].subItems[innerMenuSubIndex],
                changedBy: changedBy
            });
        }
    }, [
        innerMenuSubIndex,
        innerMenuIndex
    ]);
    var onSubItemHover = function(param) {
        var itemIndex = param.itemIndex, subItemIndex = param.subItemIndex;
        setInnerMenuIndex(itemIndex);
        setInnerMenuSubIndex(subItemIndex);
    };
    var renderSubItem = function(param) {
        var itemIndex = param.itemIndex, subItem = param.subItem, subItemIndex = param.subItemIndex;
        var icon = subItem.icon, title = subItem.title, subtitle = subItem.subtitle, hasBetaTag = subItem.hasBetaTag;
        var Icon = icon;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("inner-menu-item-subitem", {
                selected: itemIndex === innerMenuIndex && subItemIndex === innerMenuSubIndex
            }),
            onClick: function() {
                onSubItemClick({
                    itemIndex: itemIndex,
                    subItemIndex: subItemIndex
                });
            },
            onMouseEnter: function() {
                onSubItemHover({
                    itemIndex: itemIndex,
                    subItemIndex: subItemIndex
                });
            },
            onKeyPress: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(function() {
                return onSubItemClick({
                    itemIndex: itemIndex,
                    subItemIndex: subItemIndex
                });
            }),
            tabIndex: itemIndex === innerMenuIndex ? 0 : -1,
            children: [
                !enhancedProducts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inner-menu-item-subitem-title-and-icon",
                            children: [
                                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    className: classnames_default()("inner-menu-item-subitem-title-icon")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translate(title)
                                }),
                                hasBetaTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "beta-tag",
                                    children: translate("header.tabs.solutions.byProduct.dev.beta")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner-menu-item-subitem-title-arrow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                                className: "arrow-icon"
                            })
                        })
                    ]
                }),
                enhancedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inner-menu-item-subitem-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inner-menu-item-subitem-title-icon-and-arrow",
                        children: [
                            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                className: classnames_default()("inner-menu-item-subitem-title-icon")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inner-menu-item-subitem-title-and-subtitle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "inner-menu-item-subitem-title",
                                        children: translate(title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inner-menu-item-subitem-subtitle",
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inner-menu-item-subitem-title-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                                    className: "arrow-icon"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    var isItemArrowPointingDown = function(itemIndex) {
        return hasSubItems(itemIndex) && itemsCollapsedState[itemIndex];
    };
    var isExpandableItem = function(itemIndex) {
        if (hasSubItems(itemIndex)) {
            return false;
        }
        return true;
    };
    var renderItem = function(param) {
        var item = param.item, itemIndex = param.itemIndex;
        var isItemSelected = itemIndex === innerMenuIndex;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("inner-menu-item", {
                selected: isItemSelected,
                collapsed: itemsCollapsedState[itemIndex]
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inner-menu-item-title",
                    onClick: function() {
                        return onLeftPanelItemClick({
                            itemIndex: itemIndex
                        });
                    },
                    onKeyPress: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(function() {
                        return onLeftPanelItemClick({
                            itemIndex: itemIndex
                        });
                    }),
                    tabIndex: 0,
                    children: [
                        translate(item === null || item === void 0 ? void 0 : item.title),
                        isExpandableItem(itemIndex) && /*#__PURE__*/ (0,jsx_runtime.jsx)(expand_arrow_1, {
                            className: classnames_default()("expand-arrow", {
                                "down-direction": isItemArrowPointingDown(itemIndex)
                            })
                        })
                    ]
                }),
                hasSubItems(itemIndex) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("inner-menu-item-subitems"),
                    children: item.subItems.map(function(subItem, subItemIndex) {
                        return renderSubItem({
                            itemIndex: itemIndex,
                            subItem: subItem,
                            subItemIndex: subItemIndex
                        });
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStructuredHeaderMenuLeftPanelComponent, {
        className: "structured-header-menu-left-panel",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "structured-header-menu-left-panel-items",
                children: menu.items.map(function(item, itemIndex) {
                    return renderItem({
                        item: item,
                        itemIndex: itemIndex
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: bottomItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_item_component, structured_header_menu_left_panel_object_spread({}, bottomItem))
            })
        ]
    });
};
/* harmony default export */ var structured_header_menu_left_panel = ((0,generic_config_context/* withGenericConfig */.P)(StructuredHeaderMenuLeftPanelComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part.scss.js



var StyledStructuredHeaderMenuBottomPartComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1pk6o4b0"
})("display:flex;padding:8px 0;border-top:", "1px solid ".concat(colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME]), ";.spacer{flex:1;}");

;// CONCATENATED MODULE: ./static/svg/header/customers/filled_star.svg
var filled_star_path, _path2, filled_star_g;
function filled_star_extends() {
    filled_star_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return filled_star_extends.apply(this, arguments);
}

var SvgFilledStar = function SvgFilledStar(props) {
    return /*#__PURE__*/ react.createElement("svg", filled_star_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14"
    }, props), filled_star_path || (filled_star_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#C3C6D4",
        fillRule: "evenodd",
        d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_2436_172234",
        width: 14,
        height: 13,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#C3C6D4",
        fillRule: "evenodd",
        d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
        clipRule: "evenodd"
    }))), filled_star_g || (filled_star_g = /*#__PURE__*/ react.createElement("g", {
        mask: "url(#mask0_2436_172234)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFCB00",
        d: "m-.026-1.986 14.209-.043.05 17-14.208.043z"
    }))));
};
/* harmony default export */ var filled_star = (SvgFilledStar);

;// CONCATENATED MODULE: ./static/svg/header/customers/partially_filled_star.svg
var partially_filled_star_path, partially_filled_star_path2, partially_filled_star_g;
function partially_filled_star_extends() {
    partially_filled_star_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return partially_filled_star_extends.apply(this, arguments);
}

var SvgPartiallyFilledStar = function SvgPartiallyFilledStar(props) {
    return /*#__PURE__*/ react.createElement("svg", partially_filled_star_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14"
    }, props), partially_filled_star_path || (partially_filled_star_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#C3C6D4",
        fillRule: "evenodd",
        d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_2436_172223",
        width: 14,
        height: 13,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, partially_filled_star_path2 || (partially_filled_star_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#C3C6D4",
        fillRule: "evenodd",
        d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
        clipRule: "evenodd"
    }))), partially_filled_star_g || (partially_filled_star_g = /*#__PURE__*/ react.createElement("g", {
        mask: "url(#mask0_2436_172223)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFCB00",
        d: "m-.026-1.986 8.823-.026.05 17-8.822.026z"
    }))));
};
/* harmony default export */ var partially_filled_star = (SvgPartiallyFilledStar);

;// CONCATENATED MODULE: ./static/svg/header/customers/g2.svg
var g2_path, g2_defs;
function g2_extends() {
    g2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return g2_extends.apply(this, arguments);
}

var SvgG2 = function SvgG2(props) {
    return /*#__PURE__*/ react.createElement("svg", g2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 34,
        height: 34,
        fill: "none",
        viewBox: "0 0 34 34"
    }, props), g2_path || (g2_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#pattern0)",
        d: "M0 0h34v34H0z"
    })), g2_defs || (g2_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("pattern", {
        id: "pattern0",
        width: 1,
        height: 1,
        patternContentUnits: "objectBoundingBox"
    }, /*#__PURE__*/ react.createElement("use", {
        xlinkHref: "#image0_2434_171328",
        transform: "scale(.0039)"
    })), /*#__PURE__*/ react.createElement("image", {
        xlinkHref: "data:image/png;base64,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",
        id: "image0_2434_171328",
        width: 256,
        height: 256
    }))));
};
/* harmony default export */ var g2 = (SvgG2);

;// CONCATENATED MODULE: ./static/svg/header/customers/Trustradius.svg
var Trustradius_path, Trustradius_path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, Trustradius_defs;
function Trustradius_extends() {
    Trustradius_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return Trustradius_extends.apply(this, arguments);
}

var SvgTrustradius = function SvgTrustradius(props) {
    return /*#__PURE__*/ react.createElement("svg", Trustradius_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 112,
        height: 19,
        fill: "none",
        viewBox: "0 0 112 19"
    }, props), Trustradius_path || (Trustradius_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_2434_171178)",
        d: "M8.98.056c.075.037.15.074.206.13l3.223 3.223c.13.13.205.299.205.485v14.868c0 .13-.093.224-.224.224a.2.2 0 0 1-.149-.056l-3.037-3.037A.68.68 0 0 1 9 15.41V.056z"
    })), Trustradius_path2 || (Trustradius_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_2434_171178)",
        d: "M17.85.205a.8.8 0 0 1 .205-.15V15.41a.68.68 0 0 1-.205.484l-3.037 3.037a.214.214 0 0 1-.373-.149V3.913c0-.168.075-.354.205-.466z"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint2_linear_2434_171178)",
        d: "m23.7 12.018-.223-.224V8.627h-3.075a.23.23 0 0 0-.168.074l-2.198 2.2 7.043 7.06a.66.66 0 0 0 .484.187h3.708c.13 0 .224-.093.224-.224a.2.2 0 0 0-.056-.149z"
    })), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint3_linear_2434_171178)",
        d: "M18.316 0a.68.68 0 0 0-.485.205l-3.223 3.223c-.056.056-.093.13-.13.187h8.999v8.16L23.7 12l3.205-3.186a.68.68 0 0 0 .205-.484V3.913a.68.68 0 0 0-.205-.485L23.682.205A.68.68 0 0 0 23.197 0z"
    })), _path5 || (_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint4_linear_2434_171178)",
        d: "M9.167.205A.68.68 0 0 0 8.683 0H.223A.215.215 0 0 0 0 .224C0 .279.019.335.075.39l3.037 3.037c.13.13.298.205.484.205h8.57c.243 0 .448.205.448.447v-.167a.68.68 0 0 0-.205-.485z"
    })), _path6 || (_path6 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint5_linear_2434_171178)",
        d: "M17.831.205A.68.68 0 0 1 18.316 0h4.881c.187 0 .354.075.485.205l3.223 3.223c.13.13.205.298.205.485v.167a.453.453 0 0 0-.447-.447H14.887a.453.453 0 0 0-.447.447v-.167c0-.187.075-.354.205-.485z"
    })), _path7 || (_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint6_linear_2434_171178)",
        d: "M27.11 8.161a.453.453 0 0 1-.447.447h-6.074a.12.12 0 0 0-.112.112c0 .037.019.056.037.075l3.205 3.204 3.205-3.186a.68.68 0 0 0 .205-.484V8.16z"
    })), _path8 || (_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint7_linear_2434_171178)",
        d: "M111.794 12.15c0-1.528-.876-2.105-3.019-2.646-1.286-.317-1.621-.577-1.621-1.025s.41-.745 1.248-.745c.932.037 1.826.28 2.646.727l.261-1.64a7.4 7.4 0 0 0-2.907-.577c-1.937 0-3.074.987-3.074 2.366 0 1.49.839 2.05 2.851 2.553 1.397.335 1.789.559 1.789 1.155 0 .54-.541.875-1.491.875a6.1 6.1 0 0 1-3.074-.95l-.261 1.658a7.55 7.55 0 0 0 3.242.783c2.236 0 3.41-.95 3.41-2.534m-7.621 2.366v-8.16h-1.975v5.533c-.652.634-1.342 1.044-2.031 1.044-.801 0-1.137-.485-1.137-1.211V6.337h-1.975v5.888c0 1.509.839 2.422 2.441 2.422 1.118 0 2.031-.578 2.832-1.305l.28 1.137zm-8.31 0v-8.16h-1.956v8.16zm-.969-11.738a1.13 1.13 0 0 1 1.137 1.137 1.13 1.13 0 0 1-1.137 1.136 1.13 1.13 0 0 1-1.137-1.136 1.13 1.13 0 0 1 1.137-1.137m-4.118 9.018c-.577.708-1.21 1.155-2.012 1.155-.987 0-1.714-.764-1.714-2.366 0-1.789.857-2.665 2.012-2.665a3.8 3.8 0 0 1 1.714.355zm1.957 2.72V2.386l-1.957.336v3.932a6.5 6.5 0 0 0-1.993-.317c-1.975 0-3.727 1.341-3.727 4.36 0 2.72 1.435 3.987 3.224 3.987 1.192 0 2.012-.596 2.627-1.286l.167 1.118zM82.28 12.28a3.15 3.15 0 0 1-2.087.913c-.67 0-1.1-.372-1.1-.95 0-.782.616-1.472 3.206-1.77v1.807zm1.956 2.236V8.964c0-1.92-1.043-2.702-3.204-2.702a8.8 8.8 0 0 0-3.317.652l.242 1.565a7.9 7.9 0 0 1 2.851-.652c.932 0 1.49.336 1.49 1.211V9.3c-3.465.336-5.142 1.174-5.142 3.13 0 1.398.969 2.236 2.422 2.236a4 4 0 0 0 2.851-1.21l.186 1.043h1.621zm-7.415-.298-3.13-4.267c1.416-.447 2.347-1.434 2.347-3.037 0-2.086-1.509-3.279-4.006-3.279h-3.447v10.881h2.031v-4.21h.988l3.055 4.304zm-2.814-7.192c0 1.137-.857 1.752-2.236 1.752h-1.155V5.312h1.267c1.398.019 2.124.633 2.124 1.714m-6.446 7.49-.243-1.62a4.4 4.4 0 0 1-.708.055c-.8 0-1.118-.354-1.118-1.025V7.94h2.069l-.336-1.584h-1.733V3.523l-1.937.336v2.496h-1.323V7.94h1.323v4.304c0 1.826 1.08 2.385 2.701 2.385.448.019.876-.018 1.305-.112m-5.74-2.366c0-1.528-.875-2.105-3.018-2.646-1.285-.317-1.62-.577-1.62-1.025s.41-.745 1.248-.745c.931.037 1.826.28 2.646.727l.279-1.64a7.4 7.4 0 0 0-2.907-.577c-1.937 0-3.074.987-3.074 2.366 0 1.49.839 2.05 2.85 2.553 1.398.335 1.79.559 1.79 1.155 0 .54-.54.875-1.491.875a5.9 5.9 0 0 1-3.037-.95l-.28 1.658a7.6 7.6 0 0 0 3.261.783c2.18 0 3.354-.95 3.354-2.534m-7.508 2.366v-8.16h-1.975v5.533c-.652.634-1.342 1.044-2.03 1.044-.802 0-1.138-.485-1.138-1.211V6.337h-1.974v5.888c0 1.509.838 2.422 2.44 2.422 1.118 0 2.031-.578 2.832-1.305l.28 1.137zm-8.05-6.353-.446-1.92c-1.249.224-1.994.876-2.572 1.808l-.372-1.696H41.4v8.161h1.919V9.858a3.83 3.83 0 0 1 2.944-1.695"
    })), _path9 || (_path9 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint8_linear_2434_171178)",
        d: "m42.63 5.44-.446-1.807H32.55V5.44h3.633v9.074h2.031V5.44z"
    })), Trustradius_defs || (Trustradius_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2434_171178",
        x1: 10.804,
        x2: 10.804,
        y1: 18.99,
        y2: 0.052,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.71,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_2434_171178",
        x1: 16.247,
        x2: 16.247,
        y1: 18.994,
        y2: 0.056,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.71,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint2_linear_2434_171178",
        x1: 19.739,
        x2: 28.604,
        y1: 8.983,
        y2: 17.847,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.41,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#185DEC"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint3_linear_2434_171178",
        x1: 20.755,
        x2: 20.755,
        y1: 11.999,
        y2: -0.112,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.58,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint4_linear_2434_171178",
        x1: 8.445,
        x2: 4.837,
        y1: -0.19,
        y2: 3.418,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.03,
        stopColor: "#59C5FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.99,
        stopColor: "#21B1FF"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint5_linear_2434_171178",
        x1: 17.512,
        x2: 21.12,
        y1: 0.759,
        y2: 4.367,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.04,
        stopColor: "#59C5FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.99,
        stopColor: "#21B1FF"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint6_linear_2434_171178",
        x1: 25.606,
        x2: 22.879,
        y1: 10.271,
        y2: 7.544,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.04,
        stopColor: "#57C4FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.99,
        stopColor: "#21B1FF"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint7_linear_2434_171178",
        x1: 41.401,
        x2: 111.794,
        y1: 8.535,
        y2: 8.535,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.71,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint8_linear_2434_171178",
        x1: 32.551,
        x2: 42.631,
        y1: 9.073,
        y2: 9.073,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.71,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })))));
};
/* harmony default export */ var Trustradius = (SvgTrustradius);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part-components/social-proof-component.scss.js


var StyledSocialProofComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18amlmu0"
})("display:flex;align-items:center;font-size:0.75rem;font-weight:400;color:", colors/* default.asphalt */.Z.asphalt, ";gap:8px;.stars{display:flex;}.logo-wrapper{height:19px;display:flex;align-items:center;}.reviews-text{white-space:nowrap;}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part-components/social-proof-component.js







var SocialProofComponent = function(param) {
    var translate = param.translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSocialProofComponent, {
        className: "social-proof-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "stars",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filled_star, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filled_star, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filled_star, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filled_star, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partially_filled_star, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "reviews-text",
                children: translate("header.tabs.customers.section.bottomPart.socialProofText")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "logo-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(g2, {
                    height: "19",
                    width: "19"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "logo-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trustradius, {
                    height: "15",
                    width: "auto"
                })
            })
        ]
    });
};
/* harmony default export */ var social_proof_component = ((0,generic_config_context/* withGenericConfig */.P)(SocialProofComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part-components/bottom-items-component.scss.js



var StyledBottomItemsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg0qsbv0"
})("display:flex;width:375px;justify-content:center;.bottom-items{display:flex;align-items:center;.separator{width:1px;height:50%;background:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}.header-menu-section-item-component-wrapper{width:auto;height:auto;padding:0 16px;margin:0 8px;.header-menu-section-item-component{font-size:0.8125rem;color:", colors/* default.asphalt */.Z.asphalt, ";display:flex;align-items:center;gap:8px;height:24px;.header-menu-item-content{align-items:center;.menu-item-title-icon{margin-right:8px;height:14px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part-components/bottom-items-component.js
function bottom_items_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bottom_items_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bottom_items_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function bottom_items_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function bottom_items_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        bottom_items_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var BottomItemsComponent = function(props) {
    var items = props.items, menuId = props.menuId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomItemsComponent, {
        className: "bottom-items-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bottom-items",
            children: items.map(function(bottomItem, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        index !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "separator"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_item_component, bottom_items_component_object_spread_props(bottom_items_component_object_spread({}, bottomItem), {
                            menuId: menuId
                        }))
                    ]
                });
            })
        })
    });
};
/* harmony default export */ var bottom_items_component = (BottomItemsComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part.js





var StructuredHeaderMenuBottomPartComponent = function(props) {
    var menuId = props.menuId, panel = props.panel;
    var items = panel.bottomItems, isSocialProofDisplayed = panel.isSocialProofDisplayed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStructuredHeaderMenuBottomPartComponent, {
        className: "structured-header-menu-bottom-part-component",
        children: [
            isSocialProofDisplayed && /*#__PURE__*/ (0,jsx_runtime.jsx)(social_proof_component, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "spacer"
            }),
            items && /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_items_component, {
                menuId: menuId,
                items: items
            })
        ]
    });
};
/* harmony default export */ var structured_header_menu_bottom_part = ((0,generic_config_context/* withGenericConfig */.P)(StructuredHeaderMenuBottomPartComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-component.js







var DEAFULT_INNER_MENU_INDEX = 0;
var DEAFULT_INNER_MENU_SUB_INDEX = 0;
var StructuredHeaderMenuComponent = function(props) {
    var ref = (0,react.useState)(DEAFULT_INNER_MENU_INDEX), innerMenuIndex = ref[0], setInnerMenuIndex = ref[1];
    var ref1 = (0,react.useState)(DEAFULT_INNER_MENU_SUB_INDEX), innerMenuSubIndex = ref1[0], setInnerMenuSubIndex = ref1[1];
    var ref2 = (0,react.useState)([
        true,
        true
    ]), itemsCollapsedState = ref2[0], setItemsCollapsedState = ref2[1];
    var menuItems = props.menuItems, menuId = props.menuId, enhancedProducts = props.enhancedProducts;
    var content = menuItems.content, innerMenu = menuItems.innerMenu;
    var onItemClick = function(menuIndex) {
        setInnerMenuIndex(menuIndex);
    // Temp. preventing collapsing until clear test results
    // setItemsCollapsedState(itemsCollapsedState.map((isCollapsed, index) => index === menuIndex ? !isCollapsed : false ))
    };
    var hasSubItems = function(itemIndex) {
        return innerMenu.items[itemIndex] && innerMenu.items[itemIndex].subItems;
    };
    var getContent = function() {
        if (!innerMenu) {
            return content;
        }
        var items = innerMenu.items;
        // inner content will be displayed if exists
        if (items) {
            var currentItem = items[innerMenuIndex];
            if (hasSubItems(innerMenuIndex)) {
                var currentSubItem = currentItem.subItems[innerMenuSubIndex];
                return currentSubItem.content;
            }
            return currentItem.content;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStructuredHeaderMenuComponent, {
        className: classnames_default()("structured-header-menu-component", menuId, {
            "with-left-panel": innerMenu
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "structured-header-menu",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "structured-header-menu-top-part",
                    children: [
                        innerMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(structured_header_menu_left_panel, {
                            menu: innerMenu,
                            hasSubItems: hasSubItems,
                            innerMenuIndex: innerMenuIndex,
                            innerMenuSubIndex: innerMenuSubIndex,
                            itemsCollapsedState: itemsCollapsedState,
                            onItemClick: onItemClick,
                            setInnerMenuIndex: setInnerMenuIndex,
                            setInnerMenuSubIndex: setInnerMenuSubIndex,
                            menuId: menuId,
                            enhancedProducts: enhancedProducts
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(structured_header_menu_content, {
                            menuId: menuId,
                            content: getContent()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "structured-header-menu-bottom-part",
                    children: menuItems.bottomPanel && /*#__PURE__*/ (0,jsx_runtime.jsx)(structured_header_menu_bottom_part, {
                        menuId: menuId,
                        panel: menuItems.bottomPanel
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var structured_header_menu_component = (StructuredHeaderMenuComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/index.js



/* harmony default export */ var header_menu = ({
    BaseHeaderMenuComponent: BaseHeaderMenuComponent,
    SectionsHeaderMenuComponent: sections_header_menu_component,
    StructuredHeaderMenuComponent: structured_header_menu_component
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/structured-header/structured-header.scss.js



var StyledStructuredHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", {
    target: "e15gf1e10"
})(".products-switcher-open-button{cursor:pointer;margin-left:16px;border-radius:4px;.picture-component{display:flex;height:40px;width:40px;}&.show-switcher{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}}.menu-component-wrapper.short-menu{margin:auto;width:fit-content;}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/structured-header/const.js
var PRODUCTS_SWITCHER_LOGO = "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/switcher-icon-hp.png";
var PRODUCTS_SWITCHER_LOGO_DARK = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/Switcher.png";

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/short-header-menu-component.scss.js



var HEADER_HEIGHT = 450;
var HEADER_WIDTH = 1040;
var StyledShortHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e62g9dl0"
})("background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";height:", HEADER_HEIGHT, "px;width:", HEADER_WIDTH, "px;justify-self:center;border-radius:0 0 8px 8px;overflow:hidden;box-shadow:0 6px 12px 0 rgba(0,0,0,0.08);display:flex;flex-direction:column;.menu-component{display:flex;height:inherit;gap:32px;justify-content:stretch;padding:48px 0 48px 64px;.align-to-link{margin-left:8px;}.section-title{font-size:1.25rem;line-height:32px;}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/action-bar/action-bar.scss.js



var StyledActionBar = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1oicq8v0"
})("display:flex;justify-content:flex-end;background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";padding:16px 32px;gap:24px;.contact-sales-wrapper{.button{.secondary-button{a{background:none;.secondary-button-text{font-size:0.875rem;line-height:14px;color:black;}}}}}.cta-wrapper{display:flex;align-items:center;.button .signup-button{svg{height:10px;width:12px;}&.ladda-button{background-color:transparent;}font-size:0.875rem;line-height:14px;height:fit-content;padding:0;background-color:transparent;color:black;&:hover{background-color:transparent;color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}.signup-button{padding:0;min-width:unset;&:hover{background-color:transparent;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/menu-divider/menu-divider.scss.js



var StyledMenuDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ef9yry60"
})("width:1px;background-color:", colors/* default */.Z[color_consts.GAINSBORO_COLOR_NAME], ";margin:0;&.horizontal{height:1px;width:100%;}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/menu-divider/menu-divider.js



var MenuDivider = function(param) {
    var isHorizontal = param.isHorizontal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuDivider, {
        className: classnames_default()("menu-divider", {
            horizontal: isHorizontal
        })
    });
};
/* harmony default export */ var menu_divider = (MenuDivider);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/action-bar/action-bar.js








var SIGN_UP_LOCATION = "header-bottom-bar";
var ActionBar = function(param) {
    var translate = param.translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActionBar, {
        className: "action-bar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cta-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, {
                    buttonType: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
                    buttonSpinnerColor: colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME],
                    extraData: {
                        location: SIGN_UP_LOCATION
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "contact-sales-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, {
                    buttonType: button_consts/* SECONDARY_BUTTON_TYPE */.jE,
                    buttonText: translate("header.contactSales"),
                    url: links/* CONTACT_US_FROM_HEADER_PAGE_LINK */.lij,
                    extraEventData: {
                        englishText: "Contact sales",
                        location: SIGN_UP_LOCATION
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var action_bar = (ActionBar);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/products-menu-component.scss.js

var StyledProductsMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eerh77s0"
})(".platform-section{display:flex;flex-direction:column;gap:32px;.links-container{display:flex;flex-direction:column;gap:8px;width:256px;}}.products-section{display:flex;flex-direction:column;gap:24px;.products-container{display:grid;grid-template-columns:repeat(2,1fr);grid-column-gap:20px;grid-row-gap:12px;margin-right:40px;.descriptive-link-block{width:296px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dev-icon.js

var DevIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00C875"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.0823 18.6854C20.5179 18.735 18.4564 20.8272 18.4564 23.4035C18.4564 25.9776 20.5142 28.0683 23.0754 28.1215V28.1265H36.7881V28.1226H37.3272V28.1318C37.6002 28.1415 37.8758 28.2482 38.1023 28.4736L40.3903 30.7488C40.8499 31.2059 40.8499 31.9497 40.3903 32.4069L38.1023 34.6821C37.8288 34.9541 37.4838 35.0534 37.1581 35.0175H23.1755C23.1434 35.0175 23.1113 35.0174 23.0793 35.0171L23.0184 35.0174L22.9874 35.0175H22.1198C15.174 34.1911 12.5243 28.596 11.9373 26.2484L11.9138 26.2543C11.6837 25.3422 11.5615 24.3872 11.5615 23.4035C11.5615 17.1265 16.5381 12.0145 22.7619 11.7968C22.8364 11.792 22.9116 11.7896 22.9874 11.7896C23.0195 11.7896 23.0516 11.7897 23.0837 11.7899C23.1142 11.7897 23.1448 11.7896 23.1755 11.7896C23.2504 11.7896 23.3248 11.792 23.3986 11.7967C29.6235 12.0132 34.6014 17.1257 34.6014 23.4035C34.6014 24.3701 34.4833 25.309 34.261 26.2068H26.7847C27.364 25.4231 27.7064 24.4535 27.7064 23.4035C27.7064 20.8277 25.6459 18.7359 23.0823 18.6854ZM10.5349 28.1225H10.1848C8.28079 28.1225 6.7373 29.666 6.7373 31.57C6.7373 33.474 8.28079 35.0175 10.1848 35.0175H16.2326C13.0984 33.1003 11.3599 30.2109 10.5349 28.1225Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/service-icon.js

var ServiceIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#FA4270"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.661 14.8509C13.2565 15.8638 12.084 18.3982 13.1735 20.9858C14.5822 24.3309 20.7807 26.2303 21.0722 26.2728C21.334 26.3133 21.6404 26.1622 21.6404 25.8728C21.6404 25.5834 21.0722 23.1797 21.0722 23.0094C21.0722 22.8392 21.168 22.686 21.3318 22.6179C21.4957 22.5498 28.6837 19.5026 31.0669 18.5003C33.4502 17.4981 34.5801 14.7999 33.5544 12.3655C32.5288 9.93115 29.8157 8.86931 27.4197 9.87795C25.0237 10.8866 18.0655 13.8402 15.661 14.8509Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.3122 33.1464C34.7167 32.1335 35.8892 29.5992 34.7997 27.0116C33.391 23.6665 27.1925 21.7795 26.901 21.7369C26.6392 21.6965 26.3328 21.8476 26.3328 22.1369C26.3328 22.4263 26.901 24.8177 26.901 24.9879C26.901 25.1582 26.8052 25.3114 26.6414 25.3795C26.4775 25.4476 19.2895 28.4948 16.9063 29.497C14.523 30.4993 13.3931 33.1975 14.4188 35.6319C15.4444 38.0684 18.1575 39.1281 20.5535 38.1194C22.9516 37.1108 29.9077 34.1572 32.3122 33.1464Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/crm-icon.js

var CRMIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00D2D2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.1191 33.3844C23.4528 32.8913 22.8451 32.3152 22.3121 31.6657C21.0172 30.0879 20.233 28.1619 20.0508 26.1428L30.1529 26.1427C30.6563 26.1424 31.0642 25.7343 31.0642 25.2309C31.0642 23.1705 30.5318 21.1326 29.5028 19.321C28.6751 17.8636 27.5569 16.6074 26.23 15.6224C27.2036 15.3011 28.2443 15.1272 29.3257 15.1272C34.7769 15.1272 39.1959 19.5463 39.1959 24.9975C39.1959 30.4487 34.7769 34.8677 29.3257 34.8677C27.4147 34.8677 25.6305 34.3246 24.1191 33.3844Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.87793 25.2303C8.87793 19.6285 13.4191 15.0874 19.0208 15.0874C20.8485 15.0874 22.5608 15.57 24.0401 16.4142C24.0569 16.4254 24.0741 16.4362 24.0918 16.4463C25.6464 17.3439 26.9437 18.6434 27.8397 20.2208C28.5597 21.4884 28.9928 22.8867 29.122 24.3186H19.0204C18.5168 24.3186 18.1087 24.7268 18.1087 25.2304C18.1087 27.9988 19.0686 30.6817 20.8249 32.8218C21.3919 33.5127 22.0306 34.1332 22.727 34.675C21.5796 35.1256 20.3298 35.3732 19.0208 35.3732C13.4191 35.3732 8.87793 30.8321 8.87793 25.2303Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/wm-icon.js

var WmIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "8.08909",
                fill: "#6C6CFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.6134 27.0611C25.382 27.0611 26.8158 25.6274 26.8158 23.8588C26.8158 22.0902 25.382 20.6565 23.6134 20.6565C21.8449 20.6565 20.4111 22.0902 20.4111 23.8588C20.4111 25.6274 21.8449 27.0611 23.6134 27.0611Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.6134 16.078C25.382 16.078 26.8158 14.6442 26.8158 12.8757C26.8158 11.1071 25.382 9.67334 23.6134 9.67334C21.8449 9.67334 20.4111 11.1071 20.4111 12.8757C20.4111 14.6442 21.8449 16.078 23.6134 16.078Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1652 23.669C14.9338 23.669 16.3675 22.2353 16.3675 20.4667C16.3675 18.6981 14.9338 17.2644 13.1652 17.2644C11.3966 17.2644 9.96289 18.6981 9.96289 20.4667C9.96289 22.2353 11.3966 23.669 13.1652 23.669Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.1545 35.9488C18.9231 35.9488 20.3568 34.5151 20.3568 32.7465C20.3568 30.9779 18.9231 29.5442 17.1545 29.5442C15.3859 29.5442 13.9521 30.9779 13.9521 32.7465C13.9521 34.5151 15.3859 35.9488 17.1545 35.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.0656 35.9488C31.8342 35.9488 33.2679 34.5151 33.2679 32.7465C33.2679 30.9779 31.8342 29.5442 30.0656 29.5442C28.297 29.5442 26.8633 30.9779 26.8633 32.7465C26.8633 34.5151 28.297 35.9488 30.0656 35.9488Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.0597 23.669C35.8283 23.669 37.2621 22.2353 37.2621 20.4667C37.2621 18.6981 35.8283 17.2644 34.0597 17.2644C32.2911 17.2644 30.8574 18.6981 30.8574 20.4667C30.8574 22.2353 32.2911 23.669 34.0597 23.669Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/ai-icon.js

var AIIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "path-1-inside-1_589_3088",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.7196 3.83214L17.0691 4.2596C17.1738 4.29261 17.2451 4.38989 17.2451 4.49985C17.2451 4.60981 17.1738 4.7068 17.0691 4.74011L15.7196 5.16786C15.5737 5.21414 15.4594 5.32852 15.4131 5.47444L14.9854 6.82401C14.9523 6.92866 14.8551 7 14.7451 7C14.6352 7 14.5382 6.92866 14.5049 6.82401L14.0772 5.47444C14.0309 5.32852 13.9165 5.21414 13.7706 5.16786L12.4211 4.74011C12.3165 4.70709 12.2451 4.60952 12.2451 4.49985C12.2451 4.39019 12.3165 4.29291 12.4211 4.2596L13.7706 3.83214C13.9165 3.78586 14.0309 3.67148 14.0772 3.52556L14.5049 2.17599C14.5379 2.07134 14.6352 2 14.7451 2C14.8551 2 14.952 2.07134 14.9854 2.17599L15.4131 3.52556C15.4594 3.67148 15.5737 3.78586 15.7196 3.83214ZM11.4327 10.0881L14.8032 11.1557C15.0645 11.2381 15.2427 11.4811 15.2427 11.7557C15.2427 12.0304 15.0645 12.2726 14.8032 12.3558L11.4327 13.4241C11.0683 13.5397 10.7827 13.8254 10.6671 14.1898L9.5988 17.5605C9.51635 17.8218 9.27339 18 8.99878 18C8.72417 18 8.48196 17.8218 8.39877 17.5605L7.33051 14.1898C7.21492 13.8254 6.92926 13.5397 6.56483 13.4241L3.19441 12.3558C2.93305 12.2733 2.75488 12.0296 2.75488 11.7557C2.75488 11.4818 2.93305 11.2389 3.19441 11.1557L6.56483 10.0881C6.92926 9.97251 7.21492 9.68683 7.33051 9.32238L8.39877 5.95176C8.48122 5.69038 8.72417 5.51221 8.99878 5.51221C9.27339 5.51221 9.51561 5.69038 9.5988 5.95176L10.6671 9.32238C10.7827 9.68683 11.0683 9.97251 11.4327 10.0881Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.0691 4.2596L16.6917 5.45125L16.693 5.45167L17.0691 4.2596ZM15.7196 3.83214L15.3417 5.02364L15.3422 5.02379L15.7196 3.83214ZM17.0691 4.74011L17.4468 5.93168L17.4483 5.93122L17.0691 4.74011ZM15.7196 5.16786L15.342 3.97628L15.3417 3.97636L15.7196 5.16786ZM15.4131 5.47444L14.2216 5.09655L14.2215 5.09679L15.4131 5.47444ZM14.9854 6.82401L13.7938 6.44635L13.7933 6.44794L14.9854 6.82401ZM14.5049 6.82401L13.3133 7.20166L13.3138 7.20312L14.5049 6.82401ZM14.0772 5.47444L15.2687 5.09679L15.2687 5.09654L14.0772 5.47444ZM13.7706 5.16786L14.1485 3.97636L14.1483 3.97628L13.7706 5.16786ZM12.4211 4.74011L12.7988 3.54853L12.7972 3.54804L12.4211 4.74011ZM12.4211 4.2596L12.0436 3.06795L12.0419 3.06849L12.4211 4.2596ZM13.7706 3.83214L14.148 5.02379L14.1485 5.02364L13.7706 3.83214ZM14.0772 3.52556L15.2687 3.90346L15.2687 3.90321L14.0772 3.52556ZM14.5049 2.17599L15.6965 2.55364L15.697 2.55206L14.5049 2.17599ZM14.9854 2.17599L16.1769 1.79834L16.1765 1.79687L14.9854 2.17599ZM15.4131 3.52556L14.2215 3.90321L14.2216 3.90345L15.4131 3.52556ZM14.8032 11.1557L14.4257 12.3473L14.4271 12.3478L14.8032 11.1557ZM11.4327 10.0881L11.0548 11.2796L11.0553 11.2797L11.4327 10.0881ZM14.8032 12.3558L15.1809 13.5474L15.1823 13.5469L14.8032 12.3558ZM11.4327 13.4241L11.055 12.2325L11.0548 12.2326L11.4327 13.4241ZM10.6671 14.1898L9.47555 13.8119L9.47548 13.8122L10.6671 14.1898ZM9.5988 17.5605L8.40722 17.1828L8.40672 17.1844L9.5988 17.5605ZM8.39877 17.5605L7.20718 17.9381L7.20765 17.9396L8.39877 17.5605ZM7.33051 14.1898L8.52209 13.8122L8.52202 13.8119L7.33051 14.1898ZM6.56483 13.4241L6.94277 12.2326L6.94253 12.2325L6.56483 13.4241ZM3.19441 12.3558L3.5721 11.1642L3.57052 11.1637L3.19441 12.3558ZM3.19441 11.1557L2.81695 9.96403L2.81524 9.96458L3.19441 11.1557ZM6.56483 10.0881L6.94229 11.2797L6.94277 11.2796L6.56483 10.0881ZM7.33051 9.32238L8.52202 9.70027L8.52209 9.70003L7.33051 9.32238ZM8.39877 5.95176L9.59035 6.32941L9.59085 6.32783L8.39877 5.95176ZM9.5988 5.95176L10.7904 5.57411L10.7899 5.57263L9.5988 5.95176ZM10.6671 9.32238L9.47548 9.70003L9.47555 9.70027L10.6671 9.32238ZM17.4466 3.06795L16.0971 2.6405L15.3422 5.02379L16.6917 5.45124L17.4466 3.06795ZM18.4951 4.49985C18.4951 3.84494 18.0706 3.26482 17.4453 3.06752L16.693 5.45167C16.277 5.3204 15.9951 4.93484 15.9951 4.49985H18.4951ZM17.4483 5.93122C18.0687 5.73371 18.4951 5.15708 18.4951 4.49985H15.9951C15.9951 4.06254 16.2788 3.67988 16.69 3.549L17.4483 5.93122ZM16.0973 6.35943L17.4468 5.93168L16.6914 3.54854L15.342 3.97628L16.0973 6.35943ZM16.6046 5.85233C16.528 6.09371 16.339 6.28278 16.0976 6.35935L15.3417 3.97636C14.8085 4.1455 14.3907 4.56333 14.2216 5.09655L16.6046 5.85233ZM16.1769 7.20166L16.6047 5.85209L14.2215 5.09679L13.7938 6.44636L16.1769 7.20166ZM14.7451 8.25C15.4001 8.25 15.9802 7.82535 16.1774 7.20007L13.7933 6.44794C13.9245 6.03197 14.31 5.75 14.7451 5.75V8.25ZM13.3138 7.20312C13.5112 7.82349 14.0878 8.25 14.7451 8.25V5.75C15.1826 5.75 15.5652 6.03383 15.696 6.44489L13.3138 7.20312ZM12.8856 5.85209L13.3133 7.20166L15.6965 6.44636L15.2687 5.09679L12.8856 5.85209ZM13.3927 6.35935C13.1512 6.28278 12.9622 6.09371 12.8856 5.85234L15.2687 5.09654C15.0996 4.56333 14.6818 4.1455 14.1485 3.97636L13.3927 6.35935ZM12.0434 5.93168L13.3929 6.35943L14.1483 3.97628L12.7988 3.54854L12.0434 5.93168ZM10.9951 4.49985C10.9951 5.15361 11.4188 5.73463 12.045 5.93218L12.7972 3.54804C13.2141 3.67956 13.4951 4.06542 13.4951 4.49985H10.9951ZM12.0419 3.06849C11.4207 3.26625 10.9951 3.84377 10.9951 4.49985H13.4951C13.4951 4.93661 13.2122 5.31956 12.8003 5.4507L12.0419 3.06849ZM13.3931 2.6405L12.0436 3.06795L12.7986 5.45124L14.148 5.02379L13.3931 2.6405ZM12.8856 3.14766C12.9622 2.90629 13.1512 2.71722 13.3927 2.64065L14.1485 5.02364C14.6818 4.8545 15.0996 4.43667 15.2687 3.90346L12.8856 3.14766ZM13.3133 1.79834L12.8856 3.14791L15.2687 3.90321L15.6965 2.55364L13.3133 1.79834ZM14.7451 0.75C14.0901 0.75 13.51 1.17467 13.3128 1.79993L15.697 2.55206C15.5657 2.96801 15.1802 3.25 14.7451 3.25V0.75ZM16.1765 1.79687C15.979 1.17649 15.4024 0.75 14.7451 0.75V3.25C14.3077 3.25 13.9251 2.96619 13.7942 2.55512L16.1765 1.79687ZM16.6047 3.14791L16.1769 1.79834L13.7938 2.55364L14.2215 3.90321L16.6047 3.14791ZM16.0976 2.64065C16.339 2.71722 16.528 2.90629 16.6046 3.14767L14.2216 3.90345C14.3907 4.43667 14.8085 4.8545 15.3417 5.02364L16.0976 2.64065ZM15.1806 9.96404L11.8102 8.89645L11.0553 11.2797L14.4257 12.3473L15.1806 9.96404ZM16.4927 11.7557C16.4927 10.9362 15.9613 10.2104 15.1793 9.96361L14.4271 12.3478C14.1677 12.2659 13.9927 12.0261 13.9927 11.7557H16.4927ZM15.1823 13.5469C15.9595 13.2995 16.4927 12.5776 16.4927 11.7557H13.9927C13.9927 11.4831 14.1696 11.2457 14.424 11.1647L15.1823 13.5469ZM11.8104 14.6157L15.1809 13.5474L14.4255 11.1642L11.055 12.2325L11.8104 14.6157ZM11.8586 14.5677C11.8513 14.5906 11.8336 14.6084 11.8107 14.6156L11.0548 12.2326C10.303 12.4711 9.71397 13.0602 9.47555 13.8119L11.8586 14.5677ZM10.7904 17.9381L11.8587 14.5675L9.47548 13.8122L8.40722 17.1828L10.7904 17.9381ZM8.99878 19.25C9.81845 19.25 10.5442 18.7185 10.7909 17.9365L8.40672 17.1844C8.4885 16.9251 8.72834 16.75 8.99878 16.75V19.25ZM7.20765 17.9396C7.45499 18.7167 8.17677 19.25 8.99878 19.25V16.75C9.27157 16.75 9.50893 16.927 9.58989 17.1813L7.20765 17.9396ZM6.13892 14.5675L7.20718 17.9381L9.59035 17.1828L8.52209 13.8122L6.13892 14.5675ZM6.1869 14.6156C6.164 14.6084 6.14624 14.5906 6.139 14.5677L8.52202 13.8119C8.2836 13.0602 7.69452 12.4711 6.94277 12.2326L6.1869 14.6156ZM2.81671 13.5474L6.18714 14.6157L6.94253 12.2325L3.5721 11.1642L2.81671 13.5474ZM1.50488 11.7557C1.50488 12.5737 2.03544 13.3009 2.81829 13.5479L3.57052 11.1637C3.83065 11.2458 4.00488 11.4855 4.00488 11.7557H1.50488ZM2.81524 9.96458C2.03728 10.2122 1.50488 10.9354 1.50488 11.7557H4.00488C4.00488 12.0283 3.82881 12.2655 3.57357 12.3468L2.81524 9.96458ZM6.18738 8.89645L2.81695 9.96404L3.57186 12.3473L6.94229 11.2797L6.18738 8.89645ZM6.139 8.94449C6.14624 8.92165 6.164 8.90386 6.1869 8.8966L6.94277 11.2796C7.69452 11.0411 8.2836 10.452 8.52202 9.70027L6.139 8.94449ZM7.20718 5.57411L6.13892 8.94473L8.52209 9.70003L9.59035 6.32941L7.20718 5.57411ZM8.99878 4.26221C8.17909 4.26221 7.45337 4.79372 7.20668 5.57568L9.59085 6.32783C9.50908 6.58705 9.26925 6.76221 8.99878 6.76221V4.26221ZM10.7899 5.57263C10.5426 4.79553 9.82077 4.26221 8.99878 4.26221V6.76221C8.72602 6.76221 8.48864 6.58523 8.40769 6.33088L10.7899 5.57263ZM11.8587 8.94473L10.7904 5.57411L8.40722 6.32941L9.47548 9.70003L11.8587 8.94473ZM11.8107 8.8966C11.8336 8.90386 11.8513 8.92165 11.8586 8.94449L9.47555 9.70027C9.71397 10.452 10.303 11.0411 11.0548 11.2796L11.8107 8.8966Z",
                fill: color || "#676879",
                mask: "url(#path-1-inside-1_589_3088)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/dashboards-icon.js

var DashboardsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2.32292",
                y: "3.23966",
                width: "15.3542",
                height: "13.5208",
                rx: "1.26042",
                stroke: color || "#676879",
                strokeWidth: "1.14583"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "1.75",
                y1: "6.67708",
                x2: "18.25",
                y2: "6.67708",
                stroke: color || "#676879",
                strokeWidth: "1.14583"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2399 10C14.2399 9.68359 13.9834 9.42708 13.667 9.42708C13.3506 9.42708 13.0941 9.68359 13.0941 10L14.2399 10ZM13.0941 10L13.0941 16.4167L14.2399 16.4167L14.2399 10L13.0941 10Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5729 10.9167C10.5729 10.6003 10.3164 10.3438 10 10.3438C9.68359 10.3438 9.42708 10.6003 9.42708 10.9167L10.5729 10.9167ZM9.42708 10.9167L9.42708 16.4167L10.5729 16.4167L10.5729 10.9167L9.42708 10.9167Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.90592 12.75C6.90592 12.4336 6.64942 12.1771 6.33301 12.1771C6.01659 12.1771 5.76009 12.4336 5.76009 12.75L6.90592 12.75ZM5.76009 12.75L5.76009 16.4167L6.90592 16.4167L6.90592 12.75L5.76009 12.75Z",
                fill: color || "#676879"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/automations-icon.js

var AutomationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4.3329",
                y: "6.55556",
                width: "11.3333",
                height: "9.55556",
                rx: "1.22222",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.333 9.55542H16.2219C17.2037 9.55542 17.9997 10.3514 17.9997 11.3332V12.2221C17.9997 13.2039 17.2037 13.9999 16.2219 13.9999H15.333",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.66699 9.55542H3.7781C2.79626 9.55542 2.00032 10.3514 2.00032 11.3332V12.2221C2.00032 13.2039 2.79626 13.9999 3.7781 13.9999H4.66699",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.2227 10.4443L12.2227 11.7777",
                stroke: color || "#676879",
                strokeWidth: "1.11111",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.77734 10.4443L7.77734 11.7777",
                stroke: color || "#676879",
                strokeWidth: "1.11111",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5556 3.33325C10.5556 3.02643 10.3068 2.7777 10 2.7777C9.69318 2.7777 9.44444 3.02643 9.44444 3.33325L10.5556 3.33325ZM9.44444 3.33325L9.44444 6.88881L10.5556 6.88881L10.5556 3.33325L9.44444 3.33325Z",
                fill: color || "#676879"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/infrastructure-icon.js

var InfrastructureIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 6.25007C3.75 6.91313 4.4085 7.54904 5.58064 8.01789C6.75277 8.48675 8.34253 8.75015 10.0002 8.75015C11.6578 8.75015 13.2476 8.48675 14.4197 8.01789C15.5919 7.54904 16.2504 6.91313 16.2504 6.25007C16.2504 5.58701 15.5919 4.95111 14.4197 4.48225C13.2476 4.0134 11.6578 3.75 10.0002 3.75C8.34253 3.75 6.75277 4.0134 5.58064 4.48225C4.4085 4.95111 3.75 5.58701 3.75 6.25007Z",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 6.25V9.99955C3.75 11.3802 6.54842 12.4996 10.0002 12.4996C13.452 12.4996 16.2504 11.3807 16.2504 9.99955V6.25",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 9.99951V13.7496C3.75 15.1302 6.54842 16.2497 10.0002 16.2497C13.452 16.2497 16.2504 15.1302 16.2504 13.7496V9.99951",
                stroke: color || "#676879",
                strokeWidth: "1.25004",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/integrations-icon.js

var IntegrationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_589_3100)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.84863 12.293L8.18694 16.5269C8.84001 17.1643 9.88612 17.1516 10.5235 16.4985L13.2608 13.6938L15.9981 10.889C16.6355 10.2359 16.6227 9.18982 15.9697 8.55246L11.6314 4.31848",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.65137 13.5205L12.8288 3.09233",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.5918 2.11961C6.34477 1.87852 5.94908 1.88333 5.70799 2.13036C5.4669 2.37739 5.47171 2.77309 5.71874 3.01418L6.5918 2.11961ZM5.71874 3.01418L9.39928 6.60621L10.2723 5.71163L6.5918 2.11961L5.71874 3.01418Z",
                        fill: color || "#676879"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.9609 14.0007L16.6415 17.5928",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.40137 6.41404C2.15434 6.17295 1.75865 6.17777 1.51756 6.4248C1.27647 6.67183 1.28128 7.06753 1.52831 7.30862L2.40137 6.41404ZM1.52831 7.30862L5.20885 10.9006L6.08191 10.0061L2.40137 6.41404L1.52831 7.30862Z",
                        fill: color || "#676879"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_589_3100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/icons/index.js










;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/icons/beta-icon.js

var BetaIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "21",
        height: "7",
        viewBox: "0 0 21 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.79372 3.38212C4.03431 3.42011 4.25274 3.51824 4.44901 3.67652C4.65161 3.8348 4.80989 4.03107 4.92385 4.26533C5.04415 4.49959 5.1043 4.74967 5.1043 5.01558C5.1043 5.35114 5.01882 5.65504 4.84788 5.92729C4.67694 6.1932 4.42685 6.4053 4.09763 6.56358C3.77473 6.71553 3.39169 6.7915 2.9485 6.7915H0.479308V0.172168H2.85353C3.30305 0.172168 3.68609 0.248143 4.00266 0.400093C4.31922 0.545712 4.55664 0.745147 4.71492 0.998398C4.8732 1.25165 4.95235 1.53655 4.95235 1.85312C4.95235 2.24566 4.84471 2.57172 4.62945 2.8313C4.42052 3.08455 4.14194 3.26816 3.79372 3.38212ZM1.34353 3.03073H2.79655C3.20175 3.03073 3.51515 2.93576 3.73674 2.74583C3.95834 2.55589 4.06913 2.29314 4.06913 1.95758C4.06913 1.62203 3.95834 1.35928 3.73674 1.16934C3.51515 0.979404 3.19542 0.884435 2.77756 0.884435H1.34353V3.03073ZM2.87253 6.07924C3.30305 6.07924 3.63861 5.97794 3.8792 5.77534C4.11978 5.57274 4.24008 5.29099 4.24008 4.93011C4.24008 4.5629 4.11345 4.27483 3.8602 4.0659C3.60695 3.85063 3.26823 3.743 2.84403 3.743H1.34353V6.07924H2.87253ZM10.8909 3.98992C10.8909 4.15453 10.8814 4.32864 10.8624 4.51225H6.70273C6.73439 5.02508 6.9085 5.42712 7.22506 5.71835C7.54796 6.00326 7.93733 6.14572 8.39318 6.14572C8.76673 6.14572 9.07696 6.06024 9.32388 5.8893C9.57713 5.71202 9.7544 5.47777 9.8557 5.18653H10.7864C10.6471 5.6867 10.3685 6.09506 9.95067 6.41163C9.53281 6.72186 9.01364 6.87698 8.39318 6.87698C7.89934 6.87698 7.45615 6.76618 7.06362 6.54458C6.67741 6.32299 6.37351 6.00959 6.15191 5.60439C5.93032 5.19286 5.81952 4.71802 5.81952 4.17986C5.81952 3.6417 5.92715 3.17002 6.14242 2.76482C6.35768 2.35962 6.65841 2.04939 7.04462 1.83412C7.43716 1.61253 7.88668 1.50173 8.39318 1.50173C8.88702 1.50173 9.32388 1.60936 9.70375 1.82463C10.0836 2.03989 10.3749 2.33746 10.5775 2.71734C10.7864 3.09088 10.8909 3.51508 10.8909 3.98992ZM9.99816 3.80948C9.99816 3.48025 9.92535 3.19851 9.77973 2.96426C9.63411 2.72367 9.43467 2.54323 9.18142 2.42293C8.9345 2.29631 8.65909 2.23299 8.35519 2.23299C7.91834 2.23299 7.54479 2.37228 7.23456 2.65086C6.93066 2.92943 6.75655 3.31564 6.71223 3.80948H9.99816ZM12.9246 2.29947V5.36697C12.9246 5.62022 12.9784 5.80066 13.086 5.90829C13.1937 6.00959 13.3805 6.06024 13.6464 6.06024H14.2827V6.7915H13.5039C13.0227 6.7915 12.6619 6.68071 12.4213 6.45911C12.1807 6.23752 12.0604 5.87347 12.0604 5.36697V2.29947H11.3861V1.58721H12.0604V0.276634H12.9246V1.58721H14.2827V2.29947H12.9246ZM14.8457 4.17036C14.8457 3.63853 14.9533 3.17319 15.1686 2.77432C15.3839 2.36912 15.6783 2.05572 16.0518 1.83412C16.4317 1.61253 16.8527 1.50173 17.3149 1.50173C17.7708 1.50173 18.1665 1.59987 18.502 1.79614C18.8376 1.99241 19.0877 2.23933 19.2523 2.53689V1.58721H20.126V6.7915H19.2523V5.82282C19.0813 6.12672 18.8249 6.37997 18.483 6.58257C18.1475 6.77884 17.7549 6.87698 17.3054 6.87698C16.8432 6.87698 16.4254 6.76301 16.0518 6.53509C15.6783 6.30716 15.3839 5.98743 15.1686 5.5759C14.9533 5.16437 14.8457 4.69586 14.8457 4.17036ZM19.2523 4.17986C19.2523 3.78732 19.1731 3.44543 19.0148 3.15419C18.8566 2.86295 18.6413 2.64136 18.3691 2.48941C18.1031 2.33113 17.8087 2.25199 17.4858 2.25199C17.163 2.25199 16.8685 2.32796 16.6026 2.47991C16.3367 2.63186 16.1246 2.85346 15.9663 3.1447C15.8081 3.43593 15.7289 3.77782 15.7289 4.17036C15.7289 4.56923 15.8081 4.91745 15.9663 5.21502C16.1246 5.50626 16.3367 5.73102 16.6026 5.8893C16.8685 6.04125 17.163 6.11722 17.4858 6.11722C17.8087 6.11722 18.1031 6.04125 18.3691 5.8893C18.6413 5.73102 18.8566 5.50626 19.0148 5.21502C19.1731 4.91745 19.2523 4.5724 19.2523 4.17986Z",
            fill: "#C8296A"
        })
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/icons/index.js


;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/consts.js



var PLATFORM_MINI_LINKS = [
    {
        Icon: DashboardsIcon,
        text: "header.tabs.products.dashboardsReporting",
        link: links/* DASHBOARDS_PAGE_LINK */.yCu
    },
    {
        Icon: IntegrationsIcon,
        text: "header.tabs.products.integrations",
        link: links/* INTEGRATIONS_PAGE_LINK */.oUX
    },
    {
        Icon: AutomationsIcon,
        text: "header.tabs.products.automations",
        link: links/* AUTOMATIONS_PAGE_LINK */.cPO
    },
    {
        Icon: AIIcon,
        text: "header.tabs.products.ai",
        link: links/* AI_PAGE_LINK */.lro
    },
    {
        Icon: InfrastructureIcon,
        text: "header.tabs.products.ourInfrastructure",
        link: links/* MONDAY_DB_PAGE_LINK */.VDj
    }
];
var PRODUCTS_LINKS = [
    {
        Icon: WmIcon,
        title: "monday work management",
        description: "header.tabs.products.workManagement.description",
        link: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler
    },
    {
        Icon: CRMIcon,
        title: "monday CRM",
        description: "header.tabs.products.crm.description",
        link: links/* CRM_MINI_SITE_LINK */.mgz
    },
    {
        Icon: DevIcon,
        title: "monday dev",
        description: "header.tabs.products.dev.description",
        link: links/* SOFTWARE_MINI_SITE_LINK */.DDD
    },
    {
        Icon: ServiceIcon,
        title: "monday service",
        description: "For IT & support",
        link: links/* SERVICE_MINI_SITE_LINK */.Kon,
        TitleIcon: BetaIcon
    }
];

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/descriptive-link-block/descriptive-link-block.scss.js



var StyledDescriptiveLinkBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1bf0ms20"
})("display:flex;flex-direction:row;gap:12px;text-decoration:none;color:black;padding:8px;border-radius:8px;transition:all 0.2s ease-in;align-items:center;&:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}.icon{height:100%;object-fit:contain;}.details{display:flex;flex-direction:column;gap:4px;justify-content:center;.title{display:flex;gap:8px;align-items:center;font-size:0.875rem;line-height:14px;font-weight:600;}.description{font-size:0.8125rem;line-height:16px;font-weight:400;color:", colors/* default.asphalt */.Z.asphalt, ";}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/descriptive-link-block/descriptive-link-block.js


var DescriptiveLinkBlock = function(param) {
    var Icon = param.Icon, link = param.link, title = param.title, description = param.description, TitleIcon = param.TitleIcon, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDescriptiveLinkBlock, {
        onClick: onClick,
        className: "descriptive-link-block",
        href: link,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title",
                        children: [
                            title,
                            TitleIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleIcon, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "description",
                        children: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var descriptive_link_block = (DescriptiveLinkBlock);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/mini-link-item/mini-link-item.scss.js



var StyledMiniLinkItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1g9k9jw0"
})("all:unset;cursor:pointer;display:flex;gap:16px;padding:8px;font-weight:400;font-size:0.875rem;align-items:center;border-radius:8px;transition:all 0.2s ease-in;.icon-container{display:flex;}&:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/mini-link-item/mini-link-item.js





var MiniLinkItem = function(param) {
    var Icon = param.Icon, text = param.text, link = param.link, onClick = param.onClick;
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var toggleHover = function() {
        setIsHover(function(isHover) {
            return !isHover;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMiniLinkItem, {
        onMouseLeave: toggleHover,
        onMouseEnter: toggleHover,
        onClick: onClick,
        href: link,
        className: "mini-link-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "icon-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    color: isHover && colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text",
                children: text
            })
        ]
    });
};
/* harmony default export */ var mini_link_item = (MiniLinkItem);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/products-menu-component/products-menu-component.js
function products_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function products_menu_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function products_menu_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        products_menu_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function products_menu_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = products_menu_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function products_menu_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var ProductsMenuComponent = function(param) {
    var translate = param.translate, menuId = param.menuId, onLinkClick = param.onLinkClick;
    var onLinkClickWithMenuId = function(event, link, text) {
        return onLinkClick({
            menuId: menuId,
            link: link,
            event: event,
            text: text
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductsMenuComponent, {
        className: "menu-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "platform-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("section-title", "align-to-link"),
                        children: translate("header.tabs.products.title.platform")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "links-container",
                        children: PLATFORM_MINI_LINKS.map(function(_param, index) {
                            var text = _param.text, link = _param.link, platformProps = products_menu_component_object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ (0,react.createElement)(mini_link_item, products_menu_component_object_spread_props(products_menu_component_object_spread({
                                link: link,
                                onClick: function(event) {
                                    return onLinkClickWithMenuId(event, link, text);
                                }
                            }, platformProps), {
                                text: translate(text),
                                key: index
                            }));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "products-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("section-title", "align-to-link"),
                        children: translate("header.tabs.products.title.products")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "products-container",
                        children: PRODUCTS_LINKS.map(function(_param, index) {
                            var title = _param.title, link = _param.link, description = _param.description, productProps = products_menu_component_object_without_properties(_param, [
                                "title",
                                "link",
                                "description"
                            ]);
                            return /*#__PURE__*/ (0,react.createElement)(descriptive_link_block, products_menu_component_object_spread_props(products_menu_component_object_spread({}, productProps), {
                                link: link,
                                onClick: function(event) {
                                    return onLinkClickWithMenuId(event, link, title);
                                },
                                title: translate(title),
                                description: translate(description),
                                key: index
                            }));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var products_menu_component = (ProductsMenuComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/solutions-menu-component.scss.js

var StyledSolutionsMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18pmncb0"
})(".section{display:flex;flex-direction:column;gap:32px;.links{display:flex;flex-direction:column;gap:8px;&.company-links{gap:24px;}.descriptive-link-block{width:256px;.details{max-width:164px;}}.mini-link-item{width:160px;height:20px;}}.teams-links-container{display:grid;grid-template-columns:repeat(2,1fr);grid-column-gap:32px;grid-row-gap:8px;}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/enterprise-icon.js

var EnterpriseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "6.73684",
                fill: "#6C6CFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_506_4041)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.4766 19.6274V20.4603",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.4766 22.959V23.7918",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.4766 26.2903V27.1231",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.8486 19.6274V20.4603",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.8486 22.959V23.7918",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.8486 26.2903V27.1231",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.2207 19.6274V20.4603",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.2207 22.959V23.7918",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.2207 26.2903V27.1231",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M31.3445 17.1292V33.3693H16.3535V17.1292",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M29.2623 17.1291V14.6306H18.4355V17.1291",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M33.2182 33.3691H14.4795",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M32.3855 17.1292H15.3125",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.4766 29.6216V30.4544",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M28.2207 29.6216V30.4544",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M25.5149 33.3693V31.2872C25.5149 30.3711 24.7654 29.6216 23.8493 29.6216C22.9331 29.6216 22.1836 30.3711 22.1836 31.2872V33.3693",
                        stroke: "white",
                        strokeWidth: "1.24925",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_506_4041",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "19.9879",
                        height: "19.9879",
                        fill: "white",
                        transform: "translate(13.8545 14.0059)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/it-icon.js

var ItIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1788)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.3569 10.2858V13.5001C17.3569 13.6706 17.2891 13.8341 17.1686 13.9547C17.048 14.0752 16.8845 14.143 16.714 14.143H1.28544C1.11494 14.143 0.951426 14.0752 0.830867 13.9547C0.710307 13.8341 0.642578 13.6706 0.642578 13.5001V3.21439C0.642578 3.04389 0.710307 2.88037 0.830867 2.75983C0.951426 2.63926 1.11494 2.57153 1.28544 2.57153H3.85686",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.71443 14.1428L6.42871 17.3571",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.2852 14.1428L11.5709 17.3571",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.14258 17.3572H12.8569",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.07129 7.07139H10.9284V9.64282L14.7856 7.07139H17.357V0.642822H7.07129V7.07139Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1788",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/marketing-icon.js

var MarketingIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_589_3129)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.0518 1.37988L17.1317 11.9105",
                        stroke: color || "#676879",
                        strokeWidth: "1.43882",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.8157 11.3578L1.8281 14.8379L0.868164 13.1751L11.3759 1.93555",
                        stroke: color || "#676879",
                        strokeWidth: "1.43882",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.08789 14.0794L5.91317 15.5088C6.21256 16.022 6.70352 16.3952 7.27807 16.5463C7.85259 16.6973 8.46364 16.6141 8.97676 16.3146C9.4899 16.0153 9.86308 15.5244 10.0142 14.9498C10.1653 14.3753 10.0821 13.7642 9.78267 13.2511L9.6505 13.0222",
                        stroke: color || "#676879",
                        strokeWidth: "1.43882",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_589_3129",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/rnd-icon.js

var RndIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1772)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.875 16.3147C16.875 16.6131 16.7565 16.8992 16.5455 17.1102C16.3345 17.3212 16.0484 17.4397 15.75 17.4397H2.25C1.95163 17.4397 1.66548 17.3212 1.4545 17.1102C1.24353 16.8992 1.125 16.6131 1.125 16.3147V1.6897C1.125 1.39133 1.24353 1.10518 1.4545 0.894202C1.66548 0.683224 1.95163 0.564697 2.25 0.564697H13.5338C13.8275 0.564732 14.1096 0.67967 14.3198 0.884947L16.536 3.04645C16.6434 3.15131 16.7287 3.2766 16.7869 3.41493C16.8451 3.55327 16.8751 3.70186 16.875 3.85195V16.3147Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.7212 6.7522L13.5337 9.5647L10.7212 12.3772",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.34619 6.7522L4.53369 9.5647L7.34619 12.3772",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1772",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/operations-icon.js

var OperationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1783)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.90944 1.8284C8.04707 1.98118 8.21526 2.10333 8.40312 2.18694C8.59098 2.27055 8.79431 2.31376 8.99994 2.31376C9.20557 2.31376 9.4089 2.27055 9.59676 2.18694C9.78461 2.10333 9.95281 1.98118 10.0904 1.8284L10.7999 1.0499C11.0033 0.82486 11.2713 0.66826 11.5672 0.601599C11.8631 0.534938 12.1723 0.561483 12.4525 0.677589C12.7327 0.793696 12.9701 0.993674 13.1321 1.25008C13.2942 1.50648 13.3729 1.80674 13.3574 2.10965L13.3042 3.15965C13.2939 3.36448 13.3266 3.5692 13.4002 3.76062C13.4739 3.95203 13.5868 4.1259 13.7317 4.27103C13.8766 4.41615 14.0503 4.52932 14.2416 4.60323C14.4329 4.67714 14.6376 4.71015 14.8424 4.70015L15.8924 4.6469C16.1952 4.63198 16.4951 4.71104 16.7511 4.87325C17.0071 5.03545 17.2067 5.27287 17.3225 5.55295C17.4384 5.83304 17.4647 6.14209 17.398 6.43774C17.3313 6.73339 17.1748 7.00118 16.9499 7.2044L16.1684 7.9094C16.0159 8.04723 15.8939 8.21553 15.8104 8.40343C15.7269 8.59134 15.6838 8.79466 15.6838 9.00028C15.6838 9.20589 15.7269 9.40922 15.8104 9.59713C15.8939 9.78503 16.0159 9.95333 16.1684 10.0912L16.9499 10.7962C17.175 10.9995 17.3316 11.2675 17.3982 11.5634C17.4649 11.8593 17.4384 12.1685 17.3223 12.4487C17.2061 12.7289 17.0062 12.9663 16.7498 13.1284C16.4934 13.2904 16.1931 13.3691 15.8902 13.3537L14.8402 13.3004C14.6349 13.2898 14.4297 13.3225 14.2378 13.3963C14.046 13.47 13.8717 13.5832 13.7264 13.7286C13.581 13.8739 13.4678 14.0482 13.394 14.24C13.3203 14.4319 13.2876 14.6371 13.2982 14.8424L13.3514 15.8924C13.3649 16.1938 13.2852 16.492 13.1232 16.7465C12.9613 17.0011 12.7249 17.1996 12.4462 17.3151C12.1675 17.4306 11.86 17.4575 11.5655 17.3922C11.2709 17.3268 11.0037 17.1724 10.7999 16.9499L10.0942 16.1692C9.95643 16.0166 9.7882 15.8946 9.60036 15.8111C9.41251 15.7277 9.20924 15.6845 9.00369 15.6845C8.79813 15.6845 8.59487 15.7277 8.40702 15.8111C8.21918 15.8946 8.05094 16.0166 7.91319 16.1692L7.20444 16.9499C7.00105 17.1735 6.73366 17.3289 6.43872 17.3949C6.14379 17.461 5.83566 17.4344 5.55635 17.319C5.27703 17.2035 5.04012 17.0047 4.87792 16.7497C4.71571 16.4947 4.6361 16.1958 4.64994 15.8939L4.70394 14.8439C4.7145 14.6386 4.68184 14.4334 4.60809 14.2415C4.53433 14.0497 4.42111 13.8754 4.27576 13.7301C4.13041 13.5847 3.95617 13.4715 3.7643 13.3978C3.57244 13.324 3.36722 13.2913 3.16194 13.3019L2.11194 13.3552C1.80915 13.371 1.5089 13.2927 1.25239 13.131C0.99589 12.9693 0.795715 12.7322 0.679351 12.4522C0.562987 12.1723 0.536139 11.8631 0.602492 11.5673C0.668845 11.2714 0.825147 11.0034 1.04994 10.7999L1.83069 10.0949C1.98327 9.95708 2.10525 9.78878 2.18873 9.60088C2.27222 9.41297 2.31535 9.20964 2.31535 9.00403C2.31535 8.79841 2.27222 8.59509 2.18873 8.40718C2.10525 8.21928 1.98327 8.05098 1.83069 7.91315L1.04994 7.2044C0.825876 7.00116 0.670051 6.73367 0.603765 6.43851C0.537479 6.14334 0.563966 5.83491 0.679606 5.55538C0.795246 5.27584 0.994395 5.03883 1.24983 4.87676C1.50527 4.71469 1.80452 4.63546 2.10669 4.6499L3.15669 4.70315C3.36236 4.71397 3.56801 4.6814 3.76027 4.60756C3.95254 4.53372 4.12712 4.42027 4.27268 4.27456C4.41824 4.12886 4.53153 3.95417 4.60518 3.76183C4.67883 3.56949 4.7112 3.36382 4.70019 3.15815L4.64994 2.1074C4.63577 1.80535 4.71514 1.50628 4.87722 1.25101C5.0393 0.995735 5.2762 0.796687 5.55559 0.681026C5.83498 0.565366 6.14325 0.538727 6.43834 0.604744C6.73343 0.670761 7.00097 0.826218 7.20444 1.0499L7.90944 1.8284Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.625 9.00073C5.625 9.89584 5.98058 10.7543 6.61351 11.3872C7.24645 12.0202 8.10489 12.3757 9 12.3757C9.89511 12.3757 10.7535 12.0202 11.3865 11.3872C12.0194 10.7543 12.375 9.89584 12.375 9.00073C12.375 8.10563 12.0194 7.24718 11.3865 6.61425C10.7535 5.98131 9.89511 5.62573 9 5.62573C8.10489 5.62573 7.24645 5.98131 6.61351 6.61425C5.98058 7.24718 5.625 8.10563 5.625 9.00073Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1783",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/smb-icon.js

var SmbIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "6.73684",
                fill: "#6C6CFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_506_4029)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M31.5694 22.9025L29.7935 21.5225V17.09H26.4215V18.98L23.4241 16.73L15.2789 22.9025C15.1091 23.0574 15.0068 23.2729 14.9941 23.5025V32.855C14.9941 33.0539 15.0731 33.2447 15.2136 33.3853C15.3541 33.5259 15.5447 33.605 15.7435 33.605H31.1198C31.3186 33.605 31.5091 33.5259 31.6497 33.3853C31.7902 33.2447 31.8691 33.0539 31.8691 32.855V23.465C31.8432 23.2465 31.7362 23.0457 31.5694 22.9025Z",
                    stroke: "white",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_506_4029",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(14.4316 16.1675)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/product-icon.js

var ProductIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1764)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.81348 14.925H2.06348C1.66565 14.925 1.28412 14.767 1.00282 14.4858C0.721512 14.2044 0.563477 13.8229 0.563477 13.425V2.07983C0.563477 1.68201 0.721512 1.30048 1.00282 1.01918C1.28412 0.737869 1.66565 0.579834 2.06348 0.579834H15.5635C15.9613 0.579834 16.3428 0.737869 16.6241 1.01918C16.9055 1.30048 17.0635 1.68201 17.0635 2.07983V7.05008",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.563477 4.16626H17.0635",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.4385 15.4921L12.9385 17.4204V12.2776L17.4385 10.3494V15.4921Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.43799 15.4921L12.938 17.4204V12.2776L8.43799 10.3494V15.4921Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.938 8.42017L17.438 10.3492L12.938 12.2774L8.43799 10.3492L12.938 8.42017Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1764",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/sales-icon.js

var SalesIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1754)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.5625 17.4375H17.4375",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.5 12.1875H2.25C2.10142 12.1894 1.95947 12.2493 1.8544 12.3544C1.74933 12.4595 1.68944 12.6014 1.6875 12.75V17.4375H5.0625V12.75C5.06056 12.6014 5.00067 12.4595 4.8956 12.3544C4.79053 12.2493 4.64858 12.1894 4.5 12.1875Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.125 9.1875H7.875C7.72642 9.18944 7.58447 9.24933 7.4794 9.3544C7.37433 9.45947 7.31444 9.60142 7.3125 9.75V17.4375H10.6875V9.75C10.6856 9.60142 10.6257 9.45947 10.5206 9.3544C10.4155 9.24933 10.2736 9.18944 10.125 9.1875Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.75 6.1875H13.5C13.3514 6.18944 13.2095 6.24933 13.1044 6.3544C12.9993 6.45947 12.9394 6.60142 12.9375 6.75V17.4375H16.3125V6.75C16.3106 6.60142 16.2507 6.45947 16.1456 6.3544C16.0405 6.24933 15.8986 6.18944 15.75 6.1875Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.13525 6.93008L15.1878 1.45508",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.2947 3.8475L15.1872 1.455L12.8022 0.5625",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1754",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/media-icon.js

var MediaIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_595_3598)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.5 1.5H15.5C15.5 1.5 16.5 1.5 16.5 2.5V15.5C16.5 15.5 16.5 16.5 15.5 16.5H2.5C2.5 16.5 1.5 16.5 1.5 15.5V2.5C1.5 2.5 1.5 1.5 2.5 1.5Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.17647",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.82533 11.44C7.73833 11.4833 7.64169 11.5038 7.54457 11.4993C7.44745 11.4949 7.35307 11.4657 7.2704 11.4146C7.18773 11.3634 7.11949 11.292 7.07217 11.2071C7.02485 11.1221 7.00001 11.0265 7 10.9293V7.07064C7.00001 6.97342 7.02485 6.87781 7.07217 6.79288C7.11949 6.70796 7.18773 6.63653 7.2704 6.58538C7.35307 6.53422 7.44745 6.50504 7.54457 6.5006C7.64169 6.49615 7.73833 6.51658 7.82533 6.55997L11.6847 8.49C11.7795 8.53726 11.8591 8.61006 11.9149 8.70013C11.9706 8.7902 12.0001 8.89406 12.0001 9C12.0001 9.10586 11.9706 9.20973 11.9149 9.2998C11.8591 9.38986 11.7795 9.46266 11.6847 9.51L7.82533 11.44Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.17647",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.5 4H16.5",
                        stroke: color || "#676879",
                        strokeWidth: "1.17647",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.5 14H16.5",
                        stroke: color || "#676879",
                        strokeWidth: "1.17647",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_595_3598",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(1 1)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/retail-icon.js

var RetailIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1809)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.5 14.625H6.06C5.79405 14.6251 5.53657 14.5311 5.33332 14.3594C5.13015 14.1878 4.99432 13.9497 4.95 13.6875L3 2.06243C2.95492 1.795 2.81467 1.55286 2.6052 1.3806C2.39572 1.20833 2.13112 1.11754 1.86 1.12493H1.11",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.1396 16.8823C12.295 16.8823 12.4209 16.7564 12.4209 16.6011C12.4209 16.4457 12.295 16.3198 12.1396 16.3198",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.1396 16.8823C11.9843 16.8823 11.8584 16.7564 11.8584 16.6011C11.8584 16.4457 11.9843 16.3198 12.1396 16.3198",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.46094 16.8823C6.61626 16.8823 6.74219 16.7564 6.74219 16.6011C6.74219 16.4457 6.61626 16.3198 6.46094 16.3198",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.46094 16.8823C6.30561 16.8823 6.17969 16.7564 6.17969 16.6011C6.17969 16.4457 6.30561 16.3198 6.46094 16.3198",
                        stroke: color || "#676879",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.4996 11.25H13.5896C14.0872 11.2451 14.5692 11.0753 14.96 10.7672C15.3508 10.4591 15.6285 10.0302 15.7496 9.5475L16.8596 5.1975C16.8785 5.11469 16.8788 5.02874 16.8607 4.94578C16.8425 4.8628 16.8063 4.78486 16.7546 4.7175C16.7022 4.65002 16.6351 4.59537 16.5584 4.55768C16.4818 4.52 16.3975 4.50027 16.3121 4.5H3.3896",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.50014 4.50022L7.31264 1.68772C7.57806 1.42483 7.93657 1.27734 8.31014 1.27734C8.68372 1.27734 9.04222 1.42483 9.30764 1.68772L12.1201 4.50022",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.1175 2.50477L13.4175 1.53727C13.5943 1.48451 13.7798 1.46734 13.9632 1.48675C14.1467 1.50616 14.3245 1.56176 14.4863 1.65035C14.6481 1.73893 14.7908 1.85874 14.906 2.00283C15.0212 2.14691 15.1067 2.31242 15.1575 2.48977L15.75 4.49977",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1809",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "matrix(-1 0 0 1 18 0)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/construction-icon.js

var ConstructionIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_589_3199)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.5 17.4999C14.5787 14.8211 12.0197 12.8635 9.05118 12.8635C6.08268 12.8635 3.42126 14.8211 2.5 17.4999",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.94837 3.59091V0.5M3.31836 6.57878H14.5782M4.75143 7.71212C4.85379 9.97879 6.6963 11.8333 8.94827 11.8333C11.3026 11.8333 13.1451 9.97879 13.1451 7.60909V5.75455C13.1451 3.38485 11.3026 1.5303 8.94827 1.5303C6.6963 1.5303 4.85379 3.38485 4.75143 5.65152V7.71212Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_589_3199",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/hr-icon.js

var HrIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.42864 8.35679C8.20384 8.35679 9.64293 6.91771 9.64293 5.14251C9.64293 3.36731 8.20384 1.92822 6.42864 1.92822C4.65344 1.92822 3.21436 3.36731 3.21436 5.14251C3.21436 6.91771 4.65344 8.35679 6.42864 8.35679Z",
                stroke: color || "#676879",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.643066 17.3569H12.2145V16.6599C12.2043 15.6799 11.9458 14.7185 11.4633 13.8655C10.9808 13.0124 10.2899 12.2957 9.45526 11.782C8.6206 11.2684 7.66938 10.9747 6.69045 10.9283C6.60317 10.9242 6.51593 10.9221 6.42878 10.9219C6.34163 10.9221 6.25439 10.9242 6.16711 10.9283C5.18818 10.9747 4.23696 11.2684 3.4023 11.782C2.56765 12.2957 1.8768 13.0124 1.39427 13.8655C0.911751 14.7185 0.653302 15.6799 0.643066 16.6599V17.3569Z",
                stroke: color || "#676879",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5718 8.35679C13.347 8.35679 14.7861 6.91771 14.7861 5.14251C14.7861 3.36731 13.347 1.92822 11.5718 1.92822",
                stroke: color || "#676879",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.786 17.3568H17.3574V16.6596C17.3471 15.6797 17.0887 14.7182 16.6062 13.8653C16.1237 13.0122 15.4328 12.2954 14.5982 11.7818C14.0587 11.4498 13.4703 11.2097 12.8574 11.0688",
                stroke: color || "#676879",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/pmo-icon.js

var PmoIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 3.37903C1 2.93252 1.36196 2.57056 1.80847 2.57056H10.2397C10.6862 2.57056 11.0481 2.93252 11.0481 3.37903C11.0481 3.82553 10.6862 4.1875 10.2397 4.1875H1.80847C1.36196 4.1875 1 3.82553 1 3.37903ZM4.23353 8.99982C4.23353 8.55332 4.5955 8.19135 5.042 8.19135H13.4732C13.9197 8.19135 14.2817 8.55332 14.2817 8.99982C14.2817 9.44633 13.9197 9.80829 13.4732 9.80829H5.042C4.5955 9.80829 4.23353 9.44633 4.23353 8.99982ZM6.3898 14.6208C6.3898 14.1742 6.75176 13.8123 7.19827 13.8123H16.1915C16.638 13.8123 17 14.1742 17 14.6208C17 15.0673 16.638 15.4292 16.1915 15.4292H7.19827C6.75176 15.4292 6.3898 15.0673 6.3898 14.6208Z",
            fill: color || "#676879"
        })
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/icons/index.js














;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/consts.js


var COMPANY_SIZE_LINKS = [
    {
        Icon: EnterpriseIcon,
        title: "header.tabs.solution.enterprise.title",
        link: links/* ENTERPRISE_PAGE_LINK */.RVF,
        description: "header.tabs.solution.enterprise.description"
    },
    {
        Icon: SmbIcon,
        title: "header.tabs.solution.smb.title",
        link: links/* SMB_PAGE_LINK */.qDl,
        description: "header.tabs.solution.smb.description"
    }
];
var TEAMS_LINKS = [
    {
        Icon: MarketingIcon,
        text: "header.tabs.solution.marketing",
        link: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD
    },
    {
        Icon: PmoIcon,
        text: "header.tabs.solution.pmo",
        link: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42
    },
    {
        Icon: SalesIcon,
        text: "header.tabs.solution.sales",
        link: links/* CRM_MINI_SITE_LINK */.mgz
    },
    {
        Icon: OperationsIcon,
        text: "header.tabs.solution.operations",
        link: links/* OPERATIONS_CLUSTER_LINK */.R9t
    },
    {
        Icon: ProductIcon,
        text: "header.tabs.solution.product",
        link: links/* SOFTWARE_MINI_SITE_LINK */.DDD
    },
    {
        Icon: ItIcon,
        text: "header.tabs.solution.it",
        link: links/* SERVICE_MINI_SITE_LINK */.Kon
    },
    {
        Icon: RndIcon,
        text: "header.tabs.solution.rnd",
        link: links/* SOFTWARE_MINI_SITE_LINK */.DDD
    },
    {
        Icon: HrIcon,
        text: "header.tabs.solution.hr",
        link: links/* HR_USE_CASES_LINK */.n$n
    }
];
var INDUSTRIES_LINKS = [
    {
        Icon: RetailIcon,
        text: "header.tabs.solution.retail",
        link: links/* RETAIL_PAGE_LINK */.fjW
    },
    {
        Icon: MediaIcon,
        text: "header.tabs.solution.media",
        link: links/* MEDIA_PAGE_LINK */.Dx_
    },
    {
        Icon: ConstructionIcon,
        text: "header.tabs.solution.construction",
        link: links/* CONSTRUCTION_MINI_SITE_LINK */.ikI
    }
];

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/solutions-menu-component/solutions-menu-component.js
function solutions_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function solutions_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            solutions_menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function solutions_menu_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function solutions_menu_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        solutions_menu_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function solutions_menu_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = solutions_menu_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function solutions_menu_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var SolutionsMenuComponent = function(param) {
    var translate = param.translate, onLinkClick = param.onLinkClick, menuId = param.menuId;
    var onLinkClickWithMenuId = function(event, link, text) {
        return onLinkClick({
            menuId: menuId,
            link: link,
            event: event,
            text: text
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSolutionsMenuComponent, {
        className: "menu-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("section", "company-size-section"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("section-title", "align-to-link"),
                        children: translate("header.tabs.solution.title.companySize")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("links", "company-links"),
                        children: COMPANY_SIZE_LINKS.map(function(_param, index) {
                            var title = _param.title, description = _param.description, link = _param.link, company = solutions_menu_component_object_without_properties(_param, [
                                "title",
                                "description",
                                "link"
                            ]);
                            return /*#__PURE__*/ (0,react.createElement)(descriptive_link_block, solutions_menu_component_object_spread_props(solutions_menu_component_object_spread({
                                onClick: function(event) {
                                    return onLinkClickWithMenuId(event, link, title);
                                },
                                title: translate(title),
                                link: link,
                                description: translate(description)
                            }, company), {
                                key: index
                            }));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("section", "teams-section"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("section-title", "align-to-link"),
                        children: translate("header.tabs.solution.title.teams")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("links", "teams-links-container"),
                        children: TEAMS_LINKS.map(function(_param, index) {
                            var text = _param.text, link = _param.link, team = solutions_menu_component_object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ (0,react.createElement)(mini_link_item, solutions_menu_component_object_spread_props(solutions_menu_component_object_spread({
                                link: link,
                                onClick: function(event) {
                                    return onLinkClickWithMenuId(event, link, text);
                                },
                                text: translate(text)
                            }, team), {
                                key: index
                            }));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("section", "industries-section"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("section-title", "align-to-link"),
                        children: translate("header.tabs.solution.title.industries")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "links",
                        children: INDUSTRIES_LINKS.map(function(_param, index) {
                            var text = _param.text, link = _param.link, industry = solutions_menu_component_object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ (0,react.createElement)(mini_link_item, solutions_menu_component_object_spread_props(solutions_menu_component_object_spread({
                                link: link,
                                onClick: function(event) {
                                    return onLinkClickWithMenuId(event, link, text);
                                },
                                text: translate(text)
                            }, industry), {
                                key: index
                            }));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var solutions_menu_component = (SolutionsMenuComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/resources-menu-component.scss.js

var StyledResourcesMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1j6374p0"
})("margin-right:32px;.section{display:flex;flex-direction:column;gap:32px;width:256px;.links{display:flex;flex-direction:column;gap:16px;}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/about-icon.js

var AboutIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.48346 14.2369C2.67081 14.2361 1.92258 13.813 1.52927 13.1316C1.13596 12.4503 1.15953 11.6182 1.59083 10.9583L5.61505 4.80302C6.02839 4.13279 6.78876 3.73021 7.601 3.75154C8.41324 3.77287 9.14944 4.21477 9.52383 4.90569C9.89822 5.59661 9.85184 6.42775 9.40269 7.07648L5.38086 13.2318C4.9718 13.858 4.25458 14.238 3.48346 14.2369Z",
                stroke: color || "#676879",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.84016 14.2369C9.02884 14.2361 8.28183 13.814 7.88916 13.1343C7.4965 12.4546 7.52003 11.6244 7.95063 10.9661L11.9671 4.82543C12.3739 4.14542 13.137 3.7332 13.9553 3.75131C14.7736 3.76941 15.516 4.21493 15.8896 4.9122C16.2632 5.60947 16.2081 6.44659 15.7461 7.09349L11.7297 13.2342C11.3222 13.8576 10.6083 14.2364 9.84016 14.2369V14.2369Z",
                stroke: color || "#676879",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5247 14.2495C17.7538 14.2495 18.7501 13.2549 18.7501 12.0279C18.7501 10.801 17.7538 9.8064 16.5247 9.8064C15.2957 9.8064 14.2993 10.801 14.2993 12.0279C14.2993 13.2549 15.2957 14.2495 16.5247 14.2495Z",
                stroke: color || "#676879",
                strokeWidth: "1.25"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/support-icon.js

var SupportIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_595_3573)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.375 13.5H2.8125C2.21576 13.5 1.64347 13.2629 1.22151 12.841C0.799553 12.419 0.5625 11.8467 0.5625 11.25V9C0.5625 8.4033 0.799553 7.83098 1.22151 7.40901C1.64347 6.98705 2.21576 6.75 2.8125 6.75H3.375C3.52418 6.75 3.66726 6.80927 3.77275 6.91475C3.87824 7.02024 3.9375 7.16332 3.9375 7.3125V12.9375C3.9375 13.0867 3.87824 13.2298 3.77275 13.3352C3.66726 13.4408 3.52418 13.5 3.375 13.5Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.1875 13.5H14.625C14.4758 13.5 14.3327 13.4408 14.2273 13.3352C14.1217 13.2298 14.0625 13.0867 14.0625 12.9375V7.3125C14.0625 7.16332 14.1217 7.02024 14.2273 6.91475C14.3327 6.80927 14.4758 6.75 14.625 6.75H15.1875C15.7842 6.75 16.3565 6.98705 16.7785 7.40901C17.2004 7.83098 17.4375 8.4033 17.4375 9V11.25C17.4375 11.8467 17.2004 12.419 16.7785 12.841C16.3565 13.2629 15.7842 13.5 15.1875 13.5Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.8125 6.75C2.8125 5.10897 3.46439 3.53515 4.62478 2.37478C5.78515 1.21439 7.35897 0.5625 9 0.5625C10.641 0.5625 12.2149 1.21439 13.3752 2.37478C14.5356 3.53515 15.1875 5.10897 15.1875 6.75",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.25 16.3125H12.9375C13.5342 16.3125 14.1065 16.0754 14.5285 15.6535C14.9504 15.2315 15.1875 14.6592 15.1875 14.0625V13.5",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.125 17.4375H9C8.70165 17.4375 8.41545 17.319 8.20447 17.108C7.9935 16.897 7.875 16.6108 7.875 16.3125C7.875 16.0142 7.9935 15.728 8.20447 15.517C8.41545 15.306 8.70165 15.1875 9 15.1875H10.125C10.4233 15.1875 10.7096 15.306 10.9205 15.517C11.1315 15.728 11.25 16.0142 11.25 16.3125C11.25 16.6108 11.1315 16.897 10.9205 17.108C10.7096 17.319 10.4233 17.4375 10.125 17.4375Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.75 6.18756C6.75008 5.77508 6.86354 5.37056 7.07799 5.01821C7.29244 4.66586 7.5996 4.37924 7.96597 4.18967C8.33227 4.00011 8.74372 3.91489 9.15517 3.94335C9.5667 3.9718 9.96247 4.11282 10.2992 4.351C10.636 4.58917 10.9008 4.91534 11.0647 5.29385C11.2286 5.67236 11.2853 6.08865 11.2286 6.49721C11.1719 6.90577 11.0041 7.2909 10.7433 7.6105C10.4825 7.93008 10.1389 8.1718 9.75 8.30928C9.53055 8.3869 9.34057 8.5306 9.20625 8.72065C9.07192 8.91078 8.99985 9.1378 9 9.37053V9.56253",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 12.375C8.84467 12.375 8.71875 12.2491 8.71875 12.0938C8.71875 11.9384 8.84467 11.8125 9 11.8125",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 12.375C9.15533 12.375 9.28125 12.2491 9.28125 12.0938C9.28125 11.9384 9.15533 11.8125 9 11.8125",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_595_3573",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/app-development-icon.js

var AppDevelopmentIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1968)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.1496 12.2625L15.8084 11.8313C16.0139 11.8155 16.22 11.8546 16.4056 11.9445C16.5912 12.0344 16.7496 12.1719 16.8647 12.343C16.9797 12.5141 17.0473 12.7127 17.0606 12.9185C17.0738 13.1242 17.0323 13.3298 16.9401 13.5143C16.8081 13.7773 16.5818 13.9808 16.3064 14.0843L8.48085 17.0183C7.99885 17.1994 7.46922 17.2092 6.98085 17.046L0.985352 15.048",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.92285 12.798H9.26385C9.47386 12.798 9.67853 12.7319 9.84893 12.6092C10.0193 12.4864 10.1468 12.3132 10.2134 12.114C10.2563 11.9849 10.2724 11.8484 10.2609 11.7128C10.2493 11.5773 10.2102 11.4455 10.1459 11.3255C10.0817 11.2056 9.99372 11.1 9.88732 11.0152C9.78092 10.9304 9.65835 10.8681 9.5271 10.8323L5.0736 9.61803C4.60361 9.48943 4.11139 9.46384 3.6306 9.54303L0.985352 9.98403",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.54735 2.22461L3.79785 4.28711L6.54735 6.34961",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.4229 2.22461L16.1731 4.28711L13.4229 6.34961",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.6726 0.849121L9.29785 7.72437",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1968",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/blog-icon.js

var BlogIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1930)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.8861 13.7731L8.4308 8.89062L7.4873 6.18237L10.3501 6.35262L16.8046 11.2351C16.9707 11.3608 17.1105 11.5179 17.2159 11.6976C17.3214 11.8773 17.3904 12.076 17.419 12.2824C17.4476 12.4888 17.4353 12.6987 17.3828 12.9003C17.3302 13.1019 17.2385 13.2912 17.1128 13.4574L17.1068 13.4649C16.8532 13.8002 16.4767 14.0211 16.0603 14.0789C15.6438 14.1367 15.2214 14.0267 14.8861 13.7731Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.8096 4.53149V2.28149C11.8096 1.98313 11.691 1.69698 11.4801 1.486C11.2691 1.27502 10.9829 1.15649 10.6846 1.15649H1.68457C1.3862 1.15649 1.10005 1.27502 0.889075 1.486C0.678097 1.69698 0.55957 1.98313 0.55957 2.28149V13.5315C0.55957 13.8299 0.678097 14.116 0.889075 14.327C1.10005 14.538 1.3862 14.6565 1.68457 14.6565H6.93457L9.55957 16.9065V14.6565H10.6846C10.8935 14.6566 11.0984 14.5984 11.2761 14.4886C11.4539 14.3788 11.5976 14.2216 11.6911 14.0347",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.80957 3.40649H6.18457",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.49707 3.40649V6.78149",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.80957 9.59399H5.62207",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.80957 11.844H7.30957",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1930",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/certification-icon.js

var CertificationIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1939)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.2628 7.04254C16.1938 7.29575 16.0534 7.5238 15.8585 7.69954L15.1295 8.35804C14.9871 8.48658 14.8733 8.64359 14.7953 8.8189C14.7174 8.99422 14.6771 9.18393 14.6771 9.37579C14.6771 9.56764 14.7174 9.75736 14.7953 9.93267C14.8733 10.108 14.9871 10.265 15.1295 10.3935L15.8585 11.052C16.0689 11.2417 16.2153 11.4919 16.2776 11.7682C16.34 12.0445 16.3153 12.3333 16.2069 12.595C16.0984 12.8566 15.9116 13.0783 15.6721 13.2295C15.4326 13.3807 15.1521 13.454 14.8693 13.4393L13.8883 13.389C13.6967 13.3793 13.5053 13.4099 13.3263 13.4789C13.1474 13.5478 12.9849 13.6535 12.8493 13.7891C12.7137 13.9247 12.6081 14.0873 12.5393 14.2663C12.4705 14.4453 12.44 14.6368 12.4498 14.8283L12.5 15.8093C12.5152 16.0924 12.4423 16.3733 12.2912 16.6133C12.1401 16.8533 11.9183 17.0405 11.6564 17.1491C11.3945 17.2578 11.1053 17.2826 10.8287 17.2201C10.5521 17.1575 10.3017 17.0108 10.112 16.8L9.45353 16.071C9.32498 15.9286 9.16798 15.8148 8.99266 15.7368C8.81735 15.6589 8.62763 15.6186 8.43578 15.6186C8.24393 15.6186 8.05421 15.6589 7.87889 15.7368C7.70358 15.8148 7.54657 15.9286 7.41803 16.071L6.75953 16.8C6.56975 17.0105 6.31942 17.157 6.04298 17.2193C5.76654 17.2817 5.47757 17.2568 5.21583 17.1482C4.95409 17.0396 4.73244 16.8525 4.58138 16.6127C4.43032 16.373 4.35727 16.0923 4.37228 15.8093L4.42478 14.8283C4.43458 14.6367 4.40406 14.4452 4.3352 14.2661C4.26634 14.0871 4.16066 13.9245 4.02501 13.7888C3.88936 13.6531 3.72675 13.5475 3.54769 13.4786C3.36864 13.4098 3.17712 13.3792 2.98553 13.389L2.00453 13.4393C1.72167 13.454 1.44121 13.3807 1.2017 13.2295C0.962181 13.0783 0.77537 12.8566 0.66694 12.595C0.55851 12.3333 0.533783 12.0445 0.596158 11.7682C0.658533 11.4919 0.804948 11.2417 1.01528 11.052L1.74428 10.3935C1.8867 10.265 2.00056 10.108 2.07848 9.93267C2.15641 9.75736 2.19668 9.56764 2.19668 9.37579C2.19668 9.18393 2.15641 8.99422 2.07848 8.8189C2.00056 8.64359 1.8867 8.48658 1.74428 8.35804L1.01528 7.69954C0.805136 7.50996 0.658814 7.25999 0.596395 6.98394C0.533975 6.70789 0.558518 6.41928 0.666653 6.15774C0.774789 5.89619 0.961218 5.67452 1.20035 5.52315C1.43949 5.37177 1.71961 5.29812 2.00228 5.31229L2.98328 5.36254C3.17505 5.37266 3.36682 5.34239 3.54614 5.27367C3.72547 5.20496 3.88836 5.09933 4.02426 4.96364C4.16016 4.82796 4.26604 4.66523 4.33503 4.48601C4.40403 4.30679 4.43461 4.11508 4.42478 3.92329L4.37228 2.94229C4.35693 2.65917 4.42974 2.37826 4.58067 2.13824C4.73161 1.89822 4.95324 1.7109 5.21506 1.60207C5.47688 1.49325 5.766 1.46828 6.0426 1.53059C6.3192 1.59291 6.56967 1.73945 6.75953 1.95004L7.41803 2.67904C7.54645 2.82167 7.70341 2.93571 7.87874 3.01377C8.05407 3.09184 8.24386 3.13218 8.43578 3.13218C8.6277 3.13218 8.81748 3.09184 8.99281 3.01377C9.16814 2.93571 9.32511 2.82167 9.45353 2.67904L10.112 1.95004C10.3022 1.7404 10.5525 1.59472 10.8287 1.53295C11.1049 1.47119 11.3935 1.49637 11.6548 1.60504",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.7002 7.98073L7.58495 10.494C7.68654 10.6294 7.81737 10.7401 7.96769 10.8179C8.11801 10.8957 8.28394 10.9385 8.45313 10.9433C8.62232 10.948 8.7904 10.9146 8.94486 10.8453C9.09931 10.7761 9.23616 10.6729 9.3452 10.5435L17.4362 0.938232",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1939",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/customers-story-icon.js

var CustomersStoryIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1944)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.4375 11.8125H10.6875V15.1875L14.0625 11.8125H16.3125C16.6108 11.8125 16.897 11.694 17.108 11.483C17.319 11.2721 17.4375 10.9858 17.4375 10.6875V1.6875C17.4375 1.38914 17.319 1.10298 17.108 0.892005C16.897 0.681026 16.6108 0.5625 16.3125 0.5625H7.3125C7.01414 0.5625 6.72798 0.681026 6.517 0.892005C6.30603 1.10298 6.1875 1.38914 6.1875 1.6875",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.125 5.0625C1.125 5.65924 1.36205 6.23153 1.78401 6.65349C2.20597 7.07545 2.77826 7.3125 3.375 7.3125C3.97174 7.3125 4.54403 7.07545 4.96599 6.65349C5.38795 6.23153 5.625 5.65924 5.625 5.0625C5.625 4.46576 5.38795 3.89347 4.96599 3.47151C4.54403 3.04955 3.97174 2.8125 3.375 2.8125C2.77826 2.8125 2.20597 3.04955 1.78401 3.47151C1.36205 3.89347 1.125 4.46576 1.125 5.0625Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.7153 4.18188L11.5403 7.08738C11.4919 7.15179 11.4302 7.20507 11.3595 7.24359C11.2887 7.28212 11.2106 7.305 11.1302 7.3107C11.0498 7.31638 10.9692 7.30475 10.8937 7.27657C10.8182 7.24839 10.7497 7.20434 10.6927 7.14738L9.56775 6.02238M6.1875 12.9374V11.2499C6.1875 10.504 5.89118 9.78856 5.36374 9.26116C4.83629 8.73369 4.12092 8.43736 3.375 8.43736C2.62908 8.43736 1.91371 8.73369 1.38626 9.26116C0.858818 9.78856 0.5625 10.504 0.5625 11.2499V12.9374H1.6875L2.25 17.4374H4.5L5.0625 12.9374H6.1875Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1944",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/whats-new-icon.js

var WhatsNewIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_562_1921)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.25 11.8125V6.1875L4.5 11.8125V6.1875",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 11.8125H7.875C7.57663 11.8125 7.29048 11.694 7.0795 11.483C6.86853 11.272 6.75 10.9859 6.75 10.6875V7.3125C6.75 7.01413 6.86853 6.72798 7.0795 6.517C7.29048 6.30603 7.57663 6.1875 7.875 6.1875H9",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.75 9.5625H9",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.25 6.1875V7.70025C11.2498 8.5589 11.4137 9.40967 11.733 10.2068L12.375 11.8125L13.5 7.875L14.625 11.8125L15.267 10.2068C15.586 9.40957 15.7499 8.55887 15.75 7.70025V6.1875",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.4375 14.0625V16.3125C17.4375 16.6109 17.319 16.897 17.108 17.108C16.897 17.319 16.6109 17.4375 16.3125 17.4375H1.6875C1.38913 17.4375 1.10298 17.319 0.892005 17.108C0.681026 16.897 0.5625 16.6109 0.5625 16.3125V14.0625",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.5625 3.9375V1.6875C0.5625 1.38913 0.681026 1.10298 0.892005 0.892005C1.10298 0.681026 1.38913 0.5625 1.6875 0.5625H16.3125C16.6109 0.5625 16.897 0.681026 17.108 0.892005C17.319 1.10298 17.4375 1.38913 17.4375 1.6875V3.9375",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_562_1921",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/help-center-icon.js

var HelpCenterIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_595_3565)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.3125 11.8125V14.0625",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.6875 14.0625V6.1875C1.6875 5.88914 1.80603 5.60298 2.01701 5.39201C2.22798 5.18103 2.51414 5.0625 2.8125 5.0625H5.625",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.938 14.0625C10.7428 14.4042 10.4607 14.6882 10.1204 14.8857C9.78 15.0833 9.39352 15.1873 9 15.1873C8.60648 15.1873 8.22 15.0833 7.87965 14.8857C7.5393 14.6882 7.25721 14.4042 7.062 14.0625H0.5625V15.1875C0.5625 15.7842 0.799553 16.3565 1.22151 16.7785C1.64347 17.2004 2.21576 17.4375 2.8125 17.4375H15.1875C15.7842 17.4375 16.3565 17.2004 16.7785 16.7785C17.2004 16.3565 17.4375 15.7842 17.4375 15.1875V14.0625H10.938Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.0666 0.762293C13.184 0.498585 12.2441 0.495875 11.3602 0.754485C10.4762 1.0131 9.68596 1.52199 9.08476 2.21975C8.48356 2.91752 8.09716 3.77433 7.97206 4.68683C7.84704 5.59934 7.98871 6.52853 8.38006 7.36229L6.83203 10.5041L10.3743 9.53655C10.6868 9.71558 11.0186 9.85823 11.3636 9.9618C12.5764 10.2972 13.8725 10.1422 14.9721 9.53033C16.0718 8.91848 16.8867 7.89878 17.2412 6.69135C17.5955 5.4839 17.461 4.18551 16.8665 3.0764C16.272 1.96729 15.2653 1.1364 14.0636 0.763043L14.0666 0.762293Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.3281 4.24683C11.3281 3.96869 11.4106 3.69681 11.5651 3.46556C11.7196 3.2343 11.9393 3.05405 12.1962 2.94762C12.4532 2.84119 12.736 2.81333 13.0087 2.8676C13.2815 2.92186 13.5321 3.0558 13.7287 3.25246C13.9255 3.44913 14.0593 3.6997 14.1136 3.97248C14.1679 4.24526 14.14 4.52801 14.0336 4.78498C13.9272 5.04194 13.7469 5.26156 13.5157 5.41608C13.2844 5.5706 13.0125 5.65307 12.7344 5.65307",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.7344 7.90311C12.579 7.90311 12.4531 7.77719 12.4531 7.62186C12.4531 7.4665 12.579 7.34058 12.7344 7.34058",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.7344 7.90311C12.8897 7.90311 13.0156 7.77719 13.0156 7.62186C13.0156 7.4665 12.8897 7.34058 12.7344 7.34058",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_595_3565",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/partners-icon.js

var PartnersIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_595_3558)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.4375 16.875C6.34892 16.875 4.34588 16.0454 2.86904 14.5685C1.39219 13.0916 0.5625 11.0886 0.5625 9C0.5625 6.91142 1.39219 4.90838 2.86904 3.43153C4.34588 1.95469 6.34892 1.125 8.4375 1.125",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.4375 1.125C8.4375 1.125 4.5 3.375 4.5 9C4.5 14.625 8.4375 16.875 8.4375 16.875",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.43707 5.625H1.32031",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.43707 12.375H1.32031",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.8125 3.375C11.8125 3.97174 12.0496 4.54403 12.4715 4.96599C12.8935 5.38795 13.4658 5.625 14.0625 5.625C14.6592 5.625 15.2315 5.38795 15.6535 4.96599C16.0754 4.54403 16.3125 3.97174 16.3125 3.375C16.3125 2.77826 16.0754 2.20597 15.6535 1.78401C15.2315 1.36205 14.6592 1.125 14.0625 1.125C13.4658 1.125 12.8935 1.36205 12.4715 1.78401C12.0496 2.20597 11.8125 2.77826 11.8125 3.375Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.02 7.38452L14.0625 10.125L12.105 7.38452C11.6672 7.69516 11.3102 8.10594 11.0636 8.58271C10.817 9.05941 10.688 9.58824 10.6875 10.125V12.375C10.6875 12.6734 10.806 12.9596 11.017 13.1705C11.2279 13.3815 11.5142 13.5 11.8125 13.5H12.375V15.75C12.375 16.0484 12.4935 16.3346 12.7045 16.5455C12.9155 16.7565 13.2017 16.875 13.5 16.875H14.625C14.9233 16.875 15.2095 16.7565 15.4205 16.5455C15.6315 16.3346 15.75 16.0484 15.75 15.75V13.5H16.3125C16.6108 13.5 16.897 13.3815 17.108 13.1705C17.319 12.9596 17.4375 12.6734 17.4375 12.375V10.125C17.437 9.58824 17.308 9.05941 17.0614 8.58271C16.8149 8.10594 16.4578 7.69516 16.02 7.38452Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_595_3558",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/template-center-icon.js

var TemplateCenterIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_595_3582)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.25 1.1228H15.75C15.75 1.1228 16.875 1.1228 16.875 2.2478V15.7478C16.875 15.7478 16.875 16.8728 15.75 16.8728H2.25C2.25 16.8728 1.125 16.8728 1.125 15.7478V2.2478C1.125 2.2478 1.125 1.1228 2.25 1.1228Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.125 5.6228H16.875",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 16.8728V5.6228",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.125 11.2478H16.875",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_595_3582",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/icons/index.js











;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/consts.js


var LEARN_LINKS = [
    {
        Icon: AboutIcon,
        text: "header.tabs.resources.aboutUs",
        link: links/* ABOUT_US_PAGE_LINK */.iAZ
    },
    {
        Icon: WhatsNewIcon,
        text: "header.tabs.resources.whatsNew",
        link: links/* WHATS_NEW_PAGE_LINK */.Lmq
    },
    {
        Icon: BlogIcon,
        text: "header.tabs.resources.blog",
        link: links/* BLOG_PAGE_LINK */.xR0
    },
    {
        Icon: CertificationIcon,
        text: "header.tabs.resources.getCertified",
        link: links/* BUILDERS_CERTIFICATIONS_PAGE_LINK */.QHq
    },
    {
        Icon: CustomersStoryIcon,
        text: "header.tabs.resources.customerStories",
        link: links/* CUSTOMERS_PAGE_LINK */.iN6
    }
];
var SUPPORT_LINKS = [
    {
        Icon: HelpCenterIcon,
        text: "header.tabs.resources.helpCenter",
        link: links/* HELP_CENTER_LINK */.j3e
    },
    {
        Icon: SupportIcon,
        text: "header.tabs.resources.support",
        link: links/* SUPPORT_PAGE_LINK */.jX6
    },
    {
        Icon: PartnersIcon,
        text: "header.tabs.resources.partners",
        link: links/* PARTNERS_PAGE_LINK */.MW2
    }
];
var BUILD_LINKS = [
    {
        Icon: TemplateCenterIcon,
        text: "header.tabs.resources.templateCenter",
        link: links/* TEMPLATE_CENTER_PAGE_LINK */.EDy
    },
    {
        Icon: AppDevelopmentIcon,
        text: "header.tabs.resources.appDevelopment",
        link: links/* APPS_DEVELOPER_LINK */.FE7
    }
];

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/resources-menu-component/resources-menu-component.js
function resources_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function resources_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            resources_menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function resources_menu_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function resources_menu_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        resources_menu_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function resources_menu_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = resources_menu_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function resources_menu_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var ResourcesMenuComponent = function(param) {
    var translate = param.translate, menuId = param.menuId, onLinkClick = param.onLinkClick;
    var onLinkClickWithMenuId = function(event, link, text) {
        return onLinkClick({
            menuId: menuId,
            link: link,
            event: event,
            text: text
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledResourcesMenuComponent, {
        className: "menu-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("section", "learn-section"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("section-title", "align-to-link"),
                        children: translate("header.tabs.resources.title.learn")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "links",
                        children: LEARN_LINKS.map(function(_param, index) {
                            var text = _param.text, link = _param.link, company = resources_menu_component_object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ (0,react.createElement)(mini_link_item, resources_menu_component_object_spread_props(resources_menu_component_object_spread({
                                link: link,
                                onClick: function(event) {
                                    return onLinkClickWithMenuId(event, link, text);
                                },
                                text: translate(text)
                            }, company), {
                                key: index
                            }));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("section", "support-section"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("section-title", "align-to-link"),
                        children: translate("header.tabs.resources.title.support")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "links",
                        children: SUPPORT_LINKS.map(function(_param, index) {
                            var text = _param.text, link = _param.link, team = resources_menu_component_object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ (0,react.createElement)(mini_link_item, resources_menu_component_object_spread_props(resources_menu_component_object_spread({
                                link: link,
                                onClick: function(event) {
                                    return onLinkClickWithMenuId(event, link, text);
                                },
                                text: translate(text)
                            }, team), {
                                key: index
                            }));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("section", "build-section"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("section-title", "align-to-link"),
                        children: translate("header.tabs.resources.title.build")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "links",
                        children: BUILD_LINKS.map(function(_param, index) {
                            var text = _param.text, link = _param.link, industry = resources_menu_component_object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ (0,react.createElement)(mini_link_item, resources_menu_component_object_spread_props(resources_menu_component_object_spread({
                                link: link,
                                onClick: function(event) {
                                    return onLinkClickWithMenuId(event, link, text);
                                },
                                text: translate(text)
                            }, industry), {
                                key: index
                            }));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var resources_menu_component = (ResourcesMenuComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/index.js




;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/short-header-menu-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function short_header_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}











var short_header_menu_component_obj;
var ID_TO_MENU = (short_header_menu_component_obj = {}, (0,src_define_property/* default */.Z)(short_header_menu_component_obj, base_header_service/* RESOURCES_MENU_ID */.Gu, function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(resources_menu_component, short_header_menu_component_object_spread({
        menuId: base_header_service/* RESOURCES_MENU_ID */.Gu
    }, props));
}), (0,src_define_property/* default */.Z)(short_header_menu_component_obj, base_header_service/* SOLUTIONS_MENU_ID */.e1, function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(solutions_menu_component, short_header_menu_component_object_spread({
        menuId: base_header_service/* SOLUTIONS_MENU_ID */.e1
    }, props));
}), (0,src_define_property/* default */.Z)(short_header_menu_component_obj, base_header_service/* PRODUCTS_MENU_ID */.VG, function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(products_menu_component, short_header_menu_component_object_spread({
        menuId: base_header_service/* PRODUCTS_MENU_ID */.VG
    }, props));
}), short_header_menu_component_obj);
var ShortHeaderMenuComponent = function(param) {
    var translate = param.translate, menuId = param.menuId;
    var onLinkClick = function(param) {
        var menuId = param.menuId, text = param.text, event = param.event, link = param.link;
        var isKeyboardEvent = (event === null || event === void 0 ? void 0 : event.screenX) === 0 && (event === null || event === void 0 ? void 0 : event.screenY) === 0;
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
            click_text: translate(text),
            parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
            kind: link,
            info1: isKeyboardEvent ? "keyboard" : "mouse",
            info2: menuId
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShortHeaderMenuComponent, {
        className: "short-header-menu-component",
        children: [
            ID_TO_MENU[menuId]({
                translate: translate,
                onLinkClick: onLinkClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(action_bar, {
                translate: translate
            })
        ]
    });
};
/* harmony default export */ var short_header_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(ShortHeaderMenuComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/structured-header/structured-header.js
function structured_header_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function structured_header_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            structured_header_define_property(target, key, source[key]);
        });
    }
    return target;
}
function structured_header_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function structured_header_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        structured_header_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



























var StructuredHeader = function(props) {
    var showMenu = props.showMenu, showButton = props.showButton, buttonConfig = props.buttonConfig, hideLanguagePicker = props.hideLanguagePicker, shouldShowMainPricingLink = props.shouldShowMainPricingLink, isSecondaryMenuNeeded = props.isSecondaryMenuNeeded, renderUnifiedLinks = props.renderUnifiedLinks, hideLogin = props.hideLogin, abTests = props.abTests, openedMenuId = props.openedMenuId, openLinkMenu = props.openLinkMenu, closeLinkMenu = props.closeLinkMenu, simulateExistingAccountHeader = props.simulateExistingAccountHeader, isTypeformDisabled = props.isTypeformDisabled, translate = props.translate, persistantCookies = props.persistantCookies, pageProductId = props.pageProductId, showSuccessStoriesInHeader = props.showSuccessStoriesInHeader, shouldHaveEnhancedProducts = props.shouldHaveEnhancedProducts, setShowproductsSwithcer = props.setShowproductsSwithcer, showproductsSwithcer = props.showproductsSwithcer, isInContactSalesNoHeaderTest = props.isInContactSalesNoHeaderTest, isDynamicColor = props.isDynamicColor, isShortMenu = props.isShortMenu, removeContactSalesButton = props.removeContactSalesButton, simulateSwitcherForExistingUsers = props.simulateSwitcherForExistingUsers;
    var isInHeaderTest = isShortMenu || (0,acquisition_ab_test_service.shouldGetHeaderRevamp)(abTests, true);
    var openSolutionsMenu = function(menuKind) {
        return openLinkMenu(base_header_service/* SOLUTIONS_MENU_ID */.e1, menuKind);
    };
    var openTeamsMenu = function() {
        return openLinkMenu(base_header_service/* TEAMS_MENU_ID */.$Q);
    };
    var openPlatformMenu = function() {
        return openLinkMenu(base_header_service/* PLATFORM_MENU_ID */.wP);
    };
    var openCustomersMenu = function() {
        return openLinkMenu(base_header_service/* CUSTOMERS_MENU_ID */.xN);
    };
    var openResourcesMenu = function() {
        return openLinkMenu(base_header_service/* RESOURCES_MENU_ID */.Gu);
    };
    var openProductsMenu = function() {
        return openLinkMenu(base_header_service/* PRODUCTS_MENU_ID */.VG, "Products");
    };
    var isMenuOpen = function(menuId) {
        return openedMenuId === menuId;
    };
    var isExistingUser = simulateExistingAccountHeader || (0,existing_accounts_service/* isExistingUserInHeader */.xy)(persistantCookies);
    var isUserEligibleForSimulation = isExistingUser && simulateSwitcherForExistingUsers;
    var isStandaloneAndSwitcherTest = (0,existing_accounts_service/* isExistingUserSwithcerInHeaderTest */.dF)(persistantCookies, true);
    var shouldGetProductsSwitcherExperience = showMenu && (!isExistingUser || isUserEligibleForSimulation || isStandaloneAndSwitcherTest);
    var renderSubmenuWithTransitionIfNeeded = function(menuId) {
        // always render transition - menu rendered only if open
        var isMenuOpen = openedMenuId === menuId;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: isMenuOpen && renderMainHeaderPopup(menuId)
        });
    };
    var renderMainHeaderPopup = function(menuId) {
        var enhancedProducts = menuId === base_header_service/* SOLUTIONS_MENU_ID */.e1 && (shouldHaveEnhancedProducts || (0,acquisition_ab_test_service.shouldHaveEnhancedProductsInHeaderTest)(abTests, true));
        var headerMenuItems = base_header_service/* StructuredHeaderMenuMapping */.M2[menuId];
        var MenuComponent = header_menu[base_header_service/* StructuredHeaderMenuComponentMapping */.jm[menuId]];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()(base_header_constants/* default.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME */.Z.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME, {
                "enhanced-products": enhancedProducts
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                "aria-label": "main submenu",
                className: classnames_default()("menu-component-wrapper", {
                    "short-menu": isInHeaderTest
                }),
                children: isInHeaderTest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(short_header_menu_component, {
                    menuId: menuId
                }) : MenuComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuComponent, {
                    menuItems: headerMenuItems,
                    menuId: menuId,
                    enhancedProducts: enhancedProducts
                })
            })
        }, menuId);
    };
    var showSuccessStories = showSuccessStoriesInHeader || (0,acquisition_ab_test_service.shouldShowSuccessStoriesInHeaderTest)(abTests, true);
    var renderBaseHeaderLeftShortLinks = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* PRODUCTS_MENU_ID */.VG)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.products",
                        openMenu: openProductsMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* PRODUCTS_MENU_ID */.VG)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* PRODUCTS_MENU_ID */.VG),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* SOLUTIONS_MENU_ID */.e1)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "Solutions",
                        openMenu: function() {
                            return openSolutionsMenu("Solutions");
                        },
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* SOLUTIONS_MENU_ID */.e1)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* SOLUTIONS_MENU_ID */.e1),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* RESOURCES_MENU_ID */.Gu)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.resources",
                        openMenu: openResourcesMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* RESOURCES_MENU_ID */.Gu)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* RESOURCES_MENU_ID */.Gu)
            ]
        });
    };
    var renderBaseHeaderLeftLinks = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* SOLUTIONS_MENU_ID */.e1)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.products",
                        openMenu: openSolutionsMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* SOLUTIONS_MENU_ID */.e1)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* SOLUTIONS_MENU_ID */.e1),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* TEAMS_MENU_ID */.$Q)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.teams",
                        openMenu: openTeamsMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* TEAMS_MENU_ID */.$Q)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* TEAMS_MENU_ID */.$Q),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* PLATFORM_MENU_ID */.wP)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.platform",
                        openMenu: openPlatformMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* PLATFORM_MENU_ID */.wP)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* PLATFORM_MENU_ID */.wP),
                showSuccessStories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* CUSTOMERS_MENU_ID */.xN)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.successStories",
                        openMenu: openCustomersMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* CUSTOMERS_MENU_ID */.xN)
                    })
                }),
                showSuccessStories && renderSubmenuWithTransitionIfNeeded(base_header_service/* CUSTOMERS_MENU_ID */.xN),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* RESOURCES_MENU_ID */.Gu)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.resources",
                        openMenu: openResourcesMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* RESOURCES_MENU_ID */.Gu)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* RESOURCES_MENU_ID */.Gu)
            ]
        });
    };
    var fireEvent = function() {
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).SIGNUP_CLICKED, {
            click_text: translate("existingAccount.createAccountCta"),
            click_location: "header"
        });
    };
    var prominantContactSalesClicked = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_LINK_CLICKED, {
            info2: "header.contactSales"
        });
    };
    var buildHeaderStructure = function() {
        // init header according to its props
        var headerStructure = {
            leftLinks: {
                isVisible: showMenu
            },
            languagePicker: {
                isVisible: !showMenu && showButton && !hideLanguagePicker
            },
            pricing: {
                isVisible: showMenu && shouldShowMainPricingLink()
            },
            login: {
                isVisible: showMenu && !hideLogin
            },
            contactSales: {
                isVisible: showButton && (buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType) === button_consts/* SIGNUP_BUTTON_TYPE */.ge && !removeContactSalesButton && !isInContactSalesNoHeaderTest
            },
            button: {
                isVisible: showButton
            }
        };
        if ((buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType) === button_consts/* SIGNUP_BUTTON_TYPE */.ge && showButton && isExistingUser) {
            headerStructure.login.isVisible = false;
            headerStructure.button.extraProps = {
                forceGoToMyAccount: true
            };
        }
        return headerStructure;
    };
    var showSwitcher = function() {
        if (!showproductsSwithcer) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SWITCHER_OPENED);
        }
        setShowproductsSwithcer(!showproductsSwithcer);
    };
    var ref = buildHeaderStructure(), leftLinks = ref.leftLinks, languagePicker = ref.languagePicker, pricing = ref.pricing, contactSales = ref.contactSales, login = ref.login, button = ref.button;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStructuredHeader, {
        "aria-label": "Main",
        className: classnames_default()("base-header-desktop-content"),
        children: [
            leftLinks.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left-side-header-links",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute-main-links",
                        role: "list",
                        children: isInHeaderTest ? renderBaseHeaderLeftShortLinks() : renderBaseHeaderLeftLinks()
                    }),
                    isSecondaryMenuNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute-unified-links",
                        children: renderUnifiedLinks()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "right-side-header-links",
                role: "list",
                children: [
                    languagePicker.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("link-item-component-wrapper", "header-language-picker"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(language_picker_component/* default */.Z, {
                            dialogDirection: language_picker_service/* DIALOG_DIRECTIONS.ALIGN_BOTTOM */.Df.ALIGN_BOTTOM,
                            showLabel: false,
                            showMainLanguagesOnly: true
                        })
                    }),
                    pricing.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "link-item-component-wrapper",
                        role: "listitem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_component/* default */.Z, {
                            title: "header.pricing",
                            url: links/* PRICING_PAGE_LINK */.C9V
                        })
                    }),
                    login.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "link-item-component-wrapper",
                        role: "listitem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_component/* default */.Z, {
                            title: "header.logIn",
                            url: links/* LOGIN_PAGE_LINK */.dVh
                        })
                    })
                ]
            }),
            contactSales.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-prominant-contact-sales-button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                    buttonText: translate("header.contactSales"),
                    color: isDynamicColor ? color_consts.WHITE_COLOR_NAME : color_consts.WORK_OS_IRIS_COLOR_NAME,
                    outline: true,
                    url: links/* CONTACT_US_FROM_HEADER_PAGE_LINK */.lij,
                    isWithArrow: false,
                    buttonSize: sizes.SM,
                    onClick: prominantContactSalesClicked,
                    extraEventData: {
                        englishText: "Contact sales"
                    }
                })
            }),
            button.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, structured_header_object_spread(structured_header_object_spread_props(structured_header_object_spread({}, buttonConfig), {
                    parentSegment: base_header_constants/* default.DESKTOP_HEADER_SEGMENT_NAME */.Z.DESKTOP_HEADER_SEGMENT_NAME
                }), button.extraProps))
            }),
            shouldGetProductsSwitcherExperience && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("products-switcher-open-button", {
                    "show-switcher": showproductsSwithcer
                }),
                onClick: function() {
                    return showSwitcher();
                },
                onMouseEnter: function() {
                    return (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SWITCHER_LOGO_HOVERED);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: isDynamicColor && !showproductsSwithcer ? PRODUCTS_SWITCHER_LOGO_DARK : PRODUCTS_SWITCHER_LOGO
                })
            })
        ]
    });
};
/* harmony default export */ var structured_header = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(StructuredHeader)));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/base-header-desktop-component.js
function base_header_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_header_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_header_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}


















var BaseHeaderDesktopComponent = function(props) {
    var ref = (0,react.useState)(null), openedMenuId = ref[0], setOpenedMenuId = ref[1];
    var ref1 = (0,react.useState)(null), showproductsSwithcer = ref1[0], setShowproductsSwithcer = ref1[1];
    var ref2 = (0,react.useState)(props === null || props === void 0 ? void 0 : props.shouldUseDynamicColor), isDynamicColor = ref2[0], setIsDynamicColor = ref2[1];
    var _scrollInfo = {
        scrollTopWhenStartedScrollingUp: 0,
        prevScrollTop: 0,
        scrollingDown: true
    };
    var _basicHeader = (0,react.useRef)(null);
    var _headerRef = (0,react.useRef)(null);
    var isSecondaryMenuNeeded = props.isSecondaryMenuNeeded, buttonConfig = props.buttonConfig, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig, showMenu = props.showMenu, hideLogin = props.hideLogin, showButton = props.showButton, logoHref = props.logoHref, logoSrc = props.logoSrc, logoPopup = props.logoPopup, simulateExistingAccountHeader = props.simulateExistingAccountHeader, hideLanguagePicker = props.hideLanguagePicker, abTests = props.abTests, overrideClusterLogo = props.overrideClusterLogo, testTypeformContactSales = props.testTypeformContactSales, forceTypeformContactSalesExperience = props.forceTypeformContactSalesExperience, showSuccessStoriesInHeader = props.showSuccessStoriesInHeader, shouldHaveEnhancedProducts = props.shouldHaveEnhancedProducts, trackScroll = props.trackScroll, shouldUseDynamicColor = props.shouldUseDynamicColor, removeContactSalesButton = props.removeContactSalesButton, isShortMenu = props.isShortMenu;
    (0,react.useEffect)(function() {
        if (!openedMenuId) {
            removeClickOutsideEvent();
            return;
        }
        window.addEventListener("mousedown", handleClickOutsideMenu);
        return function() {
            removeClickOutsideEvent();
        };
    }, [
        openedMenuId
    ]);
    (0,react.useEffect)(function() {
        if (isSecondaryMenuNeeded) {
            window.addEventListener("scroll", scrollListenerForSecondaryMenuUnification, {
                passive: true
            });
            return function() {
                window.removeEventListener("scroll", scrollListenerForSecondaryMenuUnification);
                removeClickOutsideEvent();
            };
        }
    }, []);
    var removeClickOutsideEvent = function() {
        window.removeEventListener("mousedown", handleClickOutsideMenu);
    };
    var handleClickOutsideMenu = function(event) {
        if ((_headerRef === null || _headerRef === void 0 ? void 0 : _headerRef.current) && !_headerRef.current.contains(event.target)) {
            closeLinkMenu();
        }
    };
    var scrollListenerForSecondaryMenuUnification = function(event) {
        {
            var header = document.querySelector(".".concat(base_header_service/* DESKTOP_HEADER_BASE_CLASS_NAME */.Nl));
            if (!header) {
                return;
            }
            var scrolledUpEnough = false;
            if (document.scrollingElement.scrollTop > _scrollInfo.prevScrollTop) {
                // scrolling down
                _scrollInfo.scrollingDown = true;
            } else {
                // scrolling up
                if (_scrollInfo.scrollingDown) {
                    _scrollInfo.scrollTopWhenStartedScrollingUp = document.scrollingElement.scrollTop;
                }
                scrolledUpEnough = _scrollInfo.scrollTopWhenStartedScrollingUp - document.scrollingElement.scrollTop > base_header_constants/* default.SCROLL_BACK_UP_THRESHOLD */.Z.SCROLL_BACK_UP_THRESHOLD;
                _scrollInfo.scrollingDown = false;
            }
            _scrollInfo.prevScrollTop = document.scrollingElement.scrollTop;
            var showUnifiedBanner = document.scrollingElement.scrollTop > base_header_constants/* default.SCROLL_PIXEL_THRESHOLD */.Z.SCROLL_PIXEL_THRESHOLD && (_scrollInfo.scrollingDown || !scrolledUpEnough);
            if (document.scrollingElement.scrollTop > 0) {
                // shows the bottom menu border after scroll start
                header.classList.add("scroll-started");
            } else {
                header.classList.remove("scroll-started");
            }
            if (showUnifiedBanner) {
                header.classList.add("scrolled-threshold");
            } else {
                header.classList.remove("scrolled-threshold");
            }
        }
    };
    var openLinkMenu = function(menuId, menuKind) {
        var _basicHeader_current;
        setOpenedMenuId(menuId);
        var _MENU_ID_TO_EVENT_KIND_MAP_menuId;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_OPENED, {
            kind: menuKind || ((_MENU_ID_TO_EVENT_KIND_MAP_menuId = MENU_ID_TO_EVENT_KIND_MAP[menuId]) !== null && _MENU_ID_TO_EVENT_KIND_MAP_menuId !== void 0 ? _MENU_ID_TO_EVENT_KIND_MAP_menuId : menuId)
        });
        _basicHeader === null || _basicHeader === void 0 ? void 0 : (_basicHeader_current = _basicHeader.current) === null || _basicHeader_current === void 0 ? void 0 : _basicHeader_current.forceShadow();
    };
    var closeLinkMenu = function(e) {
        var _basicHeader_current;
        if (!openedMenuId) return;
        setOpenedMenuId(null);
        var _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_CLOSED, {
            kind: (_MENU_ID_TO_EVENT_KIND_MAP_openedMenuId = MENU_ID_TO_EVENT_KIND_MAP[openedMenuId]) !== null && _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId !== void 0 ? _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId : openedMenuId
        });
        _basicHeader === null || _basicHeader === void 0 ? void 0 : (_basicHeader_current = _basicHeader.current) === null || _basicHeader_current === void 0 ? void 0 : _basicHeader_current.unforceShadow();
    };
    var getButtonConfig = function() {
        var buttonType = buttonConfig.buttonType;
        var extraConfigs;
        switch(buttonType){
            case button_consts/* SIGNUP_BUTTON_TYPE */.ge:
                {
                    extraConfigs = {
                        buttonSize: "xs"
                    };
                    break;
                }
            default:
                {
                    extraConfigs = {};
                    break;
                }
        }
        return base_header_desktop_component_object_spread({}, buttonConfig, extraConfigs);
    };
    var getUnifiedDesktopLogoIfExists = function() {
        if (!isSecondaryMenuNeeded) return null;
        return (0,cluster_config_service/* getMiniSiteUnifiedDesktopLogo */.LN)(pageClusterConfig, {
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
    };
    var shouldShowMainPricingLink = function() {
        if (!isSecondaryMenuNeeded) return true;
        return !(0,cluster_config_service/* shouldHideGeneralPricingInMinisite */.Wi)(pageClusterConfig, {
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
    };
    var renderUnifiedLinks = function() {
        var links = (0,cluster_config_service/* getMiniSiteLinks */.J9)(pageClusterConfig, {
            onlyUnifiedLinks: true,
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        return links.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "link-item-component-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_component/* default */.Z, {
                    title: link === null || link === void 0 ? void 0 : link.text,
                    url: link === null || link === void 0 ? void 0 : link.url
                })
            }, link === null || link === void 0 ? void 0 : link.text);
        });
    };
    var renderBaseHeader = function() {
        var baseHeaderProps = {
            showMenu: showMenu,
            hideLogin: hideLogin,
            showButton: showButton,
            buttonConfig: getButtonConfig(),
            openedMenuId: openedMenuId,
            openLinkMenu: openLinkMenu,
            closeLinkMenu: closeLinkMenu,
            shouldShowMainPricingLink: shouldShowMainPricingLink,
            isSecondaryMenuNeeded: isSecondaryMenuNeeded,
            renderUnifiedLinks: renderUnifiedLinks,
            simulateExistingAccountHeader: simulateExistingAccountHeader,
            hideLanguagePicker: hideLanguagePicker,
            testTypeformContactSales: testTypeformContactSales,
            forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
            showSuccessStoriesInHeader: showSuccessStoriesInHeader,
            shouldHaveEnhancedProducts: shouldHaveEnhancedProducts,
            setShowproductsSwithcer: setShowproductsSwithcer,
            showproductsSwithcer: showproductsSwithcer,
            isDynamicColor: isDynamicColor,
            removeContactSalesButton: removeContactSalesButton,
            isShortMenu: isShortMenu
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(structured_header, base_header_desktop_component_object_spread({}, baseHeaderProps));
    };
    var getMainPageLogo = function() {
        if (pageClusterConfig && !isSecondaryMenuNeeded) {
            var clusterMainLogo = (0,cluster_config_service/* getClusterDesktopLogo */.k7)(pageClusterConfig, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
            if (clusterMainLogo) {
                return {
                    logoHref: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.url) || clusterMainLogo.url,
                    logoSrc: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.src) || clusterMainLogo.src,
                    logoAltText: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.alt) || clusterMainLogo.alt
                };
            }
        }
        return {
            logoHref: logoHref,
            logoSrc: logoSrc
        };
    };
    var unifiedDesktopLogo = getUnifiedDesktopLogoIfExists();
    var mainLogo = getMainPageLogo();
    var onDynamicColorChange = function(newIsDynamicColor) {
        setIsDynamicColor(newIsDynamicColor);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseHeaderDesktopComponent, {
        className: classnames_default()(base_header_service/* DESKTOP_HEADER_BASE_CLASS_NAME */.Nl),
        ref: _headerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_header_component/* default */.Z, {
                ref: _basicHeader,
                imageHref: mainLogo.logoHref,
                imageSrc: mainLogo.logoSrc,
                imageAlt: mainLogo.logoAltText,
                secondaryLogoObject: unifiedDesktopLogo,
                logoPopup: logoPopup,
                isMenuOpen: !!openedMenuId,
                trackScroll: trackScroll,
                shouldUseDynamicColor: shouldUseDynamicColor,
                onDynamicColorChange: onDynamicColorChange,
                children: renderBaseHeader()
            }),
            isSecondaryMenuNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "secondary-header-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_header_desktop_component, {})
            }),
            showproductsSwithcer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "products-switcher-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(products_switcher, {
                    setShowproductsSwithcer: setShowproductsSwithcer,
                    showproductsSwithcer: showproductsSwithcer
                })
            })
        ]
    });
};
BaseHeaderDesktopComponent.defaultProps = {
    showMenu: true,
    showButton: true
};
/* harmony default export */ var base_header_desktop_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(BaseHeaderDesktopComponent)));

// EXTERNAL MODULE: ./node_modules/@typeform/embed/build/css/popup.css
var popup = __webpack_require__(56051);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/download-mobile-app/download-mobile-app-component.js + 1 modules
var download_mobile_app_component = __webpack_require__(78407);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/link/link-component.js + 1 modules
var link_component = __webpack_require__(51467);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/constants.js
var header_menu_constants = __webpack_require__(3165);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/link-with-menu/link-with-menu-component.scss.js




var BORDER_BOTTOM = "1px solid ".concat(colors/* default.dark-marble */.Z["dark-marble"]);
var MENU_ITEM_TITLE_HEIGHT = "".concat(header_menu_constants/* default.MENU_ITEM_TITLE_HEIGHT */.Z.MENU_ITEM_TITLE_HEIGHT, "px");
var MENU_ITEM_LINK_HEIGHT = "".concat(header_menu_constants/* default.MENU_ITEM_LINK_HEIGHT */.Z.MENU_ITEM_LINK_HEIGHT, "px");
var SECTION_BORDER_BOTTOM = "1px solid ".concat(colors/* default.riverstone */.Z.riverstone);
var StyledLinkWithSectionsMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1t3h1kc0"
})("border-bottom:", BORDER_BOTTOM, ";overflow:hidden;transition:height 400ms ease;flex-shrink:0;&.is-open{.link-with-menu-title-wrapper{.link-with-menu-title-text{color:", colors/* default.iris */.Z.iris, ";}.link-with-menu-title-icon{transform:rotate(180deg);path{fill:", colors/* default.iris */.Z.iris, ";}}}}.link-with-menu-title-wrapper{display:flex;align-items:center;font-size:1.125rem;height:", MENU_ITEM_TITLE_HEIGHT, ";cursor:pointer;.link-with-menu-title-text{color:", colors/* default.text-gray */.Z["text-gray"], ";margin-right:8px;}.link-with-menu-title-icon{height:10px;width:10px;transition:transform 400ms ease;}}.link-with-menu-links-wrapper{display:flex;flex-direction:column;transition:height 400ms ease;.section-wrapper{margin:0 0 20px 12px;}.section-link{font-size:0.875rem;color:", colors/* default.asphalt */.Z.asphalt, ";font-weight:500;border-bottom:", SECTION_BORDER_BOTTOM, ";padding:16px 0;}.header-link{height:", MENU_ITEM_LINK_HEIGHT, ";display:flex;align-items:center;font-size:0.875rem;color:", colors/* default.tuna */.Z.tuna, ";text-decoration:none;.new-badge-component-wrapper{margin-left:8px;}.mobile-icon{margin-right:16px;}&.subsection-link{height:48px;color:", colors/* default.asphalt */.Z.asphalt, ";display:flex;}.beta-tag{font-size:0.6875rem;font-weight:400;color:", colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_BACKGROUND_PINK], ";border-radius:12px;padding:1px 5px;line-height:normal;border-radius:32px;margin-left:8px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/link-with-menu/link-with-sections-menu-component.js










var LinkWithSectionsMenuComponent = function(props) {
    var menuEl = (0,react.useRef)(null);
    var isOpen = props.isOpen, title = props.title, translate = props.translate, id = props.id, openLinksMenu = props.openLinksMenu, links = props.links;
    var openMenu = function() {
        var menuId = isOpen ? null : id;
        openLinksMenu(menuId);
    };
    var getStyle = function() {
        var _menuEl_current;
        // Don't break if menuEl is not yet set or clientHeight is not available for some reason
        // in such case, set height to auto (will disable animation tho)
        var collapseHeight = (menuEl === null || menuEl === void 0 ? void 0 : (_menuEl_current = menuEl.current) === null || _menuEl_current === void 0 ? void 0 : _menuEl_current.clientHeight) || "auto";
        return isOpen ? {
            height: collapseHeight
        } : {
            overflow: "hidden",
            height: 0
        };
    };
    var renderSection = function(param) {
        var section = param.section, sectionIndex = param.sectionIndex;
        var mobileTitle = section.mobileTitle, title = section.title, menuSectionItems = section.menuSectionItems, hideOnMobile = section.hideOnMobile;
        var onLinkClick = function(e, link) {
            (0,accessibility_service/* preventFocusOnMouseDown */.$R)(e);
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
                click_text: translate(link === null || link === void 0 ? void 0 : link.title),
                parent_category: link === null || link === void 0 ? void 0 : link.itemType
            });
        };
        return !hideOnMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "section-wrapper",
            children: [
                (mobileTitle || title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "section-link",
                    children: translate(mobileTitle || title)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: menuSectionItems.map(function(link, linkIndex) {
                        var linkTitle = link.title, url = link.url, isPopular = link.isPopular, badgeText = link.badgeText, badgeColorName = link.badgeColorName, badgeTextColorName = link.badgeTextColorName, badgeStrokeColorName = link.badgeStrokeColorName, openInNewTab = link.openInNewTab, MobileIcon = link.mobileIcon, hasBetaTag = link.hasBetaTag;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "header-link subsection-link",
                            href: url,
                            onMouseDown: function(e) {
                                return onLinkClick(e, link);
                            },
                            target: openInNewTab ? "_blank" : "_self",
                            rel: "noreferrer",
                            children: [
                                MobileIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileIcon, {
                                    className: "mobile-icon"
                                }),
                                translate(linkTitle),
                                hasBetaTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "beta-tag",
                                    children: translate("header.tabs.solutions.byProduct.dev.beta")
                                }),
                                isPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "new-badge-component-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_component/* default */.Z, {
                                        badgeText: translate(badgeText),
                                        badgeColorName: badgeColorName,
                                        badgeTextColorName: badgeTextColorName,
                                        badgeStrokeColorName: badgeStrokeColorName
                                    })
                                })
                            ]
                        }, "link_".concat(linkIndex));
                    })
                })
            ]
        }, "section_".concat(sectionIndex));
    };
    var onKeyDown = (0,react.useCallback)((0,accessibility_service/* generateOnKeyDownHandler */.vR)(openMenu), [
        isOpen,
        id
    ]);
    var style = (0,react.useMemo)(function() {
        return getStyle();
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLinkWithSectionsMenuComponent, {
        className: classnames_default()("link-with-menu-mobile-component", {
            "is-open": isOpen
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "link-with-menu-title-wrapper",
                tabIndex: 0,
                onClick: openMenu,
                onKeyDown: onKeyDown,
                onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                "aria-label": translate(title),
                role: "button",
                "aria-haspopup": "menu",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "link-with-menu-title-text",
                        children: translate(title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {
                        className: "link-with-menu-title-icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("link-with-menu-links-wrapper"),
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: menuEl,
                    children: links.map(function(section, sectionIndex) {
                        return renderSection({
                            section: section,
                            sectionIndex: sectionIndex
                        });
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var link_with_sections_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(LinkWithSectionsMenuComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/header-menu-component.scss.js


var StyledHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bfiei10"
})("height:100%;width:100%;background-color:", colors/* default.white */.Z.white, ";user-select:none;display:flex;flex-direction:column;padding-bottom:80px;padding:0px 32px 80px;overflow:auto;.download-mobile-app-component-wrapper{margin-top:32px;}.monday-link-wrapper{display:flex;gap:10px;flex-direction:row;align-items:center;justify-content:center;margin-top:28px;.picture-component{img{max-height:20px;vertical-align:bottom;}}.monday-link-text-wrapper{justify-content:center;vertical-align:middle;.secondary-button{line-height:24px;a{&.with-underline{background:none;}}}}}");

// EXTERNAL MODULE: ./client/services/hooks/use-contact-cales-typeform.js
var use_contact_cales_typeform = __webpack_require__(48109);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/header-menu-component.js

















var HeaderMenuComponent = function(props) {
    var ref = (0,react.useState)(null), openedMenuId = ref[0], setOpenedMenuId = ref[1];
    var isMinisitePage = props.isMinisitePage, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig, abTests = props.abTests, translate = props.translate, isTypeformDisabled = props.isTypeformDisabled;
    var SMALL_MONDAY_LOGO = "https://dapulse-res.cloudinary.com/image/upload/mobile_menu/Monday.png";
    var openLinksMenu = function(menuId) {
        setOpenedMenuId(menuId);
    };
    var getPricingPageLink = function() {
        var minisitePricingPageLink = null;
        if (isMinisitePage) {
            minisitePricingPageLink = (0,cluster_config_service/* getMiniSitePricingPageLink */.DJ)(pageClusterConfig, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        return minisitePricingPageLink || links/* PRICING_PAGE_LINK */.C9V;
    };
    var onMainLinkClick = function(title) {
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
            click_text: translate(title)
        });
    };
    var displayTypeform = (0,use_contact_cales_typeform/* useContactSalesTypeform */.O)({
        abTests: abTests,
        fallbackLink: links/* CONTACT_US_FROM_HEADER_PAGE_LINK */.lij
    }).displayTypeform;
    var onContactSalesClicked = (0,react.useCallback)(function() {
        !isTypeformDisabled && displayTypeform();
    }, [
        displayTypeform,
        isTypeformDisabled
    ]);
    var renderContactSalesMobileButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_component/* default */.Z, {
            title: "header.contactSales",
            onClickFunc: onContactSalesClicked,
            url: isTypeformDisabled ? links/* CONTACT_US_FROM_HEADER_PAGE_LINK */.lij : null
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderMenuComponent, {
        className: "header-menu-mobile-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_with_sections_menu_component, {
                id: base_header_service/* PRODUCTS_MENU_ID */.VG,
                title: "header.products",
                links: base_header_service/* mobileProductsSectionMenuItems */.VK,
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === base_header_service/* PRODUCTS_MENU_ID */.VG
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_with_sections_menu_component, {
                id: base_header_service/* USE_CASES_MENU_ID */.sI,
                title: "header.teams",
                links: base_header_service/* SectionsHeadersMenuItemsMapping */.tS[base_header_service/* USE_CASES_MENU_ID */.sI],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === base_header_service/* USE_CASES_MENU_ID */.sI
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_with_sections_menu_component, {
                id: base_header_service/* FEATURES_MENU_ID */.Qc,
                title: "header.features",
                links: base_header_service/* SectionsHeadersMenuItemsMapping */.tS[base_header_service/* FEATURES_MENU_ID */.Qc],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === base_header_service/* FEATURES_MENU_ID */.Qc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_with_sections_menu_component, {
                id: base_header_service/* RESOURCES_MENU_ID */.Gu,
                title: "header.resources",
                links: base_header_service/* SectionsHeadersMenuItemsMapping */.tS[base_header_service/* RESOURCES_MENU_ID */.Gu],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === base_header_service/* RESOURCES_MENU_ID */.Gu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_component/* default */.Z, {
                title: "header.pricing",
                url: getPricingPageLink(),
                onClickFunc: function() {
                    return onMainLinkClick("header.pricing");
                }
            }),
            renderContactSalesMobileButton(),
            !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)(link_component/* default */.Z, {
                title: "header.logIn",
                url: links/* LOGIN_PAGE_LINK */.dVh,
                onClickFunc: function() {
                    return onMainLinkClick("header.logIn");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "download-mobile-app-component-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(download_mobile_app_component/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "monday-link-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: SMALL_MONDAY_LOGO
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "monday-link-text-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, {
                            buttonText: translate("header.menuItem.backToHomePage"),
                            url: links/* ROOT_LINK */.yjY,
                            onClick: function() {
                                return onMainLinkClick("logo");
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var header_menu_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(HeaderMenuComponent)));

// EXTERNAL MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.js + 1 modules
var hamburger_menu_component = __webpack_require__(73418);
// EXTERNAL MODULE: ./segments/desktop/core-components/banner/banner.js + 2 modules
var banner = __webpack_require__(15814);
// EXTERNAL MODULE: ./constants/header-popup.js
var header_popup = __webpack_require__(61167);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/base-header-mobile-component.scss.js





var base_header_mobile_component_scss_BASIC_HEADER_HEIGHT = "".concat(constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT, "px");
var HEADER_MENU_HEIGHT = "calc(100% - ".concat(constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT - 1, "px)");
var HEADER_MENU_TRANSITION = "opacity ".concat(base_header_constants/* default.HEADER_MENU_TRANSITION_DURATION */.Z.HEADER_MENU_TRANSITION_DURATION, "ms ease, visibility ").concat(base_header_constants/* default.HEADER_MENU_TRANSITION_DURATION */.Z.HEADER_MENU_TRANSITION_DURATION, "ms ease;");
var BASE_HEADER_HEIGHT_WITH_SECONDARY = "".concat(constants/* default.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT + constants/* default.MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT, "px");
var MOBILE_MINISITE_HEADER_MENU_HEIGHT = "calc(100% - ".concat(constants/* default.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT - 1, "px)");
var MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT = "".concat(constants/* default.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, "px");
var StyledBaseHeaderMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", {
    target: "e16c8k6m0"
})("width:100%;height:", base_header_mobile_component_scss_BASIC_HEADER_HEIGHT, ";&.secondary-header{height:", BASE_HEADER_HEIGHT_WITH_SECONDARY, ";}&.with-cluster-logo:not(.secondary-header){height:", MOBILE_MINISITE_HEADER_MENU_HEIGHT, ";}&.with-cluster-logo{.header-menu-component-wrapper{top:", constants/* default.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT - 1, "px;height:", MOBILE_MINISITE_HEADER_MENU_HEIGHT, ";}.mobile-basic-header{height:", MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, ";.basic-header-content-wrapper{height:", MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, ";img{height:", MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, ";}.basic-header-content{height:", MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, ";justify-content:space-between;padding-left:24px;padding-right:24px;.main-logo-wrapper{height:100%;a{height:100%;display:flex;.picture-component{display:flex;align-items:center;.base-header-monday-logo-image{max-width:calc(100% - 32px);height:unset;max-height:60px;margin-right:0;}}}}}}}.mobile-menu-right-section{flex-grow:0;.mobile-header-content{.hamburger-menu{margin:0;}}}}&.sticky-signup{.basic-header-component{.basic-header-content-wrapper{.basic-header-content{padding:0 16px;@media (max-width:", vp_sizes/* MOBILE_SMALL_PHONE_MAX_WIDTH */.W8, "){padding:0 12px;.mobile-header-content{.hamburger-menu{width:22px;}}}.mobile-menu-right-section{.sticky-signup-wrapper{@media (max-width:", vp_sizes/* SMALL_MOBILE_QUERY_INCLUDED_MAX_WIDTH */.JI, "){display:none;}.regular-button{.button-component{padding:8px 12px 9.5px 12px;font-size:0.8125rem;font-weight:300;}}}.mobile-header-content{.hamburger-menu{margin-left:16px;margin-right:0;}}}}}}}.mobile-menu-right-section{flex-grow:1;display:flex;justify-content:flex-end;.mobile-header-content{.hamburger-menu{span{height:2px !important;}}}}.header-menu-component-wrapper{position:fixed;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";top:", constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT - 1 + "px", ";opacity:0;height:", HEADER_MENU_HEIGHT, ";width:100%;visibility:hidden;transition:", HEADER_MENU_TRANSITION, ";&.is-open{opacity:1;visibility:visible;}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){max-width:100vw;}}");

// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-header-mobile/secondary-header-mobile-component.scss.js



var OPACITY_WIDTH = "48px";
var SECONDARY_HEIGHT = "".concat(constants/* default.MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT, "px");
var StyledSecondaryHeaderMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", {
    target: "ekpqxv50"
})("height:", SECONDARY_HEIGHT, ";width:100%;outline:solid 1px;outline-color:", colors/* default.border-gray */.Z["border-gray"], ';position:fixed;background-color:#fff;z-index:555;box-shadow:0px 4px 40px rgba(0,0,0,0.08);&.scroll-end{&::after{opacity:0;}}&::after{content:"";position:absolute;right:0;top:0;height:100%;width:', OPACITY_WIDTH, ";background:linear-gradient(90deg,rgba(255,255,255,0) -140%,#ffffff 180%);opacity:1;pointer-events:none;}.links-wrapper{display:flex;overflow:scroll;height:100%;&::-webkit-scrollbar{display:none;}.secondary-link-item-wrapper{white-space:nowrap;display:flex;&:first-child{padding-left:8px;}&:last-child{.secondary-link-item-component{margin-right:24px;}}.secondary-link-item-component{padding-left:8px;padding-right:8px;margin:0 8px;font-size:0.8125rem;&:hover{color:", colors/* default.asphalt */.Z.asphalt, ";}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-header-mobile/secondary-header-mobile-component.js










var SCROLL_TRESHOLD = 10;
var INITIAL_SCROLL_FOR_OUTER_VIEWPORT_LINK = 64;
var SecondaryHeaderMobileComponent = function(props) {
    var ref = (0,react.useState)(false), isScrollEnded = ref[0], setIsScrollEnded = ref[1];
    var selectedLinkRef = (0,react.useRef)(null);
    var linksWrapperRef = (0,react.useRef)(null);
    var pageClusterConfig = props.pageClusterConfig, router = props.router, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var ref1 = (0,react.useState)(null), linksWrapperScrollWidth = ref1[0], setLinksWrapperScrollWidth = ref1[1];
    var ref2 = (0,react.useState)(null), linksWrapperOffsetWidth = ref2[0], setLinksWrapperOffsetWidth = ref2[1];
    (0,react.useEffect)(function() {
        if (selectedLinkRef === null || selectedLinkRef === void 0 ? void 0 : selectedLinkRef.current) {
            (0,dom_utils_service.isNodeFullyInView)(selectedLinkRef === null || selectedLinkRef === void 0 ? void 0 : selectedLinkRef.current).then(function(inView) {
                if (!inView) {
                    selectedLinkRef.current.scrollIntoView(true);
                    linksWrapperRef.current.scrollLeft += INITIAL_SCROLL_FOR_OUTER_VIEWPORT_LINK;
                }
            });
        }
        linksWrapperRef.current.addEventListener("scroll", scrollListenerForSecondaryMenuRemoveFade, {
            passive: true
        });
    }, []);
    (0,react.useEffect)(function() {
        var _linksWrapperRef_current, _linksWrapperRef_current1;
        setLinksWrapperScrollWidth((_linksWrapperRef_current = linksWrapperRef.current) === null || _linksWrapperRef_current === void 0 ? void 0 : _linksWrapperRef_current.scrollWidth);
        setLinksWrapperOffsetWidth((_linksWrapperRef_current1 = linksWrapperRef.current) === null || _linksWrapperRef_current1 === void 0 ? void 0 : _linksWrapperRef_current1.offsetWidth);
    }, [
        linksWrapperRef
    ]);
    var scrollListenerForSecondaryMenuRemoveFade = function() {
        var scrollLeft = linksWrapperRef.current.scrollLeft;
        if (scrollLeft + SCROLL_TRESHOLD >= linksWrapperScrollWidth - linksWrapperOffsetWidth) {
            setIsScrollEnded(true);
        } else if (isScrollEnded) {
            setIsScrollEnded(false);
        }
    };
    var scrollToLinkItemOnClick = function(e) {
        e.target.scrollIntoView(true);
    };
    var renderLinks = function() {
        var links = (0,cluster_config_service/* getMiniSiteLinks */.J9)(pageClusterConfig, {
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        return links.map(function(link, index) {
            var isSelected = (0,url.isSameUrlWithoutQueryParams)(link === null || link === void 0 ? void 0 : link.url, router === null || router === void 0 ? void 0 : router.asPath);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "secondary-link-item-wrapper",
                ref: isSelected ? selectedLinkRef : null,
                onClick: scrollToLinkItemOnClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_link_item_component, {
                    url: link === null || link === void 0 ? void 0 : link.url,
                    title: link === null || link === void 0 ? void 0 : link.text,
                    isSelected: isSelected
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryHeaderMobileComponent, {
        "aria-label": "Secondary",
        className: classnames_default()("secondary-header-mobile-component", {
            "scroll-end": isScrollEnded
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "links-wrapper",
            ref: linksWrapperRef,
            children: renderLinks()
        })
    });
};
/* harmony default export */ var secondary_header_mobile_component = ((0,router.withRouter)((0,generic_config_context/* withGenericConfig */.P)(SecondaryHeaderMobileComponent)));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/base-header-mobile-component.js





function base_header_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




















var SCROLL_MODE_THRESHOLD = 2; // The amount of pixels from the top that will trigger the scrolled mode of the navbar
var MONDAY_WHITE_LOGO = "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/img/monday_logo_white.png";
var BaseHeaderMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseHeaderMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseHeaderMobileComponent);
    function BaseHeaderMobileComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BaseHeaderMobileComponent);
        var _this;
        _this = _super.call(this, props);
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "isScrolled", function() {
            var _window, _document_documentElement, _document;
            return (((_window = window) === null || _window === void 0 ? void 0 : _window.pageYOffset) || ((_document = document) === null || _document === void 0 ? void 0 : (_document_documentElement = _document.documentElement) === null || _document_documentElement === void 0 ? void 0 : _document_documentElement.scrollTop)) >= SCROLL_MODE_THRESHOLD;
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "scrollListener", function(event) {
            var isScrolled = _this.state.isScrolled;
            var isInScrollMode = _this.isScrolled();
            if (isInScrollMode !== isScrolled) {
                _this.setState({
                    isScrolled: isInScrollMode
                });
            }
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldDisplayClusterizedLogo", function() {
            var _props = _this.props, pageClusterConfig = _props.pageClusterConfig, isSecondaryMenuNeeded = _props.isSecondaryMenuNeeded, pageClusterId = _props.pageClusterId, pageSubClusterId = _props.pageSubClusterId, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
            if (pageClusterConfig && (isSecondaryMenuNeeded || pageClusterId || pageSubClusterId)) {
                return !!(0,cluster_config_service/* getMiniSiteLogo */.o8)(pageClusterConfig, {
                    useProductMiniSiteConfig: useProductMiniSiteConfig
                });
            }
            return false;
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getMondayLogo", function() {
            var _props = _this.props, pageClusterConfig = _props.pageClusterConfig, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
            var _props1 = _this.props, logoHref = _props1.logoHref, logoSrc = _props1.logoSrc;
            if (_this.shouldDisplayClusterizedLogo()) {
                var _pageClusterConfig_mini_site_logo, _pageClusterConfig_mini_site;
                var useDesktopLogoInMobile = (pageClusterConfig === null || pageClusterConfig === void 0 ? void 0 : (_pageClusterConfig_mini_site = pageClusterConfig.mini_site) === null || _pageClusterConfig_mini_site === void 0 ? void 0 : (_pageClusterConfig_mini_site_logo = _pageClusterConfig_mini_site.logo) === null || _pageClusterConfig_mini_site_logo === void 0 ? void 0 : _pageClusterConfig_mini_site_logo.useDesktopLogoInMobile) === "true";
                return useDesktopLogoInMobile ? (0,cluster_config_service/* getClusterDesktopLogo */.k7)(pageClusterConfig, {
                    useProductMiniSiteConfig: useProductMiniSiteConfig
                }) : (0,cluster_config_service/* getMiniSiteLogo */.o8)(pageClusterConfig, {
                    useProductMiniSiteConfig: useProductMiniSiteConfig
                });
            }
            return {
                src: logoSrc,
                url: logoHref
            };
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "enterMobileMenuAbTest", function() {
            // leaving for future menu ab tests
            var abTests = _this.props.abTests;
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "toogleOpenMenu", function(isMenuOpen) {
            if (isMenuOpen) {
                var _document;
                _this._basicHeader.forceShadow();
                _this.enterMobileMenuAbTest();
                // Remove focus when opening the menu
                // Should close all native autocompletes
                if ((_document = document) === null || _document === void 0 ? void 0 : _document.activeElement) {
                    document.activeElement.blur();
                }
            } else {
                // Close all tabs in link menus in case the menu will be closed
                setTimeout(function() {
                    var _this__headerMenu;
                    return (_this__headerMenu = _this._headerMenu) === null || _this__headerMenu === void 0 ? void 0 : _this__headerMenu.openLinksMenu(null);
                }, base_header_constants/* default.HEADER_MENU_TRANSITION_DURATION */.Z.HEADER_MENU_TRANSITION_DURATION);
                _this._basicHeader.unforceShadow();
            }
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
                click_text: "logo"
            });
            _this.setState({
                isMenuOpen: isMenuOpen
            });
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLogoPopupIfNeeded", function() {
            var _props = _this.props, translate = _props.translate, logoPopup = _props.logoPopup, localeId = _props.localeId;
            var popupData = header_popup/* HEADER_POPUP_DATA */.Yq[logoPopup];
            if (!popupData) return null;
            var key = popupData.mobileTextKey || popupData.textKey;
            var imageSource = popupData.mobileImageSrc || popupData.gifSrc;
            var bannerText = translate(key).replace("<br>", " "); // desktop popup text can have specific breaks
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                withSignupButton: false,
                bannerText: bannerText,
                bannerLinkData: {
                    text: translate(popupData.ctaKey),
                    src: popupData.getLink(localeId)
                },
                theme: popupData.bannerTheme,
                bannerleftImage: imageSource
            });
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderSignup", function() {
            var translate = _this.props.translate;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sticky-signup-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                    buttonText: translate("signup.cta"),
                    url: links/* NEW_SOFT_SIGNUP_LINK */.SXZ,
                    color: color_consts.WORK_OS_IRIS_COLOR_NAME
                })
            });
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldShowStickySignup", function() {
            var _props = _this.props, abTests = _props.abTests, mobileStickySignup = _props.mobileStickySignup;
            if (_this.shouldDisplayClusterizedLogo()) return false;
            if (mobileStickySignup) return true;
            return (0,acquisition_ab_test_service.shouldGetMobileStickySignupAbTest)(abTests, true);
        });
        _this.state = {
            isMenuOpen: false,
            isScrolled: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseHeaderMobileComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("scroll", this.scrollListener);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("scroll", this.scrollListener);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, showMenu = _props.showMenu, isSecondaryMenuNeeded = _props.isSecondaryMenuNeeded, translate = _props.translate, shouldUseDynamicColor = _props.shouldUseDynamicColor;
                var isMenuOpen = this.state.isMenuOpen;
                var logo = this.getMondayLogo();
                var displayClusterLogo = this.shouldDisplayClusterizedLogo();
                var renderStickySignup = this.shouldShowStickySignup();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseHeaderMobileComponent, {
                            className: classnames_default()("base-header-mobile-component", {
                                "secondary-header": isSecondaryMenuNeeded,
                                "with-cluster-logo": displayClusterLogo,
                                "sticky-signup": renderStickySignup
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_header_component/* default */.Z, {
                                    ref: function(element) {
                                        return _this._basicHeader = element;
                                    },
                                    showMenu: showMenu,
                                    imageHref: logo.url,
                                    imageSrc: logo.src,
                                    imageAlt: logo.alt,
                                    isMobile: true,
                                    isSecondaryMenuNeeded: isSecondaryMenuNeeded,
                                    className: "mobile-basic-header",
                                    isMenuOpen: isMenuOpen,
                                    shouldUseDynamicColor: shouldUseDynamicColor,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mobile-menu-right-section",
                                        children: [
                                            renderStickySignup && this.renderSignup(),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mobile-header-content",
                                                "aria-label": translate("header.mainMenu"),
                                                role: "navigation",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hamburger_menu_component/* default */.Z, {
                                                    changeStateCallback: this.toogleOpenMenu,
                                                    isOpen: isMenuOpen
                                                })
                                            })
                                        ]
                                    })
                                }),
                                isSecondaryMenuNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_header_mobile_component, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("header-menu-component-wrapper", {
                                        "is-open": isMenuOpen
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_component, {
                                        ref: function(element) {
                                            return _this._headerMenu = element;
                                        },
                                        isMinisitePage: isSecondaryMenuNeeded
                                    })
                                })
                            ]
                        }),
                        this.renderLogoPopupIfNeeded()
                    ]
                });
            }
        }
    ]);
    return BaseHeaderMobileComponent;
}(react.PureComponent);
/* harmony default export */ var base_header_mobile_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(BaseHeaderMobileComponent)));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/default-props.js
var default_props = __webpack_require__(32777);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js




function base_header_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_header_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_header_component_define_property(target, key, source[key]);
        });
    }
    return target;
}








var BaseHeaderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseHeaderComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseHeaderComponent);
    function BaseHeaderComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BaseHeaderComponent);
        var _this;
        _this = _super.call(this, props);
        var isSecondaryMenuNeeded = props.isSecondaryMenuNeeded;
        _this.isSecondaryMenuNeeded = isSecondaryMenuNeeded;
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseHeaderComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.trackIsMobileOrTablet();
            }
        },
        {
            key: "trackIsMobileOrTablet",
            value: function trackIsMobileOrTablet() {
                var mobileWrapper = document.querySelector(".mobile-wrapper");
                if (mobileWrapper) {
                    var isMobileWrapperRendered = mobileWrapper.offsetParent !== null;
                    if (isMobileWrapperRendered) BigBrain("track", bigbrain_event_types.MOBILE_OR_TABLE_VIEW, {
                        kind: location.pathname
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseHeaderComponent, {
                    className: "base-header-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desktop-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_desktop_component, base_header_component_object_spread({
                                isSecondaryMenuNeeded: this.isSecondaryMenuNeeded
                            }, this.props))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_mobile_component, base_header_component_object_spread({
                                isSecondaryMenuNeeded: this.isSecondaryMenuNeeded
                            }, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return BaseHeaderComponent;
}(react.PureComponent);
BaseHeaderComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var base_header_component = ((0,generic_config_context/* withGenericConfig */.P)(BaseHeaderComponent));


/***/ }),

/***/ 32777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75650);
/* harmony import */ var _constants_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27639);


/* harmony default export */ __webpack_exports__["Z"] = ({
    showMenu: true,
    hideLogin: false,
    showButton: true,
    hideLanguagePicker: false,
    logoHref: _constants_links__WEBPACK_IMPORTED_MODULE_1__/* .ROOT_LINK */ .yjY,
    logoSrc: _constants_links__WEBPACK_IMPORTED_MODULE_1__/* .MONDAY_LOGO_SRC */ .Onk,
    buttonConfig: {
        buttonType: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_0__/* .SIGNUP_BUTTON_TYPE */ .ge
    }
});


/***/ })

}]);